// src/StepQuestionnaire.js
import React, {useState, useEffect, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import './StepQuestionnaire.css';
import Chapter13PlanModal from '../components/Chapter13PlanModal';
import LoadingModal from '../components/LoadingModal';
import './login.css'
import './CreateFirm.css'
import VehicleInformation from './VehicleInformation';
import RealEstateInformation from './RealEstateInformation';
import UnsecuredDebtInformation from './UnsecuredDebtInformation'
import { computeBankruptcyConsultationResult } from '../consultation';
import stateFipsMap from '../json/state_fips_map';
const API_URL = process.env.REACT_APP_API_URL;
const BACKEND_API_URL = process.env.REACT_APP_BACKEND_URL;
const PARENT_ORIGIN = "https://cisowskilaw.com"
const PersonIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>

  <path fill-rule="evenodd" d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z" clip-rule="evenodd" />
</svg>

);
const BirthdayIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='1.5'>
      {/* Heroicons User Circle */}
  <path d="m15 1.784-.796.795a1.125 1.125 0 1 0 1.591 0L15 1.784ZM12 1.784l-.796.795a1.125 1.125 0 1 0 1.591 0L12 1.784ZM9 1.784l-.796.795a1.125 1.125 0 1 0 1.591 0L9 1.784ZM9.75 7.547c.498-.021.998-.035 1.5-.042V6.75a.75.75 0 0 1 1.5 0v.755c.502.007 1.002.021 1.5.042V6.75a.75.75 0 0 1 1.5 0v.88l.307.022c1.55.117 2.693 1.427 2.693 2.946v1.018a62.182 62.182 0 0 0-13.5 0v-1.018c0-1.519 1.143-2.829 2.693-2.946l.307-.022v-.88a.75.75 0 0 1 1.5 0v.797ZM12 12.75c-2.472 0-4.9.184-7.274.54-1.454.217-2.476 1.482-2.476 2.916v.384a4.104 4.104 0 0 1 2.585.364 2.605 2.605 0 0 0 2.33 0 4.104 4.104 0 0 1 3.67 0 2.605 2.605 0 0 0 2.33 0 4.104 4.104 0 0 1 3.67 0 2.605 2.605 0 0 0 2.33 0 4.104 4.104 0 0 1 2.585-.364v-.384c0-1.434-1.022-2.7-2.476-2.917A49.138 49.138 0 0 0 12 12.75ZM21.75 18.131a2.604 2.604 0 0 0-1.915.165 4.104 4.104 0 0 1-3.67 0 2.605 2.605 0 0 0-2.33 0 4.104 4.104 0 0 1-3.67 0 2.605 2.605 0 0 0-2.33 0 4.104 4.104 0 0 1-3.67 0 2.604 2.604 0 0 0-1.915-.165v2.494c0 1.035.84 1.875 1.875 1.875h15.75c1.035 0 1.875-.84 1.875-1.875v-2.494Z" />

    </svg>
  );
const BKIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 15 20" fill="currentColor">
<path d="M14.63 7L13 3h1V2H9V1H8v1H3v1h1L2.38 7H2v1h.15c.156.498.473.93.9 1.23a2.47 2.47 0 0 0 2.9 0A2.44 2.44 0 0 0 6.86 8H7V7h-.45L4.88 3H8v8H6l-.39.18-2 2.51.39.81h9l.39-.81-2-2.51L11 11H9V3h3.13l-1.67 4H10v1h.15a2.48 2.48 0 0 0 4.71 0H15V7h-.37zM5.22 8.51a1.52 1.52 0 0 1-.72.19 1.45 1.45 0 0 1-.71-.19A1.47 1.47 0 0 1 3.25 8h2.5a1.52 1.52 0 0 1-.53.51zM5.47 7h-2l1-2.4 1 2.4zm5.29 5L12 13.5H5L6.24 12h4.52zm1.78-7.38l1 2.4h-2l1-2.4zm.68 3.91a1.41 1.41 0 0 1-.72.19 1.35 1.35 0 0 1-.71-.19 1.55 1.55 0 0 1-.54-.53h2.5a1.37 1.37 0 0 1-.53.53z"/></svg>
);
const MaritalIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="currentColor">
    {/* Heroicons User Circle */}
    <path d="M3,14A9,9,0,1,0,14.822,5.46l1.019-1.585a1,1,0,0,0,.031-1.032l-.75-1.333A1,1,0,0,0,14.25,1H9.75a1,1,0,0,0-.872.51l-.75,1.333a1,1,0,0,0,.031,1.032L9.178,5.46A9.011,9.011,0,0,0,3,14Zm8.282-8.966L10.167,3.3l.168-.3h3.33l.168.3L12.718,5.034C12.468,5.011,12.23,5,12,5S11.532,5.011,11.282,5.034ZM12,7a7,7,0,1,1-7,7A7.022,7.022,0,0,1,12,7Z"/>
</svg>
);
const SpouseIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 18 30" fill="none" stroke="currentColor" stroke-width='2'>
    {/* Heroicons User Circle */}
  <path d="M5.25 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM2.25 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM18.75 7.5a.75.75 0 0 0-1.5 0v2.25H15a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0v-2.25H21a.75.75 0 0 0 0-1.5h-2.25V7.5Z" />
</svg>

);
const DependIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 36 60" fill="none" stroke="currentColor" stroke-width='2'>
    {/* Heroicons User Circle */}
    <path  d="M39.59,12.45A16,16,0,0,0,25.51.11C18.2-.82,10.36,4.25,8.44,12.33,7.81,14.15,8,18.55,8,24c0,13.23,7.18,24,16,24S40,37.23,40,24C40,15.6,40.13,14.84,39.59,12.45Zm-2,.08c-.78,1.37-1.58,2.66-2.4,3.91a11.91,11.91,0,0,0,0-8.9A14,14,0,0,1,37.55,12.53ZM24,28.63a42.35,42.35,0,0,1-7.58-7.33,11.8,11.8,0,0,0,4.65,2.33,3,3,0,0,0,5.86,0,11.8,11.8,0,0,0,4.65-2.33A42.34,42.34,0,0,1,24,28.63ZM24.26,2c1.77.13,3,4.59.38,4.59-1.16,0-1.41-1.67-.41-1.67a1,1,0,0,0,0-2c-3.69,0-3.39,5.67.41,5.67,2.46,0,4.55-2.43,3-5.9a10,10,0,0,1,1.33,18c.34-4.85-10.3-4.85-10,0C10.06,15.54,13.93,1.64,24.26,2Zm2.2,19.28a3,3,0,0,0-4.92,0C20,20.14,22.09,19,24,19S28,20.14,26.46,21.29ZM24,22a1,1,0,0,1,0,2A1,1,0,0,1,24,22ZM12.87,7.55a11.83,11.83,0,0,0,0,8.89c-.82-1.25-1.63-2.54-2.41-3.91A13.83,13.83,0,0,1,12.87,7.55ZM10,24c0-9.85,0-7.79,0-8.29,5.92,9.63,14.66,18.57,25.81,20.06C28.25,54.46,10,45.77,10,24Zm26.51,9.85a25.23,25.23,0,0,1-10.78-4A51.61,51.61,0,0,0,38,15.71C38.15,23.42,38.25,28.42,36.51,33.85Z"  stroke-width="2"/>
</svg>
);
const AddressIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>

  <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
</svg>

);
const ContactIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>
    {/* Heroicons User Circle */}
  <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
</svg>

);
const EmployedIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>
        {/* Heroicons User Circle */}
  <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z" />
</svg>
);
const PaidIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>
        {/* Heroicons User Circle */}
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg>
);
const MoneyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>
  <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z" />
</svg>

);
const HomeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>

  <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205 3 1m1.5.5-1.5-.5M6.75 7.364V3h-3v18m3-13.636 10.5-3.819" />
</svg>
);
const CarIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>

  <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" />
  <circle cx="7" cy="17" r="2" />
  <path d="M9 17h6" />
  <circle cx="17" cy="17" r="2" />
</svg>
);
const BankIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>

  <path stroke-linecap="round" stroke-linejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z" />
</svg>

);
const CalcIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>

  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V13.5Zm0 2.25h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V18Zm2.498-6.75h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V13.5Zm0 2.25h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V18Zm2.504-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5Zm0 2.25h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V18Zm2.498-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5ZM8.25 6h7.5v2.25h-7.5V6ZM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 0 0 2.25 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0 0 12 2.25Z" />
</svg>
);
const CalendarIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>
  <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
</svg>
);
const ClockIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg>
);
const ClipboarIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>
  <path stroke-linecap="round" stroke-linejoin="round" d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184" />
</svg>
);
const CoinIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>
  <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
</svg>
);
const CardIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>
  <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
</svg>
);
const StudentLoansIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>
  <path stroke-linecap="round" stroke-linejoin="round" d="M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5" />
</svg>
);
const MedicalIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>

  <path d="M10 10H6" />
  <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
  <path
    d="M19 18h2a1 1 0 0 0 1-1v-3.28a1 1 0 0 0-.684-.948l-1.923-.641a1 1 0 0 1-.578-.502l-1.539-3.076A1 1 0 0 0 16.382 8H14" />
  <path d="M8 8v4" />
  <path d="M9 18h6" />
  <circle cx="17" cy="18" r="2" />
  <circle cx="7" cy="18" r="2" />
</svg>
);
const LoanIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>

<path d="M480-40q-112 0-206-51T120-227v107H40v-240h240v80h-99q48 72 126.5 116T480-120q75 0 140.5-28.5t114-77 77-114T840-480h80q0 91-34.5 171T791-169 651-74.5 480-40m-36-160v-52q-47-11-76.5-40.5T324-370l66-26q12 41 37.5 61.5T486-314t56.5-15.5T566-378q0-29-24.5-47T454-466q-59-21-86.5-50T340-592q0-41 28.5-74.5T446-710v-50h70v50q36 3 65.5 29t40.5 61l-64 26q-8-23-26-38.5T482-648q-35 0-53.5 15T410-592t23 41 83 35q72 26 96 61t24 77q0 29-10 51t-26.5 37.5-38.5 25-47 14.5v50zM40-480q0-91 34.5-171T169-791t140-94.5T480-920q112 0 206 51t154 136v-107h80v240H680v-80h99q-48-72-126.5-116T480-840q-75 0-140.5 28.5t-114 77-77 114T120-480z"/>
</svg>
);

const ReceiptIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 30" fill="none" stroke="currentColor" stroke-width='2'>
  <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z" />
  <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
  <path d="M12 17.5v-11" />
</svg>

);
async function addressToCensusData({ street, city, state, zip }) {
  const res = await fetch(`${BACKEND_API_URL}/api/geocode-fips`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ street, city, state, zip })
  });
  const data = await res.json();
  //console.log(data)
  if (!res.ok) {
    throw new Error(data.error || `Lookup failed (${res.status})`);
  }
  return data;
}
const validateAddressFields = async (addressObj) => {
  
  try {
    //console.log(addressObj)
    const response = await fetch(`${BACKEND_API_URL}/validate-address-intake`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(addressObj)
    });
    if (!response.ok) {
      throw new Error(await response.text());
    }
    const validatedAddress = await response.json();

    return validatedAddress;
  } catch (error) {
    console.error('Address validation error:', error);
    alert('Address validation failed: ' + error.message);
    return false;
  }
};
async function emailIsTaken(email) {
  const res = await fetch(`${API_URL}/debtor-email-exists/?email=${encodeURIComponent(email)}`);
  if (!res.ok) throw new Error('Network error');
  const { exists } = await res.json();
  return exists;
}
const logData = async (data) => {
  // Collect some meta data (device info, screen dimensions, timestamp, etc.)
  const metaData = {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
    languages: navigator.languages,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,
    devicePixelRatio: window.devicePixelRatio,
    colorDepth: window.screen.colorDepth,
    hardwareConcurrency: navigator.hardwareConcurrency,
    deviceMemory: navigator.deviceMemory || "unknown",
    // Connection info may not be supported in all browsers
    connection: navigator.connection ? {
      effectiveType: navigator.connection.effectiveType,
      downlink: navigator.connection.downlink,
      rtt: navigator.connection.rtt,
    } : {},
    referrer: document.referrer,
    currentUrl: window.location.href,
    timestamp: new Date().toISOString(),
  };

  // Combine your data with the meta data
  const payload = {
    ...data,
    metaData,
  };

  try {
    const response = await fetch(`${BACKEND_API_URL}/log`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      console.error('Failed to log data:', await response.text());
    } else {
      console.log('Data logged successfully.');
    }
  } catch (error) {
    console.error('Error logging data:', error);
  }
};
// After your icon constants
  
// ----- Helper functions for steps -----
const getDependentSteps = (answers) => {
  const num = parseInt(answers.dependents, 10);
  let steps = [];
  if (!isNaN(num) && num > 0) {
    for (let i = 1; i <= num; i++) {
      steps.push(`dependentDetails_${i}`);
    }
  }
  return steps;
};
// Part 1: Personal Information steps.
const getPart1Steps = (answers) => {
    let steps = ["address","birthday"];
    if (answers.bankruptcyFiled === "yes") {
      steps.push("bankruptcyDetails");
    }
    steps.push("maritalStatus");
    if (answers.maritalStatus === "married") {
        steps.push("spouseBirthday");
        steps.push("spouseFiling");
    } else if (["separated", "divorced", "widowed"].includes(answers.maritalStatus)) {
      steps.push("statusDuration");
    }
    // Final common steps for Part 1:
    steps.push("dependents");
    // Then add one step per dependent:
    steps = steps.concat(getDependentSteps(answers));
    // Continue with the common fields:
    return steps;
  };
  // Validate that the value is a number (and optionally non-negative)
const isNumeric = (value) => {
    const num = Number(value);
    return !isNaN(num) && num >= 0;
  };
  
  // Check if a state is valid (either abbreviation or full name)
  const isValidState = (state) => {
    const validAbbr = new Set([
      "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
      "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
      "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
      "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
      "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY","DC"
    ]);
    const validNames = new Set([
      "ALABAMA", "ALASKA", "ARIZONA", "ARKANSAS", "CALIFORNIA", "COLORADO",
      "CONNECTICUT", "DELAWARE", "FLORIDA", "GEORGIA", "HAWAII", "IDAHO",
      "ILLINOIS", "INDIANA", "IOWA", "KANSAS", "KENTUCKY", "LOUISIANA", "MAINE",
      "MARYLAND", "MASSACHUSETTS", "MICHIGAN", "MINNESOTA", "MISSISSIPPI",
      "MISSOURI", "MONTANA", "NEBRASKA", "NEVADA", "NEW HAMPSHIRE", "NEW JERSEY",
      "NEW MEXICO", "NEW YORK", "NORTH CAROLINA", "NORTH DAKOTA", "OHIO", "OKLAHOMA",
      "OREGON", "PENNSYLVANIA", "RHODE ISLAND", "SOUTH CAROLINA", "SOUTH DAKOTA",
      "TENNESSEE", "TEXAS", "UTAH", "VERMONT", "VIRGINIA", "WASHINGTON",
      "WEST VIRGINIA", "WISCONSIN", "WYOMING","DISTRICT OF COLUMBIA"
    ]);
    const input = state.trim().toUpperCase();
    return validAbbr.has(input) || validNames.has(input);
  };
  
  // Auto-format phone numbers as (XXX) XXX-XXXX
  const formatPhoneNumber = (value) => {
    const cleaned = ('' + value).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{0,4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}${match[3] ? '-' + match[3] : ''}`;
    }
    return value;
  };
  const isValidPhone = (phone) => {
    // Remove non-digit characters and check length
    const cleaned = phone.replace(/\D/g, '');
    return cleaned.length === 10;
  };
  
  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  // Part 2: Employment & Income steps.
  const getPart2Steps = (answers) => {
    let steps = [];
    // Respondent Employment Section
    steps.push("employmentStatus");
    if (answers.employmentStatus === "yes") {   // Workplace, job title, job duration (dropdown; if "<1 yr", ask start date)
      steps.push("payType");        // How are you paid? (via binary buttons)
      if (answers.payType === "hourly") {
        steps.push("hourlyDetails");  // Hourly rate & hours worked
      } else if (answers.payType === "salary") {
        steps.push("salaryDetails");  // Yearly salary (with bonuses)
      } else if (answers.payType === "self-employed") {
        steps.push("netProfit");      // Average net profit
      }
      if (answers.payType !== "self-employed") {
        steps.push("deductions");       // Deductions (optional)
      }
      steps.push("secondJob");
      if (answers.secondJob === "yes") {
        steps.push("secondPayType");
        if (answers.secondPayType === "hourly") {
          steps.push("secondHourlyDetails");
        } else if (answers.secondPayType === "salary") {
          steps.push("secondSalaryDetails");
        } else if (answers.secondPayType === "self-employed") {
          steps.push("secondNetProfit");
        }
      }
      // Check if current job start date is less than 6 months old.
      if (isLessThan6Months(answers.startDate)) {
        steps.push("priorEmployment");
        if (answers.priorEmployment === "yes") {
          steps.push("priorJobInfo");
          steps.push("priorLeavingDate");
          steps.push("priorPayType");
          // Based on the prior pay type, add detail step:
          if (answers.priorPayType === "hourly") {
            steps.push("priorHourlyDetails");
          } else if (answers.priorPayType === "salary") {
            steps.push("priorSalaryDetails");
          } else if (answers.priorPayType === "self-employed") {
            steps.push("priorNetProfit");
          }
        }
      }
    }
    // Fixed income for respondent:
    steps.push("hasFixedIncome");
    if (answers.hasFixedIncome === "yes") {
      steps.push("fixedIncome");
      if (answers.fixedIncomeSources && answers.fixedIncomeSources.length > 0) {
        answers.fixedIncomeSources.forEach((source) => {
          if (source !== "None") {
            steps.push("fixedIncomeDetails_" + source);
          }
        });
      }
    }
    // Spouse Employment & Income (if married)
    if (answers.maritalStatus === "married") {
    steps.push("spouseEmploymentStatus");
    if (answers.spouseEmploymentStatus === "yes") {
        steps.push("spousePayType");
        if (answers.spousePayType === "hourly") {
        steps.push("spouseHourlyDetails");
        } else if (answers.spousePayType === "salary") {
        steps.push("spouseSalaryDetails");
        } else if (answers.spousePayType === "self-employed") {
        steps.push("spouseNetProfit");
        }
        if (answers.spousePayType !== "self-employed") {
        steps.push("spouseDeductions");
        }
        steps.push("spouseSecondJob");
        if (answers.spouseSecondJob === "yes") {
        steps.push("spouseSecondJobInfo");
        steps.push("spouseSecondPayType");
        if (answers.spouseSecondPayType === "hourly") {
            steps.push("spouseSecondHourlyDetails");
        } else if (answers.spouseSecondPayType === "salary") {
            steps.push("spouseSecondSalaryDetails");
        } else if (answers.spouseSecondPayType === "self-employed") {
            steps.push("spouseSecondNetProfit");
        }
        }
    }
      steps.push("spouseHasFixedIncome");
      if (answers.spouseHasFixedIncome === "yes") {
        steps.push("spouseFixedIncome");
        if (answers.spouseFixedIncomeSources && answers.spouseFixedIncomeSources.length > 0) {
          answers.spouseFixedIncomeSources.forEach((source) => {
            if (source !== "None") {
              steps.push("spouseFixedIncomeDetails_" + source);
            }
          });
        }
      }
    }
    return steps;
  };

  const getPart3Steps = (answers) => {
    let steps = [];
    // Respondent vehicle info
    steps.push("hasVehicle");
    if (answers.hasVehicle === "yes") {
      steps.push("vehicleInformation");
    }
    // Spouse vehicle info if married and spouse filing
    if (answers.maritalStatus === "married" && answers.spouseFiling === "yes") {
      steps.push("spouseHasVehicle");
      if (answers.spouseHasVehicle === "yes") {
        steps.push("spouseVehicleInformation");
      }
    }
    return steps;
  };
  const getPart4Steps = (answers) => {
    let steps = [];
    // Home ownership questions:
    steps.push("ownsHome");
    if (answers.ownsHome === "yes") {
      if (answers.maritalStatus === "married") {
        steps.push("homeOwnershipType");
      } else {
        steps.push("homeOwnershipDetail");
      }
      steps.push("homeValue");
      // Primary mortgage steps:
      steps.push("hasMortgage");
      if (answers.hasMortgage === "yes") {
        steps.push("mortgageCreditor");
        steps.push("mortgageBalancePayment");
        steps.push("mortgagePaymentStatus");
        if (answers.mortgagePaymentStatus === "no") {
          steps.push("mortgageMonthsBehind");
        }
        // Second mortgage steps:
        steps.push("hasSecondMortgage");
        if (answers.hasSecondMortgage === "yes") {
          steps.push("secondMortgageCreditor");
          steps.push("secondMortgageBalancePayment");
          steps.push("secondMortgagePaymentStatus");
          if (answers.secondMortgagePaymentStatus === "no") {
            steps.push("secondMortgageMonthsBehind");
          }
        }
      }
    }
    steps.push("hasOtherRealEstate");
    if (answers.hasOtherRealEstate === "yes") {
      steps.push("otherRealEstateInformation");
    }
    if (answers.maritalStatus === "married" && answers.spouseFiling === "yes") {
      steps.push("spouseHasOtherRealEstate");
      if (answers.spouseHasOtherRealEstate === "yes") {
        steps.push("spouseOtherRealEstateInformation");
      }
    }
    return steps;
  };
  const getPart5Steps = (answers) => {
    let steps = [];
    // Respondent unsecured debt:
   
    // Spouse unsecured debt (if spouse is filing)
    if (answers.maritalStatus === "married" && answers.spouseFiling === "yes") {
      steps.push("spouseCreditCardDebt");
      if (answers.spouseCreditCardDebt === "yes") steps.push("spouseCreditCardDebtDetails");
      steps.push("spousePersonalLoanDebt");
      if (answers.spousePersonalLoanDebt === "yes") steps.push("spousePersonalLoanDebtDetails");
      steps.push("spouseMedicalDebt");
      if (answers.spouseMedicalDebt === "yes") steps.push("spouseMedicalDebtDetails");
      steps.push("spouseStudentLoanDebt");
      if (answers.spouseStudentLoanDebt === "yes") steps.push("spouseStudentLoanDebtDetails");
      steps.push("spouseBackTaxes");
      if (answers.spouseBackTaxes === "yes") steps.push("spouseBackTaxesDetails");
      steps.push("spouseOtherDebt");
      if (answers.spouseOtherDebt === "yes") steps.push("spouseOtherDebtDetails");
    }else
    {
      steps.push("creditCardDebt");
      if (answers.creditCardDebt === "yes") steps.push("creditCardDebtDetails");
      steps.push("personalLoanDebt");
      if (answers.personalLoanDebt === "yes") steps.push("personalLoanDebtDetails");
      steps.push("medicalDebt");
      if (answers.medicalDebt === "yes") steps.push("medicalDebtDetails");
      steps.push("studentLoanDebt");
      if (answers.studentLoanDebt === "yes") steps.push("studentLoanDebtDetails");
      steps.push("backTaxes");
      if (answers.backTaxes === "yes") steps.push("backTaxesDetails");
      steps.push("otherDebt");
      if (answers.otherDebt === "yes") steps.push("otherDebtDetails");
    }
    return steps;
  };

// ----- PART 6: Expense Information Steps -----
const getPart6Steps = (answers) => {
    let steps = [];
    // 1. If respondent does NOT own their home:

    // 3. Child Support for respondent:
    steps.push("childSupport");
    if (answers.childSupport === "yes") {
      steps.push("childSupportAmount");
      steps.push("childSupportArrearage");
      if (answers.childSupportArrearage === "yes") {
        steps.push("childSupportArrearageAmount");
      }
    }
    // 4. Alimony for respondent:
    steps.push("alimony");
    if (answers.alimony === "yes") {
        steps.push("alimonyAmount");
    }
    // 5. Spouse expense information if spouse is filing:
    if (answers.maritalStatus === "married" && answers.spouseFiling === "yes") {
      steps.push("spouseChildSupport");
      if (answers.spouseChildSupport === "yes") {
        steps.push("spouseChildSupportAmount");
        steps.push("spouseChildSupportArrearage");
        if (answers.spouseChildSupportArrearage === "yes") {
          steps.push("spouseChildSupportArrearageAmount");
        }
      }
      steps.push("spouseAlimony");
      if (answers.spouseAlimony === "yes") {
        steps.push("spouseAlimonyAmount");
      }
    }
    return steps;
  };
  const getCombinedSteps = (answers) => {
    const part1 = getPart1Steps(answers);
    const part2 = getPart2Steps(answers);
    const part3 = getPart3Steps(answers);
    const part4 = getPart4Steps(answers);
    const part5 = getPart5Steps(answers);
    const part6 = getPart6Steps(answers);
    return [...part1, ...part2, ...part3, ...part4, ...part5, ...part6];
  };
  
  // ----- Helper: returns true if the given startDate is less than 6 months ago.
  const isLessThan6Months = (startDate) => {
    if (!startDate) return false;
    const start = new Date(startDate);
    const now = new Date();
    const sixMonthsInMs = 182 * 24 * 60 * 60 * 1000;
    return now - start < sixMonthsInMs;
  };
  
  // ----- Combined Initial State -----
  const initialCombinedState = {
    // Part 1: Personal Information
    firstName: "", middleName: "", lastName: "", dob: "",
    bankruptcyFiled: "", bankruptcyChapter: "", bankruptcyCaseNumber: "",bankruptcyYearsAgo: "",
    maritalStatus: "", yearsMarried: "", spouseFiling: "",
    spouseFirstName: "", spouseMiddleName: "", spouseLastName: "",
    spouseDOB: "", spouseBankruptcyFiled: "", spouseBankruptcyChapter: "",spouseBankruptcyCaseNumber: "", spouseBankruptcyYearsAgo: "",
    statusDuration: "", dependents: "", // user selects the number (as a string or number)
    dependentDetails: [], street: "", city: "", state: "", zip: "", county:"",
    phone: "", email: "", spousePhone: "", spouseEmail: "",
    // Part 2: Respondent Employment & Income
    employmentStatus: "", // "yes" or "no"
    workPlace: "", jobTitle: "", jobDuration: "", startDate: "",
    payType: "", hourlyRate: "", hoursWorked: "", yearlySalary: "", netProfit: "",
    deductions: [], // multiple selections
    secondJob: "", // "yes" or "no"
    secondWorkPlace: "", secondJobTitle: "", secondJobDuration: "", secondStartDate: "",
    secondPayType: "", secondHourlyRate: "", secondHoursWorked: "", secondYearlySalary: "", secondNetProfit: "",
    priorEmployment: "", priorWorkPlace: "", priorJobTitle: "", priorJobDuration: "", priorStartDate: "", priorLeavingDate: "",
    priorPayType: "",
    priorHourlyRate: "",
    priorHoursWorked: "",
    priorYearlySalary: "",
    priorNetProfit: "",
    fixedIncomeSources: [], // include "None" as an option
    fixedIncomeDetails: {},
    hasFixedIncome: "",
    // Part 2: Spouse Employment & Income (if married)
    spouseEmploymentStatus: "", // "yes" or "no"
    spouseWorkPlace: "", spouseJobTitle: "", spouseJobDuration: "", spouseStartDate: "",
    spousePayType: "", spouseHourlyRate: "", spouseHoursWorked: "", spouseYearlySalary: "", spouseNetProfit: "",
    spouseDeductions: [], // multiple selections
    spouseSecondJob: "", // "yes" or "no"
    spouseSecondWorkPlace: "", spouseSecondJobTitle: "", spouseSecondJobDuration: "", spouseSecondStartDate: "",
    spouseSecondPayType: "", spouseSecondHourlyRate: "", spouseSecondHoursWorked: "", spouseSecondYearlySalary: "", spouseSecondNetProfit: "",
    spouseFixedIncomeSources: [],
    spouseFixedIncomeDetails: {},
    spouseHasFixedIncome: "",
    spousePriorEmployment: "",
    spousePriorWorkPlace: "",
    spousePriorJobTitle: "",
    spousePriorJobDuration: "",
    spousePriorStartDate: "",
    spousePriorLeavingDate: "",
    spousePriorPayType: "",
    spousePriorHourlyRate: "",
    spousePriorHoursWorked: "",
    spousePriorYearlySalary: "",
    spousePriorNetProfit: "",

    //Part 3 vehicles
    // ...inside initialCombinedState:
    hasVehicle: "", // "yes" or "no" for respondent
    vehicles: [],   // an array to hold respondent vehicle info

    // For spouse (if married and spouse filing):
    spouseHasVehicle: "",
    spouseVehicles: [],

    //Part 4 real estate
    ownsHome: "",  // "yes" or "no"
    homeOwnershipType: "", // for married respondents
    homeOwnershipDetail: "", // for non-married respondents
    homePropertyType: "",
    homeValue:"",
    hasMortgage: "",
    mortgageCreditor: "",
    mortgageBalance: "",
    mortgageMonthlyPayment: "",
    mortgagePaymentStatus: "",
    mortgageMonthsBehind: "",

    hasSecondMortgage: "",       // "yes" or "no"
    secondMortgageCreditor: "",
    secondMortgageBalance: "",
    secondMortgageMonthlyPayment: "",
    secondMortgagePaymentStatus: "",  // "yes" if current, "no" if not
    secondMortgageMonthsBehind: "",

    // For additional real estate (Part 4):
    hasOtherRealEstate: "", 
    otherRealEstateProperties: [], // Array for additional real estate properties
    spouseHasOtherRealEstate: "",
    spouseOtherRealEstateProperties: [],

    // Part 5: Unsecured Debt Information for respondent:
    creditCardDebt: "",           // "yes" or "no"
    creditCardDebtDetails: [],    // array of objects, e.g. { creditor: "", balance: "" }
    
    personalLoanDebt: "",
    personalLoanDebtDetails: [],
    
    medicalDebt: "",
    medicalDebtDetails: [],
    
    studentLoanDebt: "",
    studentLoanDebtDetails: [],
    
    backTaxDebt: "",
    backTaxDebtDetails: [],       // array of objects, e.g. { taxType: "", year: "", state: "", amount: "" }
    
    otherDebt: "",
    otherDebtDetails: [],         // array of objects, e.g. { creditor: "", description: "", amount: "" }
    
    // For spouse unsecured debt (if married and spouse is filing):
    spouseCreditCardDebt: "",
    spouseCreditCardDebtDetails: [],
    
    spousePersonalLoanDebt: "",
    spousePersonalLoanDebtDetails: [],
    
    spouseMedicalDebt: "",
    spouseMedicalDebtDetails: [],
    
    spouseStudentLoanDebt: "",
    spouseStudentLoanDebtDetails: [],
    
    spouseBackTaxDebt: "",
    spouseBackTaxDebtDetails: [],
    
    spouseOtherDebt: "",
    spouseOtherDebtDetails: [],

    // Part 6: Expense Information (respondent)
    paysRent: "",              // "yes" or "no"
    rentAmount: "",            // numeric
    vehicleInsurance: "",      // numeric
    childSupport: "",          // "yes" or "no"
    childSupportAmount: "",    // numeric
    childSupportDeducted: "",  // "yes" or "no"
    childSupportArrearage: "", // "yes" or "no"
    childSupportArrearageAmount: "", // numeric
    alimony: "",               // "yes" or "no"
    alimonyAmount: "",

    // Part 6: Expense Information (spouse, if filing)
    spouseChildSupport: "",            // "yes" or "no"
    spouseChildSupportAmount: "",      // numeric
    spouseChildSupportDeducted: "",    // "yes" or "no"
    spouseChildSupportArrearage: "",   // "yes" or "no"
    spouseChildSupportArrearageAmount: "", // numeric
    spouseAlimony: "",     
    spouseAlimonyAmount: "",  
  };
  
  function Chapter13PlanCalculator({ onNext }) {
    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState(1);
    const [answers, setAnswers] = useState(initialCombinedState);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState(initialCombinedState);
    const [message, setMessage] = useState("");
    const [recResult, setRecResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showRec, setShowRec] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    useEffect(() => {
      fetch(`${API_URL}/chapter-13-step`)
        .then(res => {
          if (!res.ok) throw new Error(res.statusText);
          return res.json();
        })
        .then(data => {
          if (data.answers) {
            // merge saved values into your initial state
            setAnswers(prev => ({
              ...prev,
              ...data.answers
            }));
          }
        })
        .catch(err => console.error('Error loading saved answers:', err));
    }, []);
    const part1Steps = getPart1Steps(answers);
    const part2Steps = getPart2Steps(answers);
    const part3Steps = getPart3Steps(answers);
    const part4Steps = getPart4Steps(answers);
    const part5Steps = getPart5Steps(answers);
    const part6Steps = getPart6Steps(answers);
    const combinedSteps = [
        ...getPart1Steps(answers),
        ...getPart2Steps(answers),
        ...getPart3Steps(answers),
        ...getPart4Steps(answers),
        ...getPart5Steps(answers),
        ...getPart6Steps(answers),
      ];
//console.log("Combined Steps:", combinedSteps);

    const containerRef = useRef(null);
    useEffect(() => {
  
      // measure & post height
      function sendHeight() {
        if (!containerRef.current) return;
        const height = containerRef.current.scrollHeight;
        window.parent.postMessage(
          { type: 'resize-iframe', height },
          PARENT_ORIGIN
        );
      }
  
      // send on mount
      sendHeight();
  
      // watch for resize of the container
      const resizeObserver = new ResizeObserver(sendHeight);
      resizeObserver.observe(containerRef.current);
  
      // watch for DOM changes (e.g. modal opening)
      const mutationObserver = new MutationObserver(sendHeight);
      mutationObserver.observe(containerRef.current, {
        childList: true,
        subtree: true,
        attributes: true
      });
          // also on window resize just in case
      window.addEventListener('resize', sendHeight);

      return () => {
        resizeObserver.disconnect();
        mutationObserver.disconnect();
        window.removeEventListener('resize', sendHeight);
      };
    }, []);

    const totalSteps = combinedSteps.length;
    const currentStepKey = combinedSteps[currentStep - 1];
  
    // Determine current part indicator and step count.
    const part1Length = getPart1Steps(answers).length;
    const part2Length = getPart2Steps(answers).length;
    const part3Length = getPart3Steps(answers).length;
    const part4Length = getPart4Steps(answers).length;
    const part5Length = getPart5Steps(answers).length;
    const part6Length = getPart6Steps(answers).length;
    let currentPart = 1;
    if (currentStep > part1Length && currentStep <= part1Length + part2Length) {
      currentPart = 2;
    } else if (currentStep > part1Length + part2Length && currentStep <= part1Length + part2Length + part3Length) {
      currentPart = 3;
    } else if (currentStep > part1Length + part2Length + part3Length && currentStep <= part1Length + part2Length + part3Length + part4Length) {
      currentPart = 4;
    } else if (currentStep > part1Length + part2Length + part3Length + part4Length && currentStep <= part1Length + part2Length + part3Length + part4Length + part5Length) {
        currentPart = 5;
    } else if (currentStep > part1Length + part2Length + part3Length + part4Length + part5Length&& currentStep <= part1Length + part2Length + part3Length + part4Length + part5Length + part6Length) {
        currentPart = 6;
    } else {
        currentPart = 1;
    }
    let partIndicator = "";
    let partStep = currentStep;
    let partTotal = part1Length;
    let totalParts = 6;
    if (currentStep <= part1Length) {
        partIndicator = "Part 1: Personal Information";
        partStep = currentStep;
        partTotal = part1Length;
      } else if (currentStep <= part1Length + part2Length) {
        partIndicator = "Part 2: Income Information";
        partStep = currentStep - part1Length;
        partTotal = part2Length;
      } else if (currentStep <= part1Length + part2Length + part3Length) {
        partIndicator = "Part 3: Vehicle Information";
        partStep = currentStep - (part1Length + part2Length);
        partTotal = part3Length;
      } else if (currentStep <= part1Length + part2Length + part4Length + part3Length){
        partIndicator = "Part 4: Real Estate Information";
        partStep = currentStep - (part1Length + part2Length + part3Length);
        partTotal = part4Length;
      } else if (currentStep <= part1Length + part2Length + part4Length + part3Length + part5Length){
        partIndicator = "Part 5: Unsecured Debt Information";
        partStep = currentStep - (part1Length + part2Length + part3Length + part4Length);
        partTotal = part5Length;
      } else {
        partIndicator = "Part 6: Expense Information";
        partStep = currentStep - (part1Length + part2Length + part3Length + part4Length + part5Length);
        partTotal = part6Length;
      }
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        
        let newValue = value;

        // Auto-format phone numbers
        if (name === "phone" || name === "spousePhone") {
            newValue = formatPhoneNumber(value);
        }
        let updatedAnswers = { ...answers, [name]: newValue };
        // ----- PART 1: Personal Information Dependencies -----
        // Bankruptcy: If the user now says "no" to bankruptcy filed, clear bankruptcy details.
        if (name === "bankruptcyFiled" && value === "no") {
          updatedAnswers.bankruptcyChapter = "";
          updatedAnswers.bankruptcyYearsAgo = "";
        }
      
        // Marital Status: If not married, clear all spouse-related fields.
        if (name === "maritalStatus" && value !== "married") {
          updatedAnswers.spouseFiling = "";
          updatedAnswers.spouseFirstName = "";
          updatedAnswers.spouseMiddleName = "";
          updatedAnswers.spouseLastName = "";
          updatedAnswers.spouseDOB = "";
          updatedAnswers.spouseBankruptcyFiled = "";
          updatedAnswers.spouseBankruptcyChapter = "";
          updatedAnswers.spouseBankruptcyYearsAgo = "";
          // Also clear any spouse employment/income fields:
          updatedAnswers.spouseEmploymentStatus = "";
          updatedAnswers.spouseWorkPlace = "";
          updatedAnswers.spouseJobTitle = "";
          updatedAnswers.spouseJobDuration = "";
          updatedAnswers.spouseStartDate = "";
          updatedAnswers.spousePayType = "";
          updatedAnswers.spouseHourlyRate = "";
          updatedAnswers.spouseHoursWorked = "";
          updatedAnswers.spouseYearlySalary = "";
          updatedAnswers.spouseNetProfit = "";
          updatedAnswers.spouseDeductions = [];
          updatedAnswers.spouseSecondJob = "";
          updatedAnswers.spouseSecondWorkPlace = "";
          updatedAnswers.spouseSecondJobTitle = "";
          updatedAnswers.spouseSecondJobDuration = "";
          updatedAnswers.spouseSecondStartDate = "";
          updatedAnswers.spouseSecondPayType = "";
          updatedAnswers.spouseSecondHourlyRate = "";
          updatedAnswers.spouseSecondHoursWorked = "";
          updatedAnswers.spouseSecondYearlySalary = "";
          updatedAnswers.spouseSecondNetProfit = "";
          updatedAnswers.spouseHasFixedIncome = "";
          updatedAnswers.spouseFixedIncomeSources = [];
          updatedAnswers.spouseFixedIncomeDetails = {};
          // Also clear spouse prior employment:
          updatedAnswers.spousePriorEmployment = "";
          updatedAnswers.spousePriorWorkPlace = "";
          updatedAnswers.spousePriorJobTitle = "";
          updatedAnswers.spousePriorJobDuration = "";
          updatedAnswers.spousePriorStartDate = "";
          updatedAnswers.spousePriorLeavingDate = "";
        }
      
        // If spouseFiling is changed to "no", clear spouse details that are only needed if filing.
        if (name === "spouseFiling" && value === "no") {
          updatedAnswers.spouseFirstName = "";
          updatedAnswers.spouseMiddleName = "";
          updatedAnswers.spouseLastName = "";
          updatedAnswers.spouseDOB = "";
          updatedAnswers.spouseBankruptcyFiled = "";
          updatedAnswers.spouseBankruptcyChapter = "";
          updatedAnswers.spouseBankruptcyYearsAgo = "";
        }
      
        // ----- PART 2: Respondent Employment & Income Dependencies -----
        // Employment Status: If changed to "no", clear all respondent employment fields.
        if (name === "employmentStatus" && value === "no") {
          updatedAnswers.workPlace = "";
          updatedAnswers.jobTitle = "";
          updatedAnswers.jobDuration = "";
          updatedAnswers.startDate = "";
          updatedAnswers.payType = "";
          updatedAnswers.hourlyRate = "";
          updatedAnswers.hoursWorked = "";
          updatedAnswers.yearlySalary = "";
          updatedAnswers.netProfit = "";
          updatedAnswers.deductions = [];
          updatedAnswers.secondJob = "";
          updatedAnswers.secondWorkPlace = "";
          updatedAnswers.secondJobTitle = "";
          updatedAnswers.secondJobDuration = "";
          updatedAnswers.secondStartDate = "";
          updatedAnswers.secondPayType = "";
          updatedAnswers.secondHourlyRate = "";
          updatedAnswers.secondHoursWorked = "";
          updatedAnswers.secondYearlySalary = "";
          updatedAnswers.secondNetProfit = "";
          // Also clear prior employment fields.
          updatedAnswers.priorEmployment = "";
          updatedAnswers.priorWorkPlace = "";
          updatedAnswers.priorJobTitle = "";
          updatedAnswers.priorJobDuration = "";
          updatedAnswers.priorStartDate = "";
          updatedAnswers.priorLeavingDate = "";
        }
        // If jobDuration changes from "<1 yr" to another value, clear startDate and any prior employment fields.
        if (name === "jobDuration" && value !== "<1 yr") {
          updatedAnswers.startDate = "";
          updatedAnswers.priorEmployment = "";
          updatedAnswers.priorWorkPlace = "";
          updatedAnswers.priorJobTitle = "";
          updatedAnswers.priorJobDuration = "";
          updatedAnswers.priorStartDate = "";
          updatedAnswers.priorLeavingDate = "";
        }
        // When payType changes, clear the related detail fields.
        if (name === "payType") {
          if (value !== "hourly") {
            updatedAnswers.hourlyRate = "";
            updatedAnswers.hoursWorked = "";
          }
          if (value !== "salary") {
            updatedAnswers.yearlySalary = "";
          }
          if (value !== "self-employed") {
            updatedAnswers.netProfit = "";
          }
        }
        // If secondJob changes to "no", clear all second job fields.
        if (name === "secondJob" && value === "no") {
          updatedAnswers.secondWorkPlace = "";
          updatedAnswers.secondJobTitle = "";
          updatedAnswers.secondJobDuration = "";
          updatedAnswers.secondStartDate = "";
          updatedAnswers.secondPayType = "";
          updatedAnswers.secondHourlyRate = "";
          updatedAnswers.secondHoursWorked = "";
          updatedAnswers.secondYearlySalary = "";
          updatedAnswers.secondNetProfit = "";
        }
        // For second job duration, if not "<1 yr", clear secondStartDate.
        if (name === "secondJobDuration" && value !== "<1 yr") {
          updatedAnswers.secondStartDate = "";
        }
        // When secondPayType changes, clear the related second job detail fields.
        if (name === "secondPayType") {
          if (value !== "hourly") {
            updatedAnswers.secondHourlyRate = "";
            updatedAnswers.secondHoursWorked = "";
          }
          if (value !== "salary") {
            updatedAnswers.secondYearlySalary = "";
          }
          if (value !== "self-employed") {
            updatedAnswers.secondNetProfit = "";
          }
        }
        // If current job start date is updated and is now more than 6 months, clear prior employment fields.
        if (name === "startDate") {
          if (!isLessThan6Months(value)) {
            updatedAnswers.priorEmployment = "";
            updatedAnswers.priorWorkPlace = "";
            updatedAnswers.priorJobTitle = "";
            updatedAnswers.priorJobDuration = "";
            updatedAnswers.priorStartDate = "";
            updatedAnswers.priorLeavingDate = "";
          }
        }
      
        // Fixed income: if hasFixedIncome is set to "no", clear its related fields.
        if (name === "hasFixedIncome" && value === "no") {
          updatedAnswers.fixedIncomeSources = [];
          updatedAnswers.fixedIncomeDetails = {};
        }
        // ----- PART 2: Spouse Employment & Income Dependencies -----
        if (name === "spouseEmploymentStatus" && value === "no") {
          updatedAnswers.spouseWorkPlace = "";
          updatedAnswers.spouseJobTitle = "";
          updatedAnswers.spouseJobDuration = "";
          updatedAnswers.spouseStartDate = "";
          updatedAnswers.spousePayType = "";
          updatedAnswers.spouseHourlyRate = "";
          updatedAnswers.spouseHoursWorked = "";
          updatedAnswers.spouseYearlySalary = "";
          updatedAnswers.spouseNetProfit = "";
          updatedAnswers.spouseDeductions = [];
          updatedAnswers.spouseSecondJob = "";
          updatedAnswers.spouseSecondWorkPlace = "";
          updatedAnswers.spouseSecondJobTitle = "";
          updatedAnswers.spouseSecondJobDuration = "";
          updatedAnswers.spouseSecondStartDate = "";
          updatedAnswers.spouseSecondPayType = "";
          updatedAnswers.spouseSecondHourlyRate = "";
          updatedAnswers.spouseSecondHoursWorked = "";
          updatedAnswers.spouseSecondYearlySalary = "";
          updatedAnswers.spouseSecondNetProfit = "";
          // Also clear spouse prior employment if any.
          updatedAnswers.spousePriorEmployment = "";
          updatedAnswers.spousePriorWorkPlace = "";
          updatedAnswers.spousePriorJobTitle = "";
          updatedAnswers.spousePriorJobDuration = "";
          updatedAnswers.spousePriorStartDate = "";
          updatedAnswers.spousePriorLeavingDate = "";
        }
        if (name === "spouseJobDuration" && value !== "<1 yr") {
          updatedAnswers.spouseStartDate = "";
          updatedAnswers.spousePriorEmployment = "";
          updatedAnswers.spousePriorWorkPlace = "";
          updatedAnswers.spousePriorJobTitle = "";
          updatedAnswers.spousePriorJobDuration = "";
          updatedAnswers.spousePriorStartDate = "";
          updatedAnswers.spousePriorLeavingDate = "";
        }
        if (name === "spousePayType") {
          if (value !== "hourly") {
            updatedAnswers.spouseHourlyRate = "";
            updatedAnswers.spouseHoursWorked = "";
          }
          if (value !== "salary") {
            updatedAnswers.spouseYearlySalary = "";
          }
          if (value !== "self-employed") {
            updatedAnswers.spouseNetProfit = "";
          }
        }
        if (name === "spouseSecondJob" && value === "no") {
          updatedAnswers.spouseSecondWorkPlace = "";
          updatedAnswers.spouseSecondJobTitle = "";
          updatedAnswers.spouseSecondJobDuration = "";
          updatedAnswers.spouseSecondStartDate = "";
          updatedAnswers.spouseSecondPayType = "";
          updatedAnswers.spouseSecondHourlyRate = "";
          updatedAnswers.spouseSecondHoursWorked = "";
          updatedAnswers.spouseSecondYearlySalary = "";
          updatedAnswers.spouseSecondNetProfit = "";
        }
        if (name === "spouseSecondJobDuration" && value !== "<1 yr") {
          updatedAnswers.spouseSecondStartDate = "";
        }
        if (name === "spouseSecondPayType") {
          if (value !== "hourly") {
            updatedAnswers.spouseSecondHourlyRate = "";
            updatedAnswers.spouseSecondHoursWorked = "";
          }
          if (value !== "salary") {
            updatedAnswers.spouseSecondYearlySalary = "";
          }
          if (value !== "self-employed") {
            updatedAnswers.spouseSecondNetProfit = "";
          }
        }
        // If spouse's current job start date is updated and is now more than 6 months, clear spouse prior employment.
        if (name === "spouseStartDate") {
          if (!isLessThan6Months(value)) {
            updatedAnswers.spousePriorEmployment = "";
            updatedAnswers.spousePriorWorkPlace = "";
            updatedAnswers.spousePriorJobTitle = "";
            updatedAnswers.spousePriorJobDuration = "";
            updatedAnswers.spousePriorStartDate = "";
            updatedAnswers.spousePriorLeavingDate = "";
          }
        }
      
        // Also, if fixed income sources (or spouse's) controllers are changed elsewhere, you might need to clear related selections.
        // (Those are handled in toggleArrayValue for fixedIncomeSources and spouseFixedIncomeSources.)
      
        setAnswers(updatedAnswers);
      };
  
    const setBinary = (name, value) => {
      setAnswers({ ...answers, [name]: value });
    };
  
    const toggleArrayValue = (name, value) => {
      let arr = answers[name] || [];
      if (arr.includes(value)) {
        arr = arr.filter(item => item !== value);
      } else {
        // For fixed income sources, if "None" is selected, clear others.
        if (name === "fixedIncomeSources" && value === "None") {
          arr = ["None"];
        } else if (name === "fixedIncomeSources" && arr.includes("None")) {
          arr = arr.filter(item => item !== "None");
          arr.push(value);
        } else if (name === "spouseFixedIncomeSources" && value === "None") {
          arr = ["None"];
        } else if (name === "spouseFixedIncomeSources" && arr.includes("None")) {
          arr = arr.filter(item => item !== "None");
          arr.push(value);
        } else {
          arr.push(value);
        }
      }
      setAnswers({ ...answers, [name]: arr });
    };
  
    const nextStep = () => {
      const newStep = currentStep + 1;
      setCurrentStep(newStep);
      // tell the parent “we’ve moved forward”
      window.parent.postMessage(
        { type: "intake-next", step: newStep },
        PARENT_ORIGIN
      );
      const saveProgress = (step) => {

        fetch(`${API_URL}/chapter-13-step/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            answers,
            last_step_reached: step
          })
        }).catch(err => console.error('Error saving progress:', err));
      };
      saveProgress(newStep)
    };
  
    const previousStep = () => {
      const newStep = currentStep - 1;
      setCurrentStep(newStep);
      // tell the parent “we’ve moved backward”
      window.parent.postMessage(
        { type: "intake-next", step: newStep },
        PARENT_ORIGIN
      );
      const saveProgress = (step) => {
        fetch(`${API_URL}/chapter-13-step/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            answers,
            last_step_reached: step
          })
        }).catch(err => console.error('Error saving progress:', err));
      };
      saveProgress(newStep)
    };
    const handleSubmit = async (e) => {
      console.log("Submitting form data:", answers);
      setLoading(true);
      console.log("Form Data Submitted:\n", JSON.stringify(answers, null, 2));
      const result = await computeBankruptcyConsultationResult(answers);
      answers.consultationResult = result
      setRecResult(result);
      console.log(result)
      console.log("FINAL ANSWERS")
      console.log(answers)
      const saveProgress = (step) => {

        fetch(`${API_URL}/chapter-13-step/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            answers,
            last_step_reached: step
          })
        }).catch(err => console.error('Error saving progress:', err));
      };
      saveProgress("Submitted")
      e.preventDefault();
    };
    const onLoaderComplete = async () => {
      try {
        const result = await computeBankruptcyConsultationResult(answers);
        setRecResult(result);
      } catch(err) {
        console.error(err);
        // maybe show an error toast…
      } finally {
        setLoading(false);
        setShowRec(true);
      }
    };
  
    // ----- Validation -----
    const validateStep = async () => {
      switch (currentStepKey) {
        // Part 1 Validations (unchanged)
        case "priorPayType":
        if (!answers.priorPayType) {
            alert("Please select your prior employment pay type.");
            return false;
        }
        return true;
        case "priorHourlyDetails":
        if (!answers.priorHourlyRate || !answers.priorHoursWorked) {
            alert("Please enter your prior hourly rate and hours worked per week.");
            return false;
        }
        if (isNaN(answers.priorHourlyRate) || isNaN(answers.priorHoursWorked)) {
            alert("Prior hourly rate and hours worked must be numbers.");
            return false;
        }
        return true;
        case "priorSalaryDetails":
        if (!answers.priorYearlySalary) {
            alert("Please enter your prior yearly salary (including bonuses).");
            return false;
        }
        if (isNaN(answers.priorYearlySalary)) {
            alert("Prior yearly salary must be a number.");
            return false;
        }
        return true;
        case "priorNetProfit":
        if (!answers.priorNetProfit) {
            alert("Please enter your prior monthly net profit.");
            return false;
        }
        if (isNaN(answers.priorNetProfit)) {
            alert("Prior net profit must be a number.");
            return false;
        }
        return true;

        // Spouse validations:
        case "spousePriorPayType":
        if (!answers.spousePriorPayType) {
            alert("Please select your spouse's prior employment pay type.");
            return false;
        }
        return true;
        case "spousePriorHourlyDetails":
        if (!answers.spousePriorHourlyRate || !answers.spousePriorHoursWorked) {
            alert("Please enter your spouse's prior hourly rate and hours worked per week.");
            return false;
        }
        if (isNaN(answers.spousePriorHourlyRate) || isNaN(answers.spousePriorHoursWorked)) {
            alert("Your spouse's prior hourly rate and hours worked must be numbers.");
            return false;
        }
        return true;
        case "spousePriorSalaryDetails":
        if (!answers.spousePriorYearlySalary) {
            alert("Please enter your spouse's prior yearly salary (including bonuses).");
            return false;
        }
        if (isNaN(answers.spousePriorYearlySalary)) {
            alert("Your spouse's prior yearly salary must be a number.");
            return false;
        }
        return true;
        case "spousePriorNetProfit":
        if (!answers.spousePriorNetProfit) {
            alert("Please enter your spouse's prior monthly net profit.");
            return false;
        }
        if (isNaN(answers.spousePriorNetProfit)) {
            alert("Your spouse's prior net profit must be a number.");
            return false;
        }
        case "name":
          if (!answers.firstName || !answers.middleName || !answers.lastName) {
            alert("Please complete your first, middle, and last name.");
            return false;
          }
          return true;
        case "hasVehicle":
            if (!answers.hasVehicle) {
              alert("Please select whether or not you have a vehicle.");
              return false;
            }
            return true;
        case "spouseHasVehicle":
            if (!answers.spouseHasVehicle) {
                alert("Please select whether or not your spouse has a vehicle.");
                return false;
            }
            return true;
        case "birthday":
          if (!answers.dob) {
            alert("Please enter your birthday.");
            return false;
          }
          return true;
        case "bankruptcyHistory":
          if (!answers.bankruptcyFiled) {
            alert("Please select whether you have filed bankruptcy before.");
            return false;
          }
          return true;
        case "bankruptcyDetails":
          if (!answers.bankruptcyChapter || !answers.bankruptcyYearsAgo) {
            alert("Please select bankruptcy chapter and enter how many years ago.");
            return false;
          }
          if (isNaN(answers.bankruptcyYearsAgo)) {
            alert("Years ago must be a whole number.");
            return false;
          }
          return true;
        case "maritalStatus":
          if (!answers.maritalStatus) {
            alert("Please select your marital status.");
            return false;
          }
          return true;
        case "yearsMarried":
          if (!answers.yearsMarried) {
            alert("Please enter how long you have been married.");
            return false;
          }
          if (isNaN(answers.yearsMarried)) {
            alert("Years married must be a number.");
            return false;
          }
          return true;
        case "spouseFiling":
          if (!answers.spouseFiling) {
            alert("Please select whether your spouse is filing with you.");
            return false;
          }
          return true;
        case "spouseName":
          if (!answers.spouseFirstName || !answers.spouseMiddleName || !answers.spouseLastName) {
            alert("Please enter your spouse's first, middle, and last name.");
            return false;
          }
          return true;
        case "spouseBirthday":
          if (!answers.spouseDOB) {
            alert("Please enter your spouse's birthday.");
            return false;
          }
          return true;
        case "spouseBankruptcyHistory":
          if (!answers.spouseBankruptcyFiled) {
            alert("Please select whether your spouse has filed bankruptcy in the last 8 years.");
            return false;
          }
          return true;
        case "spouseBankruptcyDetails":
          if (!answers.spouseBankruptcyChapter || !answers.spouseBankruptcyYearsAgo) {
            alert("Please select your spouse's bankruptcy chapter and enter how many years ago.");
            return false;
          }
          if (isNaN(answers.spouseBankruptcyYearsAgo)) {
            alert("Spouse bankruptcy years ago must be a number.");
            return false;
          }
          return true;
        case "statusDuration":
          if (!answers.statusDuration) {
            alert("Please enter the duration for your marital status.");
            return false;
          }
          return true;
        case "dependents":
          if (!answers.dependents) {
            alert("Please select the number of dependents.");
            return false;
          }
          return true;
        case "address":
            // 1) Basic form validation
            if (!answers.zip) {
              alert("Please enter you zip");
              return false;
            }
            if (!/^\d{5}$/.test(answers.zip)) {
              alert("Zip code must be exactly 5 digits.");
              return false;
            }
          
            // 2) Call your USPS function
            const addressObj = {
              address1: answers.street,
              city:      answers.city,
              state:     answers.state,
              zip:       answers.zip
            };
            //const verified = await validateAddressFields(addressObj);
          
              try {
                const censusData = await addressToCensusData({
                  street: "123 Main St",
                  city:   "Piney Flats",
                  state:  "TN",
                  zip:    answers.zip
                });
                const stateFips = String(censusData.tracts.features[0].attributes.STATE).padStart(2, '0');
                const stateAbbrev = stateFipsMap[stateFips] || '';
                answers.state = stateAbbrev;
                console.log(answers.state)
            
                // censusData.geocode    → full geocoder JSON
                // censusData.match      → the first match object
                // censusData.tracts     → full TigerWeb response
            
                // Example: grab the tract GEOID
                answers.censusTract = censusData.tracts.features[0].attributes;
                console.log(answers.censusTract)
                // You can also stash the rest:
                answers.censusGeocode = censusData.geocode;
                console.log(answers.censusGeocode)
                answers.censusMatch   = censusData.match;
                console.log(answers.censusMatch)
              } catch (err) {
                console.error("Census lookup failed:", err);
                // decide: block the user or just warn and continue
              }
              return true;
              case "contact":
                // Validate primary contact
                if (!answers.phone || !answers.email) {
                  alert("Please enter your contact info.");
                  return false;
                }
                if (!isValidPhone(answers.phone)) {
                  alert("Your phone number must be exactly 10 digits.");
                  return false;
                }
                if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(answers.email)) {
                  alert("Please enter a valid email address.");
                  return false;
                }
                try {
                  if (await emailIsTaken(answers.email)) {
                    alert('That email is already associated with another case. Enter a different email or login to your case');
                    return false;
                  }
                } catch (_) {
                  alert("Could not verify email uniqueness. Try Again")
                  return false;
                }
                console.log(answers)
                // If spouse is filing, validate spouse contact too
                if (answers.spouseFiling === 'yes') {
                  if (!answers.spousePhone || !answers.spouseEmail) {
                    alert("Please enter your spouse's contact info.");
                    return false;
                  }
                  if (!isValidPhone(answers.spousePhone)) {
                    alert("Your spouse's phone number must be exactly 10 digits.");
                    return false;
                  }
                  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(answers.spouseEmail)) {
                    alert("Please enter a valid email address for your spouse.");
                    return false;
                  }
                }
              
                return true;
  
        // Part 2: Respondent Employment & Income Validations
        case "employmentStatus":
          if (!answers.employmentStatus) {
            alert("Please indicate if you are employed.");
            return false;
          }
          return true;
        case "jobInfo":
          if (!answers.workPlace || !answers.jobTitle || !answers.jobDuration) {
            alert("Please complete your job information (workplace, job title, and duration).");
            return false;
          }
          if (answers.jobDuration === "<1 yr" && !answers.startDate) {
            alert("Please enter your start date for your current job.");
            return false;
          }
          return true;
        case "payType":
          if (!answers.payType) {
            alert("Please select how you are paid.");
            return false;
          }
          return true;
        case "hourlyDetails":
          if (!answers.hourlyRate || !answers.hoursWorked) {
            alert("Please enter your hourly rate and hours worked.");
            return false;
          }
          if (isNaN(answers.hourlyRate) || isNaN(answers.hoursWorked)) {
            alert("Hourly rate and hours worked must be numbers.");
            return false;
          }
          return true;
        case "salaryDetails":
          if (!answers.yearlySalary) {
            alert("Please enter your yearly salary.");
            return false;
          }
          if (isNaN(answers.yearlySalary)) {
            alert("Yearly salary must be a number.");
            return false;
          }
          return true;
        case "netProfit":
          if (!answers.netProfit) {
            alert("Please enter your average monthly net profit.");
            return false;
          }
          if (isNaN(answers.netProfit)) {
            alert("Net profit must be a number.");
            return false;
          }
          return true;
        case "deductions":
          // Optional – no validation required.
          return true;
        case "secondJob":
          if (!answers.secondJob) {
            alert("Please indicate whether you have a second job or side-hustle.");
            return false;
          }
          return true;
        case "secondJobInfo":
          if (!answers.secondWorkPlace || !answers.secondJobTitle || !answers.secondJobDuration) {
            alert("Please complete your second job information.");
            return false;
          }
          if (answers.secondJobDuration === "<1 yr" && !answers.secondStartDate) {
            alert("Please enter your start date for your second job.");
            return false;
          }
          return true;
        case "secondPayType":
          if (!answers.secondPayType) {
            alert("Please select your second job's pay type.");
            return false;
          }
          return true;
        case "secondHourlyDetails":
          if (!answers.secondHourlyRate || !answers.secondHoursWorked) {
            alert("Please enter your second job's hourly rate and hours worked.");
            return false;
          }
          if (isNaN(answers.secondHourlyRate) || isNaN(answers.secondHoursWorked)) {
            alert("Second job's hourly rate and hours worked must be numbers.");
            return false;
          }
          return true;
        case "secondSalaryDetails":
          if (!answers.secondYearlySalary) {
            alert("Please enter your second job's yearly salary.");
            return false;
          }
          if (isNaN(answers.secondYearlySalary)) {
            alert("Second job's yearly salary must be a number.");
            return false;
          }
          return true;
        case "secondNetProfit":
          if (!answers.secondNetProfit) {
            alert("Please enter your second job's average monthly net profit.");
            return false;
          }
          if (isNaN(answers.secondNetProfit)) {
            alert("Second job's net profit must be a number.");
            return false;
          }
          return true;
        case "priorEmployment":
          if (!answers.priorEmployment) {
            alert("Please indicate whether you have had prior employment in the last 6 months.");
            return false;
          }
          return true;
        case "priorJobInfo":
          if (!answers.priorWorkPlace || !answers.priorJobTitle || !answers.priorJobDuration) {
            alert("Please complete your prior job information.");
            return false;
          }
          if (answers.priorJobDuration === "<1 yr" && !answers.priorStartDate) {
            alert("Please enter your start date for your prior job.");
            return false;
          }
          return true;
        case "priorLeavingDate":
          if (!answers.priorLeavingDate) {
            alert("Please enter the date you left your prior employment.");
            return false;
          }
          return true;
        // Fixed income for respondent:
        case "hasFixedIncome":
          if (!answers.hasFixedIncome) {
            alert("Please indicate if you have fixed income sources.");
            return false;
          }
          return true;
        case "fixedIncome":
          if (!answers.fixedIncomeSources || answers.fixedIncomeSources.length === 0) {
            alert("Please select at least one fixed income source (or 'None').");
            return false;
          }
          return true;
        case "spouseFixedIncome":
        if (!answers.spouseFixedIncomeSources || answers.spouseFixedIncomeSources.length === 0) {
            alert("Please select at least one fixed income source (or 'None').");
            return false;
        }
        return true;
        default:
          if (currentStepKey.startsWith("fixedIncomeDetails_")) {
            const source = currentStepKey.replace("fixedIncomeDetails_", "");
            if (source === "Other") {
              if (!answers.fixedIncomeOtherDesc || !answers.fixedIncomeDetails["Other"]) {
                alert("Please describe your 'Other' income source and enter the amount.");
                return false;
              }
              if (isNaN(answers.fixedIncomeDetails["Other"])) {
                alert("'Other' income amount must be a number.");
                return false;
              }
            } else {
              if (!answers.fixedIncomeDetails[source]) {
                alert(`Please enter your net monthly income for ${source}.`);
                return false;
              }
              if (isNaN(answers.fixedIncomeDetails[source])) {
                alert(`Monthly income for ${source} must be a number.`);
                return false;
              }
            }
            return true;
          }
          // Spouse fixed income detail validations
          if (currentStepKey.startsWith("spouseFixedIncomeDetails_")) {
            const source = currentStepKey.replace("spouseFixedIncomeDetails_", "");
            if (source === "Other") {
              if (!answers.spouseFixedIncomeOtherDesc || !answers.spouseFixedIncomeDetails["Other"]) {
                alert("Please describe your spouse's 'Other' income source and enter the amount.");
                return false;
              }
              if (isNaN(answers.spouseFixedIncomeDetails["Other"])) {
                alert("Spouse 'Other' income amount must be a number.");
                return false;
              }
            } else {
              if (!answers.spouseFixedIncomeDetails[source]) {
                alert(`Please enter your spouse's net monthly income for ${source}.`);
                return false;
              }
              if (isNaN(answers.spouseFixedIncomeDetails[source])) {
                alert(`Monthly income for ${source} must be a number.`);
                return false;
              }
            }
            return true;
          }
          // Spouse Employment & Income Validations:
          if (currentStepKey === "spouseEmploymentStatus") {
            if (!answers.spouseEmploymentStatus) {
              alert("Please indicate if your spouse is employed.");
              return false;
            }
            return true;
          }
          if (currentStepKey === "spouseJobInfo") {
            if (!answers.spouseWorkPlace || !answers.spouseJobTitle || !answers.spouseJobDuration) {
              alert("Please complete your spouse's job information (workplace, job title, and duration).");
              return false;
            }
            if (answers.spouseJobDuration === "<1 yr" && !answers.spouseStartDate) {
              alert("Please enter your spouse's start date.");
              return false;
            }
            return true;
          }
          if (currentStepKey === "spousePayType") {
            if (!answers.spousePayType) {
              alert("Please select your spouse's pay type.");
              return false;
            }
            return true;
          }
          if (currentStepKey === "spouseHourlyDetails") {
            if (!answers.spouseHourlyRate || !answers.spouseHoursWorked) {
              alert("Please enter your spouse's hourly rate and hours worked.");
              return false;
            }
            if (isNaN(answers.spouseHourlyRate) || isNaN(answers.spouseHoursWorked)) {
              alert("Your spouse's hourly rate and hours worked must be numbers.");
              return false;
            }
            return true;
          }
          if (currentStepKey.startsWith("dependentDetails_")) {
            const depIndex = parseInt(currentStepKey.split("_")[1], 10) - 1;
            const dep = answers.dependentDetails[depIndex];
            if (!dep || !dep.age || isNaN(dep.age)) {
              alert(`Please enter a valid age for dependent ${depIndex + 1}.`);
              return false;
            }
            if (!dep.relation) {
              alert(`Please select a relation for dependent ${depIndex + 1}.`);
              return false;
            }
            if (dep.relation === "other" && !dep.relationOther) {
              alert(`Please specify the relation for dependent ${depIndex + 1}.`);
              return false;
            }
            return true;
          }
          if (currentStepKey === "spouseSalaryDetails") {
            if (!answers.spouseYearlySalary) {
              alert("Please enter your spouse's yearly salary.");
              return false;
            }
            if (isNaN(answers.spouseYearlySalary)) {
              alert("Your spouse's yearly salary must be a number.");
              return false;
            }
            return true;
          }
          if (currentStepKey === "spouseNetProfit") {
            if (!answers.spouseNetProfit) {
              alert("Please enter your spouse's average monthly net profit.");
              return false;
            }
            if (isNaN(answers.spouseNetProfit)) {
              alert("Your spouse's net profit must be a number.");
              return false;
            }
            return true;
          }
          if (currentStepKey === "spouseDeductions") {
            // Optional.
            return true;
          }
          if (currentStepKey === "spouseSecondJob") {
            if (!answers.spouseSecondJob) {
              alert("Please indicate whether your spouse has a second job or side-hustle.");
              return false;
            }
            return true;
          }
          if (currentStepKey === "spouseSecondJobInfo") {
            if (!answers.spouseSecondWorkPlace || !answers.spouseSecondJobTitle || !answers.spouseSecondJobDuration) {
              alert("Please complete your spouse's second job information.");
              return false;
            }
            if (answers.spouseSecondJobDuration === "<1 yr" && !answers.spouseSecondStartDate) {
              alert("Please enter your spouse's start date for their second job.");
              return false;
            }
            return true;
          }
          if (currentStepKey === "spouseSecondPayType") {
            if (!answers.spouseSecondPayType) {
              alert("Please select your spouse's second job pay type.");
              return false;
            }
            return true;
          }
          if (currentStepKey === "spouseSecondHourlyDetails") {
            if (!answers.spouseSecondHourlyRate || !answers.spouseSecondHoursWorked) {
              alert("Please enter your spouse's second job hourly rate and hours worked.");
              return false;
            }
            if (isNaN(answers.spouseSecondHourlyRate) || isNaN(answers.spouseSecondHoursWorked)) {
              alert("Your spouse's second job hourly rate and hours worked must be numbers.");
              return false;
            }
            return true;
          }
          if (currentStepKey === "spouseSecondSalaryDetails") {
            if (!answers.spouseSecondYearlySalary) {
              alert("Please enter your spouse's second job yearly salary.");
              return false;
            }
            if (isNaN(answers.spouseSecondYearlySalary)) {
              alert("Your spouse's second job yearly salary must be a number.");
              return false;
            }
            return true;
          }
          if (currentStepKey === "spouseSecondNetProfit") {
            if (!answers.spouseSecondNetProfit) {
              alert("Please enter your spouse's second job average monthly net profit.");
              return false;
            }
            if (isNaN(answers.spouseSecondNetProfit)) {
              alert("Your spouse's second job net profit must be a number.");
              return false;
            }
            return true;
          }
          if (currentStepKey === "spouseHasFixedIncome") {
            if (!answers.spouseHasFixedIncome) {
              alert("Please indicate if your spouse has fixed income sources.");
              return false;
            }
            return true;
          }
          return true;
          case "spousePriorEmployment":
        if (!answers.spousePriorEmployment) {
            alert("Please indicate if your spouse had prior employment in the last 6 months.");
            return false;
        }
        return true;
        case "ownsHome":
            if (!answers.ownsHome) {
              alert("Please indicate if you own your home.");
              return false;
            }
            return true;
          case "homeOwnershipType":
            if (answers.ownsHome === "yes" && answers.maritalStatus === "married" && !answers.homeOwnershipType) {
              alert("Please indicate your home ownership type (I own, my spouse owns, or we own together).");
              return false;
            }
            return true;
          case "homeOwnershipDetail":
            if (answers.ownsHome === "yes" && answers.maritalStatus !== "married" && !answers.homeOwnershipDetail) {
              alert("Please indicate if you own your home jointly with someone else.");
              return false;
            }
            return true;
          case "homeValue":
            if (answers.ownsHome === "yes") {
              if (!answers.homeValue) {
                alert("Please enter the estimated value of your home.");
                return false;
              }
              if (!isNumeric(answers.homeValue)) {
                alert("Home value must be a number.");
                return false;
              }
            }
            return true;
          case "hasMortgage":
            if (answers.ownsHome === "yes" && !answers.hasMortgage) {
              alert("Please indicate if your home has a mortgage.");
              return false;
            }
            return true;
          case "mortgageCreditor":
            if (answers.hasMortgage === "yes" && !answers.mortgageCreditor) {
              alert("Please enter your mortgage creditor.");
              return false;
            }
            return true;
          case "mortgageBalancePayment":
            if (answers.hasMortgage === "yes") {
              if (!answers.mortgageBalance || !answers.mortgageMonthlyPayment) {
                alert("Please enter your mortgage balance and monthly payment.");
                return false;
              }
              if (!isNumeric(answers.mortgageBalance) || !isNumeric(answers.mortgageMonthlyPayment)) {
                alert("Mortgage balance and monthly payment must be numbers.");
                return false;
              }
            }
            return true;
          case "mortgagePaymentStatus":
            if (answers.hasMortgage === "yes" && !answers.mortgagePaymentStatus) {
              alert("Please indicate if your mortgage payments are current.");
              return false;
            }
            return true;
          case "mortgageMonthsBehind":
            if (answers.mortgagePaymentStatus === "no") {
              if (!answers.mortgageMonthsBehind) {
                alert("Please enter how many months you are behind on your mortgage.");
                return false;
              }
              if (!isNumeric(answers.mortgageMonthsBehind)) {
                alert("Months behind must be a number.");
                return false;
              }
            }
            return true;
          case "hasSecondMortgage":
            if (answers.hasMortgage === "yes" && !answers.hasSecondMortgage) {
              alert("Please indicate if your home has a second mortgage.");
              return false;
            }
            return true;
          case "secondMortgageCreditor":
            if (answers.hasSecondMortgage === "yes" && !answers.secondMortgageCreditor) {
              alert("Please enter your second mortgage creditor.");
              return false;
            }
            return true;
          case "secondMortgageBalancePayment":
            if (answers.hasSecondMortgage === "yes") {
              if (!answers.secondMortgageBalance || !answers.secondMortgageMonthlyPayment) {
                alert("Please enter your second mortgage balance and monthly payment.");
                return false;
              }
              if (!isNumeric(answers.secondMortgageBalance) || !isNumeric(answers.secondMortgageMonthlyPayment)) {
                alert("Second mortgage balance and monthly payment must be numbers.");
                return false;
              }
            }
            return true;
          case "secondMortgagePaymentStatus":
            if (answers.hasSecondMortgage === "yes" && !answers.secondMortgagePaymentStatus) {
              alert("Please indicate if your second mortgage payments are current.");
              return false;
            }
            return true;
          case "secondMortgageMonthsBehind":
            if (answers.secondMortgagePaymentStatus === "no") {
              if (!answers.secondMortgageMonthsBehind) {
                alert("Please enter how many months you are behind on your second mortgage.");
                return false;
              }
              if (!isNumeric(answers.secondMortgageMonthsBehind)) {
                alert("Months behind on second mortgage must be a number.");
                return false;
              }
            }
            return true;
          case "hasOtherRealEstate":
            if (!answers.hasOtherRealEstate) {
              alert("Please indicate if you have other real estate.");
              return false;
            }
            return true;
            case "otherRealEstateInformation":
                if (answers.hasOtherRealEstate === "yes") {
                  if (!answers.otherRealEstateProperties || answers.otherRealEstateProperties.length === 0) {
                    alert("Please add at least one other real estate property.");
                    return false;
                  }
                  for (let i = 0; i < answers.otherRealEstateProperties.length; i++) {
                    const prop = answers.otherRealEstateProperties[i];
                    // Validate address fields
                    if (!prop.street || !prop.city || !prop.state || !prop.zip) {
                      alert(`Please complete the address for property ${i + 1}.`);
                      return false;
                    }
                    if (!/^\d{5}$/.test(prop.zip)) {
                      alert(`Zip code for property ${i + 1} must be exactly 5 digits.`);
                      return false;
                    }
                    if (!isValidState(prop.state)) {
                      alert(`Please enter a valid state for property ${i + 1}.`);
                      return false;
                    }
                    // Validate estimated value
                    if (!prop.value || !isNumeric(prop.value)) {
                      alert(`Please enter a valid estimated value for property ${i + 1}.`);
                      return false;
                    }
                    // Validate mortgage questions
                    if (!prop.hasMortgage) {
                      alert(`Please indicate whether property ${i + 1} has a mortgage.`);
                      return false;
                    }
                    if (prop.hasMortgage === "yes") {
                      if (!prop.mortgageCreditor) {
                        alert(`Please enter the mortgage creditor for property ${i + 1}.`);
                        return false;
                      }
                      if (!prop.mortgageBalance || !isNumeric(prop.mortgageBalance)) {
                        alert(`Please enter a valid mortgage balance for property ${i + 1}.`);
                        return false;
                      }
                      if (!prop.mortgageMonthlyPayment || !isNumeric(prop.mortgageMonthlyPayment)) {
                        alert(`Please enter a valid monthly mortgage payment for property ${i + 1}.`);
                        return false;
                      }
                      if (!prop.mortgagePaymentStatus) {
                        alert(`Please indicate if the mortgage payments are current for property ${i + 1}.`);
                        return false;
                      }
                      if (prop.mortgagePaymentStatus === "no") {
                        if (!prop.mortgageMonthsBehind || !isNumeric(prop.mortgageMonthsBehind)) {
                          alert(`Please enter a valid number of months behind for property ${i + 1}.`);
                          return false;
                        }
                      }
                      // Validate second mortgage questions
                      if (!prop.hasSecondMortgage) {
                        alert(`Please indicate whether property ${i + 1} has a second mortgage.`);
                        return false;
                      }
                      if (prop.hasSecondMortgage === "yes") {
                        if (!prop.secondMortgageCreditor) {
                          alert(`Please enter the second mortgage creditor for property ${i + 1}.`);
                          return false;
                        }
                        if (!prop.secondMortgageBalance || !isNumeric(prop.secondMortgageBalance)) {
                          alert(`Please enter a valid second mortgage balance for property ${i + 1}.`);
                          return false;
                        }
                        if (!prop.secondMortgageMonthlyPayment || !isNumeric(prop.secondMortgageMonthlyPayment)) {
                          alert(`Please enter a valid second mortgage monthly payment for property ${i + 1}.`);
                          return false;
                        }
                        if (!prop.secondMortgagePaymentStatus) {
                          alert(`Please indicate if the second mortgage payments are current for property ${i + 1}.`);
                          return false;
                        }
                        if (prop.secondMortgagePaymentStatus === "no") {
                          if (!prop.secondMortgageMonthsBehind || !isNumeric(prop.secondMortgageMonthsBehind)) {
                            alert(`Please enter a valid number of months behind for the second mortgage of property ${i + 1}.`);
                            return false;
                          }
                        }
                      }
                    }
                  }
                }
                return true;
          case "spouseHasOtherRealEstate":
            if (answers.maritalStatus === "married" && answers.spouseFiling === "yes" && !answers.spouseHasOtherRealEstate) {
              alert("Please indicate if your spouse has other real estate.");
              return false;
            }
            return true;
            case "spouseOtherRealEstateInformation":
                if (answers.spouseHasOtherRealEstate === "yes") {
                  if (!answers.spouseOtherRealEstateProperties || answers.spouseOtherRealEstateProperties.length === 0) {
                    alert("Please add at least one other real estate property.");
                    return false;
                  }
                  for (let i = 0; i < answers.spouseOtherRealEstateProperties.length; i++) {
                    const prop = answers.spouseOtherRealEstateProperties[i];
                    // Validate address fields
                    if (!prop.street || !prop.city || !prop.state || !prop.zip) {
                      alert(`Please complete the address for property ${i + 1}.`);
                      return false;
                    }
                    if (!/^\d{5}$/.test(prop.zip)) {
                      alert(`Zip code for property ${i + 1} must be exactly 5 digits.`);
                      return false;
                    }
                    if (!isValidState(prop.state)) {
                      alert(`Please enter a valid state for property ${i + 1}.`);
                      return false;
                    }
                    // Validate estimated value
                    if (!prop.value || !isNumeric(prop.value)) {
                      alert(`Please enter a valid estimated value for property ${i + 1}.`);
                      return false;
                    }
                    // Validate mortgage questions
                    if (!prop.hasMortgage) {
                      alert(`Please indicate whether property ${i + 1} has a mortgage.`);
                      return false;
                    }
                    if (prop.hasMortgage === "yes") {
                      if (!prop.mortgageCreditor) {
                        alert(`Please enter the mortgage creditor for property ${i + 1}.`);
                        return false;
                      }
                      if (!prop.mortgageBalance || !isNumeric(prop.mortgageBalance)) {
                        alert(`Please enter a valid mortgage balance for property ${i + 1}.`);
                        return false;
                      }
                      if (!prop.mortgageMonthlyPayment || !isNumeric(prop.mortgageMonthlyPayment)) {
                        alert(`Please enter a valid monthly mortgage payment for property ${i + 1}.`);
                        return false;
                      }
                      if (!prop.mortgagePaymentStatus) {
                        alert(`Please indicate if the mortgage payments are current for property ${i + 1}.`);
                        return false;
                      }
                      if (prop.mortgagePaymentStatus === "no") {
                        if (!prop.mortgageMonthsBehind || !isNumeric(prop.mortgageMonthsBehind)) {
                          alert(`Please enter a valid number of months behind for property ${i + 1}.`);
                          return false;
                        }
                      }
                      // Validate second mortgage questions
                      if (!prop.hasSecondMortgage) {
                        alert(`Please indicate whether property ${i + 1} has a second mortgage.`);
                        return false;
                      }
                      if (prop.hasSecondMortgage === "yes") {
                        if (!prop.secondMortgageCreditor) {
                          alert(`Please enter the second mortgage creditor for property ${i + 1}.`);
                          return false;
                        }
                        if (!prop.secondMortgageBalance || !isNumeric(prop.secondMortgageBalance)) {
                          alert(`Please enter a valid second mortgage balance for property ${i + 1}.`);
                          return false;
                        }
                        if (!prop.secondMortgageMonthlyPayment || !isNumeric(prop.secondMortgageMonthlyPayment)) {
                          alert(`Please enter a valid second mortgage monthly payment for property ${i + 1}.`);
                          return false;
                        }
                        if (!prop.secondMortgagePaymentStatus) {
                          alert(`Please indicate if the second mortgage payments are current for property ${i + 1}.`);
                          return false;
                        }
                        if (prop.secondMortgagePaymentStatus === "no") {
                          if (!prop.secondMortgageMonthsBehind || !isNumeric(prop.secondMortgageMonthsBehind)) {
                            alert(`Please enter a valid number of months behind for the second mortgage of property ${i + 1}.`);
                            return false;
                          }
                        }
                      }
                    }
                  }
                }
                return true;
      
          // Part 5: Unsecured Debt Information (Respondent)
          case "creditCardDebt":
            if (!answers.creditCardDebt) {
              alert("Please indicate if you have credit card debt.");
              return false;
            }
            return true;
          case "creditCardDebtDetails":
            if (answers.creditCardDebt === "yes") {
              if (!answers.creditCardDebtDetails || answers.creditCardDebtDetails.length === 0) {
                alert("Please add at least one credit card debt entry.");
                return false;
              }
              for (let i = 0; i < answers.creditCardDebtDetails.length; i++) {
                const debt = answers.creditCardDebtDetails[i];
                if (!debt.creditor) {
                  alert(`Please enter the creditor for credit card debt entry ${i + 1}.`);
                  return false;
                }
                if (!debt.debtBalance || !isNumeric(debt.debtBalance)) {
                  alert(`Please enter a valid debt balance for credit card debt entry ${i + 1}.`);
                  return false;
                }
              }
            }
            return true;
          case "personalLoanDebt":
            if (!answers.personalLoanDebt) {
              alert("Please indicate if you have personal loan debt.");
              return false;
            }
            return true;
          case "personalLoanDebtDetails":
            if (answers.personalLoanDebt === "yes") {
              if (!answers.personalLoanDebtDetails || answers.personalLoanDebtDetails.length === 0) {
                alert("Please add at least one personal loan debt entry.");
                return false;
              }
              for (let i = 0; i < answers.personalLoanDebtDetails.length; i++) {
                const debt = answers.personalLoanDebtDetails[i];
                if (!debt.creditor) {
                  alert(`Please enter the creditor for personal loan debt entry ${i + 1}.`);
                  return false;
                }
                if (!debt.debtBalance || !isNumeric(debt.debtBalance)) {
                  alert(`Please enter a valid debt balance for personal loan debt entry ${i + 1}.`);
                  return false;
                }
              }
            }
            return true;
          case "medicalDebt":
            if (!answers.medicalDebt) {
              alert("Please indicate if you have medical debt.");
              return false;
            }
            return true;
          case "medicalDebtDetails":
            if (answers.medicalDebt === "yes") {
              if (!answers.medicalDebtDetails || answers.medicalDebtDetails.length === 0) {
                alert("Please add at least one medical debt entry.");
                return false;
              }
              for (let i = 0; i < answers.medicalDebtDetails.length; i++) {
                const debt = answers.medicalDebtDetails[i];
                if (!debt.creditor) {
                  alert(`Please enter the creditor for medical debt entry ${i + 1}.`);
                  return false;
                }
                if (!debt.amountOwed || !isNumeric(debt.amountOwed)) {
                  alert(`Please enter a valid amount for medical debt entry ${i + 1}.`);
                  return false;
                }
              }
            }
            return true;
          case "studentLoanDebt":
            if (!answers.studentLoanDebt) {
              alert("Please indicate if you have student loan debt.");
              return false;
            }
            return true;
          case "studentLoanDebtDetails":
            if (answers.studentLoanDebt === "yes") {
              if (!answers.studentLoanDebtDetails || answers.studentLoanDebtDetails.length === 0) {
                alert("Please add at least one student loan debt entry.");
                return false;
              }
              for (let i = 0; i < answers.studentLoanDebtDetails.length; i++) {
                const debt = answers.studentLoanDebtDetails[i];
                if (!debt.creditor) {
                  alert(`Please enter the creditor for student loan debt entry ${i + 1}.`);
                  return false;
                }
                if (!debt.debtBalance || !isNumeric(debt.debtBalance)) {
                  alert(`Please enter a valid debt balance for student loan debt entry ${i + 1}.`);
                  return false;
                }
              }
            }
            return true;
          case "backTaxes":
            if (!answers.backTaxes) {
              alert("Please indicate if you owe back taxes.");
              return false;
            }
            return true;
          case "backTaxesDetails":
            if (answers.backTaxes === "yes") {
              if (!answers.backTaxDebtDetails || answers.backTaxDebtDetails.length === 0) {
                alert("Please add at least one back taxes entry.");
                return false;
              }
              for (let i = 0; i < answers.backTaxDebtDetails.length; i++) {
                const debt = answers.backTaxDebtDetails[i];
                if (!debt.taxType) {
                  alert(`Please select the tax type for back taxes entry ${i + 1}.`);
                  return false;
                }
                if (debt.taxType === "State" && (!debt.state || !isValidState(debt.state))) {
                  alert(`Please enter a valid state for back taxes entry ${i + 1}.`);
                  return false;
                }
                if (!debt.year || !isNumeric(debt.year)) {
                  alert(`Please enter a valid year for back taxes entry ${i + 1}.`);
                  return false;
                }
                if (!debt.amount || !isNumeric(debt.amount)) {
                  alert(`Please enter a valid amount for back taxes entry ${i + 1}.`);
                  return false;
                }
              }
            }
            return true;
          case "otherDebt":
            if (!answers.otherDebt) {
              alert("Please indicate if you have other debts or liabilities.");
              return false;
            }
            return true;
          case "otherDebtDetails":
            if (answers.otherDebt === "yes") {
              if (!answers.otherDebtDetails || answers.otherDebtDetails.length === 0) {
                alert("Please add at least one other debt entry.");
                return false;
              }
              for (let i = 0; i < answers.otherDebtDetails.length; i++) {
                const debt = answers.otherDebtDetails[i];
                if (!debt.creditor) {
                  alert(`Please enter the creditor for other debt entry ${i + 1}.`);
                  return false;
                }
                if (!debt.description) {
                  alert(`Please enter a description for other debt entry ${i + 1}.`);
                  return false;
                }
                if (!debt.amountOwed || !isNumeric(debt.amountOwed)) {
                  alert(`Please enter a valid amount for other debt entry ${i + 1}.`);
                  return false;
                }
              }
            }
            return true;
      
          // Spouse Unsecured Debt (if spouse is filing)
          // Note: Only validate these if maritalStatus is "married" and spouseFiling is "yes".
          case "spouseCreditCardDebt":
            if (answers.maritalStatus === "married" && answers.spouseFiling === "yes" && !answers.spouseCreditCardDebt) {
              alert("Please indicate if your spouse has credit card debt.");
              return false;
            }
            return true;
          case "spouseCreditCardDebtDetails":
            if (answers.spouseCreditCardDebt === "yes") {
              if (!answers.spouseCreditCardDebtDetails || answers.spouseCreditCardDebtDetails.length === 0) {
                alert("Please add at least one credit card debt entry for your spouse.");
                return false;
              }
              for (let i = 0; i < answers.spouseCreditCardDebtDetails.length; i++) {
                const debt = answers.spouseCreditCardDebtDetails[i];
                if (!debt.creditor) {
                  alert(`Please enter the creditor for spouse's credit card debt entry ${i + 1}.`);
                  return false;
                }
                if (!debt.debtBalance || !isNumeric(debt.debtBalance)) {
                  alert(`Please enter a valid debt balance for spouse's credit card debt entry ${i + 1}.`);
                  return false;
                }
              }
            }
            return true;
          case "spousePersonalLoanDebt":
            if (answers.maritalStatus === "married" && answers.spouseFiling === "yes" && !answers.spousePersonalLoanDebt) {
              alert("Please indicate if your spouse has personal loan debt.");
              return false;
            }
            return true;
          case "spousePersonalLoanDebtDetails":
            if (answers.spousePersonalLoanDebt === "yes") {
              if (!answers.spousePersonalLoanDebtDetails || answers.spousePersonalLoanDebtDetails.length === 0) {
                alert("Please add at least one personal loan debt entry for your spouse.");
                return false;
              }
              for (let i = 0; i < answers.spousePersonalLoanDebtDetails.length; i++) {
                const debt = answers.spousePersonalLoanDebtDetails[i];
                if (!debt.creditor) {
                  alert(`Please enter the creditor for spouse's personal loan debt entry ${i + 1}.`);
                  return false;
                }
                if (!debt.debtBalance || !isNumeric(debt.debtBalance)) {
                  alert(`Please enter a valid debt balance for spouse's personal loan debt entry ${i + 1}.`);
                  return false;
                }
              }
            }
            return true;
          case "spouseMedicalDebt":
            if (answers.maritalStatus === "married" && answers.spouseFiling === "yes" && !answers.spouseMedicalDebt) {
              alert("Please indicate if your spouse has medical debt.");
              return false;
            }
            return true;
          case "spouseMedicalDebtDetails":
            if (answers.spouseMedicalDebt === "yes") {
              if (!answers.spouseMedicalDebtDetails || answers.spouseMedicalDebtDetails.length === 0) {
                alert("Please add at least one medical debt entry for your spouse.");
                return false;
              }
              for (let i = 0; i < answers.spouseMedicalDebtDetails.length; i++) {
                const debt = answers.spouseMedicalDebtDetails[i];
                if (!debt.creditor) {
                  alert(`Please enter the creditor for spouse's medical debt entry ${i + 1}.`);
                  return false;
                }
                if (!debt.amountOwed || !isNumeric(debt.amountOwed)) {
                  alert(`Please enter a valid amount for spouse's medical debt entry ${i + 1}.`);
                  return false;
                }
              }
            }
            return true;
          case "spouseStudentLoanDebt":
            if (answers.maritalStatus === "married" && answers.spouseFiling === "yes" && !answers.spouseStudentLoanDebt) {
              alert("Please indicate if your spouse has student loan debt.");
              return false;
            }
            return true;
          case "spouseStudentLoanDebtDetails":
            if (answers.spouseStudentLoanDebt === "yes") {
              if (!answers.spouseStudentLoanDebtDetails || answers.spouseStudentLoanDebtDetails.length === 0) {
                alert("Please add at least one student loan debt entry for your spouse.");
                return false;
              }
              for (let i = 0; i < answers.spouseStudentLoanDebtDetails.length; i++) {
                const debt = answers.spouseStudentLoanDebtDetails[i];
                if (!debt.creditor) {
                  alert(`Please enter the creditor for spouse's student loan debt entry ${i + 1}.`);
                  return false;
                }
                if (!debt.debtBalance || !isNumeric(debt.debtBalance)) {
                  alert(`Please enter a valid debt balance for spouse's student loan debt entry ${i + 1}.`);
                  return false;
                }
              }
            }
            return true;
          case "spouseBackTaxes":
            if (answers.maritalStatus === "married" && answers.spouseFiling === "yes" && !answers.spouseBackTaxes) {
              alert("Please indicate if your spouse owes back taxes.");
              return false;
            }
            return true;
          case "spouseBackTaxesDetails":
            if (answers.spouseBackTaxes === "yes") {
              if (!answers.spouseBackTaxDebtDetails || answers.spouseBackTaxDebtDetails.length === 0) {
                alert("Please add at least one back taxes entry for your spouse.");
                return false;
              }
              for (let i = 0; i < answers.spouseBackTaxDebtDetails.length; i++) {
                const debt = answers.spouseBackTaxDebtDetails[i];
                if (!debt.taxType) {
                  alert(`Please select the tax type for spouse's back taxes entry ${i + 1}.`);
                  return false;
                }
                if (debt.taxType === "State" && (!debt.state || !isValidState(debt.state))) {
                  alert(`Please enter a valid state for spouse's back taxes entry ${i + 1}.`);
                  return false;
                }
                if (!debt.year || !isNumeric(debt.year)) {
                  alert(`Please enter a valid year for spouse's back taxes entry ${i + 1}.`);
                  return false;
                }
                if (!debt.amount || !isNumeric(debt.amount)) {
                  alert(`Please enter a valid amount for spouse's back taxes entry ${i + 1}.`);
                  return false;
                }
              }
            }
            return true;
          case "spouseOtherDebt":
            if (answers.maritalStatus === "married" && answers.spouseFiling === "yes" && !answers.spouseOtherDebt) {
              alert("Please indicate if your spouse has other debts or liabilities.");
              return false;
            }
            return true;
          case "spouseOtherDebtDetails":
            if (answers.spouseOtherDebt === "yes") {
              if (!answers.spouseOtherDebtDetails || answers.spouseOtherDebtDetails.length === 0) {
                alert("Please add at least one other debt entry for your spouse.");
                return false;
              }
              for (let i = 0; i < answers.spouseOtherDebtDetails.length; i++) {
                const debt = answers.spouseOtherDebtDetails[i];
                if (!debt.creditor) {
                  alert(`Please enter the creditor for spouse's other debt entry ${i + 1}.`);
                  return false;
                }
                if (!debt.description) {
                  alert(`Please enter a description for spouse's other debt entry ${i + 1}.`);
                  return false;
                }
                if (!debt.amountOwed || !isNumeric(debt.amountOwed)) {
                  alert(`Please enter a valid amount for spouse's other debt entry ${i + 1}.`);
                  return false;
                }
              }
            }
            return true;
      
          // Part 6: Expense Information
          case "paysRent":
            // Only applicable if the respondent does not own their home.
            if (answers.ownsHome !== "yes" && !answers.paysRent) {
              alert("Please indicate if you pay rent.");
              return false;
            }
            return true;
          case "rentAmount":
            if (answers.paysRent === "yes") {
              if (!answers.rentAmount) {
                alert("Please enter your monthly rent.");
                return false;
              }
              if (!isNumeric(answers.rentAmount)) {
                alert("Rent amount must be a number.");
                return false;
              }
            }
            return true;
          case "vehicleInsurance":
            // Only applicable if respondent owns vehicles.
            if (answers.hasVehicle === "yes") {
              if (!answers.vehicleInsurance) {
                alert("Please enter your total monthly vehicle insurance cost.");
                return false;
              }
              if (!isNumeric(answers.vehicleInsurance)) {
                alert("Vehicle insurance cost must be a number.");
                return false;
              }
            }
            return true;
          case "childSupport":
            if (!answers.childSupport) {
              alert("Please indicate if you pay child support.");
              return false;
            }
            return true;
          case "childSupportAmount":
            if (answers.childSupport === "yes") {
              if (!answers.childSupportAmount) {
                alert("Please enter the monthly child support amount.");
                return false;
              }
              if (!isNumeric(answers.childSupportAmount)) {
                alert("Child support amount must be a number.");
                return false;
              }
            }
            return true;
          case "childSupportDeducted":
            if (answers.childSupport === "yes" && !answers.childSupportDeducted) {
              alert("Please indicate if child support is deducted from your wages.");
              return false;
            }
            return true;
          case "childSupportArrearage":
            if (answers.childSupport === "yes" && !answers.childSupportArrearage) {
              alert("Please indicate if you have child support arrearage.");
              return false;
            }
            return true;
          case "childSupportArrearageAmount":
            if (answers.childSupportArrearage === "yes") {
              if (!answers.childSupportArrearageAmount) {
                alert("Please enter the amount of child support arrearage.");
                return false;
              }
              if (!isNumeric(answers.childSupportArrearageAmount)) {
                alert("Child support arrearage must be a number.");
                return false;
              }
            }
            return true;
          case "alimony":
            if (!answers.alimony) {
              alert("Please indicate if you pay alimony.");
              return false;
            }
            return true;
          case "alimonyAmount":
            if (answers.alimony === "yes") {
              if (!answers.alimonyAmount) {
                alert("Please enter your monthly alimony amount.");
                return false;
              }
              if (!isNumeric(answers.alimonyAmount)) {
                alert("Alimony amount must be a number.");
                return false;
              }
            }
            return true;
      
          // Spouse Expense Information (if spouse is filing)
          case "spouseChildSupport":
            if (answers.maritalStatus === "married" && answers.spouseFiling === "yes" && !answers.spouseChildSupport) {
              alert("Please indicate if your spouse pays child support.");
              return false;
            }
            return true;
          case "spouseChildSupportAmount":
            if (answers.spouseChildSupport === "yes") {
              if (!answers.spouseChildSupportAmount) {
                alert("Please enter your spouse's monthly child support amount.");
                return false;
              }
              if (!isNumeric(answers.spouseChildSupportAmount)) {
                alert("Child support amount must be a number.");
                return false;
              }
            }
            return true;
          case "spouseChildSupportDeducted":
            if (answers.spouseChildSupport === "yes" && !answers.spouseChildSupportDeducted) {
              alert("Please indicate if your spouse's child support is deducted from wages.");
              return false;
            }
            return true;
          case "spouseChildSupportArrearage":
            if (answers.spouseChildSupport === "yes" && !answers.spouseChildSupportArrearage) {
              alert("Please indicate if your spouse has child support arrearage.");
              return false;
            }
            return true;
          case "spouseChildSupportArrearageAmount":
            if (answers.spouseChildSupportArrearage === "yes") {
              if (!answers.spouseChildSupportArrearageAmount) {
                alert("Please enter the amount of your spouse's child support arrearage.");
                return false;
              }
              if (!isNumeric(answers.spouseChildSupportArrearageAmount)) {
                alert("Child support arrearage must be a number.");
                return false;
              }
            }
            return true;
          case "spouseAlimony":
            if (answers.maritalStatus === "married" && answers.spouseFiling === "yes" && !answers.spouseAlimony) {
              alert("Please indicate if your spouse pays alimony.");
              return false;
            }
            return true;
          case "spouseAlimonyAmount":
            if (answers.spouseAlimony === "yes") {
              if (!answers.spouseAlimonyAmount) {
                alert("Please enter your spouse's monthly alimony amount.");
                return false;
              }
              if (!isNumeric(answers.spouseAlimonyAmount)) {
                alert("Alimony amount must be a number.");
                return false;
              }
            }
            return true;
        case "spousePriorJobInfo":
        if (!answers.spousePriorWorkPlace || !answers.spousePriorJobTitle || !answers.spousePriorJobDuration) {
            alert("Please complete your spouse's prior job information.");
            return false;
        }
        if (answers.spousePriorJobDuration === "<1 yr" && !answers.spousePriorStartDate) {
            alert("Please enter your spouse's start date for their prior job.");
            return false;
        }
        return true;
        case "spousePriorLeavingDate":
        if (!answers.spousePriorLeavingDate) {
            alert("Please enter the date your spouse left their prior employment.");
            return false;
        }
        return true;
        ///part 3 for vehicles
        case "vehicleInformation":
            if (answers.vehicles.length === 0) {
              alert("Please add at least one vehicle.");
              return false;
            }
            for (let i = 0; i < answers.vehicles.length; i++) {
              const vehicle = answers.vehicles[i];
              // Check basic vehicle info
              if (!vehicle.year || !vehicle.make || !vehicle.model || !vehicle.miles) {
                alert(`Please complete all details (year, make, model, miles) for vehicle ${i + 1}.`);
                return false;
              }
              // Check that an option was chosen for loan status
              if (!vehicle.loan) {
                alert(`Please indicate whether vehicle ${i + 1} is paid off or has a loan.`);
                return false;
              }
              // If the vehicle has a loan, validate loan details and payment status
              if (vehicle.loan === "loan") {
                if (!vehicle.creditor || !vehicle.loanBalance || !vehicle.monthlyPayment) {
                  alert(`Please complete loan details (creditor, loan balance, monthly payment) for vehicle ${i + 1}.`);
                  return false;
                }
                if (isNaN(vehicle.loanBalance) || isNaN(vehicle.monthlyPayment)) {
                  alert(`Loan balance and monthly payment for vehicle ${i + 1} must be numbers.`);
                  return false;
                }
                // Ensure that the payment status is selected
                if (!vehicle.currentOnPayments) {
                  alert(`Please select whether payments are current for vehicle ${i + 1}.`);
                  return false;
                }
                if (vehicle.currentOnPayments === "no") {
                  if (!vehicle.monthsBehind) {
                    alert(`Please enter how many months behind payments for vehicle ${i + 1}.`);
                    return false;
                  }
                  if (isNaN(vehicle.monthsBehind)) {
                    alert(`Months behind for vehicle ${i + 1} must be a number.`);
                    return false;
                  }
                } else if (vehicle.currentOnPayments !== "yes") {
                  // In case an unexpected value is found
                  alert(`Please select a valid option for payment status on vehicle ${i + 1}.`);
                  return false;
                }
              }
            }
            return true;

            case "spouseVehicleInformation":
                if (answers.spouseVehicles.length === 0) {
                  alert("Please add at least one vehicle.");
                  return false;
                }
                for (let i = 0; i < answers.spouseVehicles.length; i++) {
                  const vehicle = answers.spouseVehicles[i];
                  // Check basic vehicle info
                  if (!vehicle.year || !vehicle.make || !vehicle.model || !vehicle.miles) {
                    alert(`Please complete all details (year, make, model, miles) for vehicle ${i + 1}.`);
                    return false;
                  }
                  // Check that an option was chosen for loan status
                  if (!vehicle.loan) {
                    alert(`Please indicate whether vehicle ${i + 1} is paid off or has a loan.`);
                    return false;
                  }
                  // If the vehicle has a loan, validate loan details and payment status
                  if (vehicle.loan === "loan") {
                    if (!vehicle.creditor || !vehicle.loanBalance || !vehicle.monthlyPayment) {
                      alert(`Please complete loan details (creditor, loan balance, monthly payment) for vehicle ${i + 1}.`);
                      return false;
                    }
                    if (isNaN(vehicle.loanBalance) || isNaN(vehicle.monthlyPayment)) {
                      alert(`Loan balance and monthly payment for vehicle ${i + 1} must be numbers.`);
                      return false;
                    }
                    // Ensure that the payment status is selected
                    if (!vehicle.currentOnPayments) {
                      alert(`Please select whether payments are current for vehicle ${i + 1}.`);
                      return false;
                    }
                    if (vehicle.currentOnPayments === "no") {
                      if (!vehicle.monthsBehind) {
                        alert(`Please enter how many months behind payments for vehicle ${i + 1}.`);
                        return false;
                      }
                      if (isNaN(vehicle.monthsBehind)) {
                        alert(`Months behind for vehicle ${i + 1} must be a number.`);
                        return false;
                      }
                    } else if (vehicle.currentOnPayments !== "yes") {
                      // In case an unexpected value is found
                      alert(`Please select a valid option for payment status on vehicle ${i + 1}.`);
                      return false;
                    }
                  }
                }
                return true;
            case "homeValue":
                if (!answers.homeValue) {
                    alert("Please enter the value of your home.");
                    return false;
                }
                if (isNaN(answers.homeValue)) {
                    alert("Home value must be a number.");
                    return false;
                }
                return true;
        
    // PART 4: Real Estate Information
    if (currentStepKey === "ownsHome") {
        if (!answers.ownsHome) {
          alert("Please indicate if you own your home.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "homeOwnershipType") {
        if (answers.ownsHome === "yes" && answers.maritalStatus === "married" && !answers.homeOwnershipType) {
          alert("Please indicate your home ownership type (I own, my spouse owns, or we own together).");
          return false;
        }
        return true;
      }
      if (currentStepKey === "homeOwnershipDetail") {
        if (answers.ownsHome === "yes" && answers.maritalStatus !== "married" && !answers.homeOwnershipType) {
          alert("Please indicate if you own your home jointly with someone else.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "homeValue") {
        if (answers.ownsHome === "yes" && !answers.homeValue) {
          alert("Please enter the estimated value of your home.");
          return false;
        }
        if (!isNumeric(answers.homeValue)) {
          alert("Home value must be a number.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "hasMortgage") {
        if (answers.ownsHome === "yes" && !answers.hasMortgage) {
          alert("Please indicate if your home has a mortgage.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "mortgageCreditor") {
        if (answers.hasMortgage === "yes" && !answers.mortgageCreditor) {
          alert("Please enter your mortgage creditor.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "mortgageBalancePayment") {
        if (answers.hasMortgage === "yes") {
          if (!answers.mortgageBalance || !answers.mortgageMonthlyPayment) {
            alert("Please enter your mortgage balance and monthly payment.");
            return false;
          }
          if (!isNumeric(answers.mortgageBalance) || !isNumeric(answers.mortgageMonthlyPayment)) {
            alert("Mortgage balance and monthly payment must be numbers.");
            return false;
          }
        }
        return true;
      }
      if (currentStepKey === "mortgagePaymentStatus") {
        if (answers.hasMortgage === "yes" && !answers.mortgagePaymentStatus) {
          alert("Please indicate if your mortgage payments are current.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "mortgageMonthsBehind") {
        if (answers.mortgagePaymentStatus === "no") {
          if (!answers.mortgageMonthsBehind) {
            alert("Please enter how many months you are behind on your mortgage.");
            return false;
          }
          if (!isNumeric(answers.mortgageMonthsBehind)) {
            alert("Months behind must be a number.");
            return false;
          }
        }
        return true;
      }
      if (currentStepKey === "hasSecondMortgage") {
        if (answers.hasMortgage === "yes" && !answers.hasSecondMortgage) {
          alert("Please indicate if your home has a second mortgage.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "secondMortgageCreditor") {
        if (answers.hasSecondMortgage === "yes" && !answers.secondMortgageCreditor) {
          alert("Please enter your second mortgage creditor.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "secondMortgageBalancePayment") {
        if (answers.hasSecondMortgage === "yes") {
          if (!answers.secondMortgageBalance || !answers.secondMortgageMonthlyPayment) {
            alert("Please enter your second mortgage balance and monthly payment.");
            return false;
          }
          if (!isNumeric(answers.secondMortgageBalance) || !isNumeric(answers.secondMortgageMonthlyPayment)) {
            alert("Second mortgage balance and monthly payment must be numbers.");
            return false;
          }
        }
        return true;
      }
      if (currentStepKey === "secondMortgagePaymentStatus") {
        if (answers.hasSecondMortgage === "yes" && !answers.secondMortgagePaymentStatus) {
          alert("Please indicate if your second mortgage payments are current.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "secondMortgageMonthsBehind") {
        if (answers.secondMortgagePaymentStatus === "no") {
          if (!answers.secondMortgageMonthsBehind) {
            alert("Please enter how many months you are behind on your second mortgage.");
            return false;
          }
          if (!isNumeric(answers.secondMortgageMonthsBehind)) {
            alert("Months behind on second mortgage must be a number.");
            return false;
          }
        }
        return true;
      }
      if (currentStepKey === "hasOtherRealEstate") {
        if (!answers.hasOtherRealEstate) {
          alert("Please indicate if you have other real estate.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "otherRealEstateInformation") {
        if (answers.hasOtherRealEstate === "yes") {
          if (!answers.otherRealEstateProperties || answers.otherRealEstateProperties.length === 0) {
            alert("Please add at least one other real estate property.");
            return false;
          }
          for (let i = 0; i < answers.otherRealEstateProperties.length; i++) {
            const prop = answers.otherRealEstateProperties[i];
            if (!prop.street || !prop.city || !prop.state || !prop.zip) {
              alert(`Please complete the address for property ${i + 1}.`);
              return false;
            }
            if (!/^\d{5}$/.test(prop.zip)) {
              alert(`Zip code for property ${i + 1} must be exactly 5 digits.`);
              return false;
            }
            if (!isValidState(prop.state)) {
              alert(`Please enter a valid state for property ${i + 1}.`);
              return false;
            }
            if (!prop.value || !isNumeric(prop.value)) {
              alert(`Please enter a valid estimated value for property ${i + 1}.`);
              return false;
            }
          }
        }
        return true;
      }
      if (currentStepKey === "spouseHasOtherRealEstate") {
        if (answers.maritalStatus === "married" && answers.spouseFiling === "yes" && !answers.spouseHasOtherRealEstate) {
          alert("Please indicate if your spouse has other real estate.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "spouseOtherRealEstateInformation") {
        if (answers.maritalStatus === "married" && answers.spouseFiling === "yes" && answers.spouseHasOtherRealEstate === "yes") {
          if (!answers.spouseOtherRealEstateProperties || answers.spouseOtherRealEstateProperties.length === 0) {
            alert("Please add at least one other real estate property for your spouse.");
            return false;
          }
          for (let i = 0; i < answers.spouseOtherRealEstateProperties.length; i++) {
            const prop = answers.spouseOtherRealEstateProperties[i];
            if (!prop.street || !prop.city || !prop.state || !prop.zip) {
              alert(`Please complete the address for spouse's property ${i + 1}.`);
              return false;
            }
            if (!/^\d{5}$/.test(prop.zip)) {
              alert(`Zip code for spouse's property ${i + 1} must be exactly 5 digits.`);
              return false;
            }
            if (!isValidState(prop.state)) {
              alert(`Please enter a valid state for spouse's property ${i + 1}.`);
              return false;
            }
            if (!prop.value || !isNumeric(prop.value)) {
              alert(`Please enter a valid estimated value for spouse's property ${i + 1}.`);
              return false;
            }
          }
        }
        return true;
      }
  
      // PART 5: Unsecured Debt Information (Respondent)
      if (currentStepKey === "creditCardDebt") {
        if (!answers.creditCardDebt) {
          alert("Please indicate if you have credit card debt.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "creditCardDebtDetails") {
        if (answers.creditCardDebt === "yes") {
          if (!answers.creditCardDebtDetails || answers.creditCardDebtDetails.length === 0) {
            alert("Please add at least one credit card debt entry.");
            return false;
          }
          for (let i = 0; i < answers.creditCardDebtDetails.length; i++) {
            const debt = answers.creditCardDebtDetails[i];
            if (!debt.creditor) {
              alert(`Please enter the creditor for credit card debt entry ${i + 1}.`);
              return false;
            }
            if (!debt.debtBalance || !isNumeric(debt.debtBalance)) {
              alert(`Please enter a valid debt balance for credit card debt entry ${i + 1}.`);
              return false;
            }
          }
        }
        return true;
      }
      if (currentStepKey === "personalLoanDebt") {
        if (!answers.personalLoanDebt) {
          alert("Please indicate if you have personal loan debt.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "personalLoanDebtDetails") {
        if (answers.personalLoanDebt === "yes") {
          if (!answers.personalLoanDebtDetails || answers.personalLoanDebtDetails.length === 0) {
            alert("Please add at least one personal loan debt entry.");
            return false;
          }
          for (let i = 0; i < answers.personalLoanDebtDetails.length; i++) {
            const debt = answers.personalLoanDebtDetails[i];
            if (!debt.creditor) {
              alert(`Please enter the creditor for personal loan debt entry ${i + 1}.`);
              return false;
            }
            if (!debt.debtBalance || !isNumeric(debt.debtBalance)) {
              alert(`Please enter a valid debt balance for personal loan debt entry ${i + 1}.`);
              return false;
            }
          }
        }
        return true;
      }
      if (currentStepKey === "medicalDebt") {
        if (!answers.medicalDebt) {
          alert("Please indicate if you have medical debt.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "medicalDebtDetails") {
        if (answers.medicalDebt === "yes") {
          if (!answers.medicalDebtDetails || answers.medicalDebtDetails.length === 0) {
            alert("Please add at least one medical debt entry.");
            return false;
          }
          for (let i = 0; i < answers.medicalDebtDetails.length; i++) {
            const debt = answers.medicalDebtDetails[i];
            if (!debt.creditor) {
              alert(`Please enter the creditor for medical debt entry ${i + 1}.`);
              return false;
            }
            if (!debt.amountOwed || !isNumeric(debt.amountOwed)) {
              alert(`Please enter a valid amount for medical debt entry ${i + 1}.`);
              return false;
            }
          }
        }
        return true;
      }
      if (currentStepKey === "studentLoanDebt") {
        if (!answers.studentLoanDebt) {
          alert("Please indicate if you have student loan debt.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "studentLoanDebtDetails") {
        if (answers.studentLoanDebt === "yes") {
          if (!answers.studentLoanDebtDetails || answers.studentLoanDebtDetails.length === 0) {
            alert("Please add at least one student loan debt entry.");
            return false;
          }
          for (let i = 0; i < answers.studentLoanDebtDetails.length; i++) {
            const debt = answers.studentLoanDebtDetails[i];
            if (!debt.creditor) {
              alert(`Please enter the creditor for student loan debt entry ${i + 1}.`);
              return false;
            }
            if (!debt.debtBalance || !isNumeric(debt.debtBalance)) {
              alert(`Please enter a valid debt balance for student loan debt entry ${i + 1}.`);
              return false;
            }
          }
        }
        return true;
      }
      if (currentStepKey === "backTaxes") {
        if (!answers.backTaxDebt) {
          alert("Please indicate if you owe back taxes.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "backTaxesDetails") {
        if (answers.backTaxDebt === "yes") {
          if (!answers.backTaxDebtDetails || answers.backTaxDebtDetails.length === 0) {
            alert("Please add at least one back taxes entry.");
            return false;
          }
          for (let i = 0; i < answers.backTaxDebtDetails.length; i++) {
            const debt = answers.backTaxDebtDetails[i];
            if (!debt.taxType) {
              alert(`Please select the tax type for back taxes entry ${i + 1}.`);
              return false;
            }
            if (debt.taxType === "State" && (!debt.state || !isValidState(debt.state))) {
              alert(`Please enter a valid state for back taxes entry ${i + 1}.`);
              return false;
            }
            if (!debt.year || !isNumeric(debt.year)) {
              alert(`Please enter a valid year for back taxes entry ${i + 1}.`);
              return false;
            }
            if (!debt.amount || !isNumeric(debt.amount)) {
              alert(`Please enter a valid amount for back taxes entry ${i + 1}.`);
              return false;
            }
          }
        }
        return true;
      }
      if (currentStepKey === "otherDebt") {
        if (!answers.otherDebt) {
          alert("Please indicate if you have other debts or liabilities.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "otherDebtDetails") {
        if (answers.otherDebt === "yes") {
          if (!answers.otherDebtDetails || answers.otherDebtDetails.length === 0) {
            alert("Please add at least one other debt entry.");
            return false;
          }
          for (let i = 0; i < answers.otherDebtDetails.length; i++) {
            const debt = answers.otherDebtDetails[i];
            if (!debt.creditor) {
              alert(`Please enter the creditor for other debt entry ${i + 1}.`);
              return false;
            }
            if (!debt.description) {
              alert(`Please enter a description for other debt entry ${i + 1}.`);
              return false;
            }
            if (!debt.amountOwed || !isNumeric(debt.amountOwed)) {
              alert(`Please enter a valid amount for other debt entry ${i + 1}.`);
              return false;
            }
          }
        }
        return true;
      }
  
      // Spouse Unsecured Debt (if spouse is filing)
      if (answers.maritalStatus === "married" && answers.spouseFiling === "yes") {
        if (currentStepKey === "spouseCreditCardDebt") {
          if (!answers.spouseCreditCardDebt) {
            alert("Please indicate if your spouse has credit card debt.");
            return false;
          }
          return true;
        }
        if (currentStepKey === "spouseCreditCardDebtDetails") {
          if (answers.spouseCreditCardDebt === "yes") {
            if (!answers.spouseCreditCardDebtDetails || answers.spouseCreditCardDebtDetails.length === 0) {
              alert("Please add at least one credit card debt entry for your spouse.");
              return false;
            }
            for (let i = 0; i < answers.spouseCreditCardDebtDetails.length; i++) {
              const debt = answers.spouseCreditCardDebtDetails[i];
              if (!debt.creditor) {
                alert(`Please enter the creditor for spouse's credit card debt entry ${i + 1}.`);
                return false;
              }
              if (!debt.debtBalance || !isNumeric(debt.debtBalance)) {
                alert(`Please enter a valid debt balance for spouse's credit card debt entry ${i + 1}.`);
                return false;
              }
            }
          }
          return true;
        }
        if (currentStepKey === "spousePersonalLoanDebt") {
          if (!answers.spousePersonalLoanDebt) {
            alert("Please indicate if your spouse has personal loan debt.");
            return false;
          }
          return true;
        }
        if (currentStepKey === "spousePersonalLoanDebtDetails") {
          if (answers.spousePersonalLoanDebt === "yes") {
            if (!answers.spousePersonalLoanDebtDetails || answers.spousePersonalLoanDebtDetails.length === 0) {
              alert("Please add at least one personal loan debt entry for your spouse.");
              return false;
            }
            for (let i = 0; i < answers.spousePersonalLoanDebtDetails.length; i++) {
              const debt = answers.spousePersonalLoanDebtDetails[i];
              if (!debt.creditor) {
                alert(`Please enter the creditor for spouse's personal loan debt entry ${i + 1}.`);
                return false;
              }
              if (!debt.debtBalance || !isNumeric(debt.debtBalance)) {
                alert(`Please enter a valid debt balance for spouse's personal loan debt entry ${i + 1}.`);
                return false;
              }
            }
          }
          return true;
        }
        if (currentStepKey === "spouseMedicalDebt") {
          if (!answers.spouseMedicalDebt) {
            alert("Please indicate if your spouse has medical debt.");
            return false;
          }
          return true;
        }
        if (currentStepKey === "spouseMedicalDebtDetails") {
          if (answers.spouseMedicalDebt === "yes") {
            if (!answers.spouseMedicalDebtDetails || answers.spouseMedicalDebtDetails.length === 0) {
              alert("Please add at least one medical debt entry for your spouse.");
              return false;
            }
            for (let i = 0; i < answers.spouseMedicalDebtDetails.length; i++) {
              const debt = answers.spouseMedicalDebtDetails[i];
              if (!debt.creditor) {
                alert(`Please enter the creditor for spouse's medical debt entry ${i + 1}.`);
                return false;
              }
              if (!debt.amountOwed || !isNumeric(debt.amountOwed)) {
                alert(`Please enter a valid amount for spouse's medical debt entry ${i + 1}.`);
                return false;
              }
            }
          }
          return true;
        }
        if (currentStepKey === "spouseStudentLoanDebt") {
          if (!answers.spouseStudentLoanDebt) {
            alert("Please indicate if your spouse has student loan debt.");
            return false;
          }
          return true;
        }
        if (currentStepKey === "spouseStudentLoanDebtDetails") {
          if (answers.spouseStudentLoanDebt === "yes") {
            if (!answers.spouseStudentLoanDebtDetails || answers.spouseStudentLoanDebtDetails.length === 0) {
              alert("Please add at least one student loan debt entry for your spouse.");
              return false;
            }
            for (let i = 0; i < answers.spouseStudentLoanDebtDetails.length; i++) {
              const debt = answers.spouseStudentLoanDebtDetails[i];
              if (!debt.creditor) {
                alert(`Please enter the creditor for spouse's student loan debt entry ${i + 1}.`);
                return false;
              }
              if (!debt.debtBalance || !isNumeric(debt.debtBalance)) {
                alert(`Please enter a valid debt balance for spouse's student loan debt entry ${i + 1}.`);
                return false;
              }
            }
          }
          return true;
        }
        if (currentStepKey === "spouseBackTaxes") {
          if (!answers.spouseBackTaxDebt) {
            alert("Please indicate if your spouse owes back taxes.");
            return false;
          }
          return true;
        }
        if (currentStepKey === "spouseBackTaxesDetails") {
          if (answers.spouseBackTaxDebt === "yes") {
            if (!answers.spouseBackTaxDebtDetails || answers.spouseBackTaxDebtDetails.length === 0) {
              alert("Please add at least one back taxes entry for your spouse.");
              return false;
            }
            for (let i = 0; i < answers.spouseBackTaxDebtDetails.length; i++) {
              const debt = answers.spouseBackTaxDebtDetails[i];
              if (!debt.taxType) {
                alert(`Please select the tax type for spouse's back taxes entry ${i + 1}.`);
                return false;
              }
              if (debt.taxType === "State" && (!debt.state || !isValidState(debt.state))) {
                alert(`Please enter a valid state for spouse's back taxes entry ${i + 1}.`);
                return false;
              }
              if (!debt.year || !isNumeric(debt.year)) {
                alert(`Please enter a valid year for spouse's back taxes entry ${i + 1}.`);
                return false;
              }
              if (!debt.amount || !isNumeric(debt.amount)) {
                alert(`Please enter a valid amount for spouse's back taxes entry ${i + 1}.`);
                return false;
              }
            }
          }
          return true;
        }
        if (currentStepKey === "spouseOtherDebt") {
          if (!answers.spouseOtherDebt) {
            alert("Please indicate if your spouse has other debts or liabilities.");
            return false;
          }
          return true;
        }
        if (currentStepKey === "spouseOtherDebtDetails") {
          if (answers.spouseOtherDebt === "yes") {
            if (!answers.spouseOtherDebtDetails || answers.spouseOtherDebtDetails.length === 0) {
              alert("Please add at least one other debt entry for your spouse.");
              return false;
            }
            for (let i = 0; i < answers.spouseOtherDebtDetails.length; i++) {
              const debt = answers.spouseOtherDebtDetails[i];
              if (!debt.creditor) {
                alert(`Please enter the creditor for spouse's other debt entry ${i + 1}.`);
                return false;
              }
              if (!debt.description) {
                alert(`Please enter a description for spouse's other debt entry ${i + 1}.`);
                return false;
              }
              if (!debt.amountOwed || !isNumeric(debt.amountOwed)) {
                alert(`Please enter a valid amount for spouse's other debt entry ${i + 1}.`);
                return false;
              }
            }
          }
          return true;
        }
    }
      // PART 6: Expense Information
      // 1. Rent (if they do not own their home)
      if (currentStepKey === "payRent") {
        if (answers.ownsHome !== "yes") {
          if (!answers.payRent) {
            alert("Please indicate if you pay rent.");
            return false;
          }
        }
        return true;
      }
      if (currentStepKey === "rentAmount") {
        if (answers.payRent === "yes") {
          if (!answers.rentAmount) {
            alert("Please enter your monthly rent.");
            return false;
          }
          if (!isNumeric(answers.rentAmount)) {
            alert("Rent amount must be a number.");
            return false;
          }
        }
        return true;
      }
      // 2. Vehicle insurance (if they own vehicles)
      if (currentStepKey === "vehicleInsurance") {
        if (answers.hasVehicle === "yes") {
          if (!answers.vehicleInsurance) {
            alert("Please enter your total monthly vehicle insurance cost.");
            return false;
          }
          if (!isNumeric(answers.vehicleInsurance)) {
            alert("Vehicle insurance must be a number.");
            return false;
          }
        }
        return true;
      }
      // 3. Child Support
      if (currentStepKey === "childSupport") {
        if (!answers.childSupport) {
          alert("Please indicate if you pay child support.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "childSupportAmount") {
        if (answers.childSupport === "yes") {
          if (!answers.childSupportAmount) {
            alert("Please enter the monthly child support amount.");
            return false;
          }
          if (!isNumeric(answers.childSupportAmount)) {
            alert("Child support amount must be a number.");
            return false;
          }
        }
        return true;
      }
      if (currentStepKey === "childSupportDeducted") {
        if (answers.childSupport === "yes" && !answers.childSupportDeducted) {
          alert("Please indicate if child support is deducted from your wages.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "childSupportArrearage") {
        if (answers.childSupport === "yes" && !answers.childSupportArrearage) {
          alert("Please indicate if you have child support arrearage.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "childSupportArrearageAmount") {
        if (answers.childSupportArrearage === "yes") {
          if (!answers.childSupportArrearageAmount) {
            alert("Please enter the amount of child support arrearage.");
            return false;
          }
          if (!isNumeric(answers.childSupportArrearageAmount)) {
            alert("Child support arrearage must be a number.");
            return false;
          }
        }
        return true;
      }
      // 4. Alimony
      if (currentStepKey === "alimony") {
        if (!answers.alimony) {
          alert("Please indicate if you pay alimony.");
          return false;
        }
        return true;
      }
      if (currentStepKey === "alimonyAmount") {
        if (answers.alimony === "yes") {
          if (!answers.alimonyAmount) {
            alert("Please enter the monthly alimony amount.");
            return false;
          }
          if (!isNumeric(answers.alimonyAmount)) {
            alert("Alimony amount must be a number.");
            return false;
          }
        }
        return true;
      }
      // Spouse Expense Information (if spouse is filing)
      if (answers.maritalStatus === "married" && answers.spouseFiling === "yes") {
        if (currentStepKey === "spouseChildSupport") {
          if (!answers.spouseChildSupport) {
            alert("Please indicate if your spouse pays child support.");
            return false;
          }
          return true;
        }
        if (currentStepKey === "spouseChildSupportAmount") {
          if (answers.spouseChildSupport === "yes") {
            if (!answers.spouseChildSupportAmount) {
              alert("Please enter your spouse's monthly child support amount.");
              return false;
            }
            if (!isNumeric(answers.spouseChildSupportAmount)) {
              alert("Child support amount must be a number.");
              return false;
            }
          }
          return true;
        }
        if (currentStepKey === "spouseChildSupportDeducted") {
          if (answers.spouseChildSupport === "yes" && !answers.spouseChildSupportDeducted) {
            alert("Please indicate if your spouse's child support is deducted from wages.");
            return false;
          }
          return true;
        }
        if (currentStepKey === "spouseChildSupportArrearage") {
          if (answers.spouseChildSupport === "yes" && !answers.spouseChildSupportArrearage) {
            alert("Please indicate if your spouse has child support arrearage.");
            return false;
          }
          return true;
        }

        if (currentStepKey === "spouseChildSupportArrearageAmount") {
          if (answers.spouseChildSupportArrearage === "yes") {
            if (!answers.spouseChildSupportArrearageAmount) {
              alert("Please enter the amount of your spouse's child support arrearage.");
              return false;
            }
            if (!isNumeric(answers.spouseChildSupportArrearageAmount)) {
              alert("Child support arrearage must be a number.");
              return false;
            }
          }
          return true;
        }
        if (currentStepKey === "spouseAlimony") {
          if (!answers.spouseAlimony) {
            alert("Please indicate if your spouse pays alimony.");
            return false;
          }
          return true;
        }
        if (currentStepKey === "spouseAlimonyAmount") {
          if (answers.spouseAlimony === "yes") {
            if (!answers.spouseAlimonyAmount) {
              alert("Please enter your spouse's monthly alimony amount.");
              return false;
            }
            if (!isNumeric(answers.spouseAlimonyAmount)) {
              alert("Alimony amount must be a number.");
              return false;
            }
          }
          return true;
        }
      }
  
      // If no case matches, assume validation passes.
      return true;
            }
      
    };
  
    const nextStepValidated = async () => {
      if (await validateStep()) {
        nextStep();
        const part1Length = getPart1Steps(answers).length;
        const isPart1Final = currentStep === part1Length;
        const part2Length = getPart2Steps(answers).length;
        const part3Length = getPart3Steps(answers).length;
        const part4Length = getPart4Steps(answers).length;
        const part5Length = getPart5Steps(answers).length;
        const part6Length = getPart6Steps(answers).length;
        const part2Final = currentStep === (part1Length + part2Length);
        if (currentStep === totalSteps || currentStep === part1Length || currentStep === part1Length + part2Length || currentStep === part3Length + part1Length + part2Length || currentStep === part4Length + part3Length + part2Length + part1Length || currentStep === part5Length + part4Length + part3Length + part2Length + part1Length)
        {
          logData(answers);
        }
        
      }
    };
  
    // ----- Render Main Content -----
    const renderMainContent = () => {
      <LoadingModal isOpen={loading} onComplete={onLoaderComplete} />
        {showRec && (
          <Chapter13PlanModal
            isOpen={showRec}
            onClose={() => setShowRec(false)}
            recommendationResult={recResult}
            answers={answers}
            computedValues={recResult.computedValues}
          />
        )}
      // Check for respondent fixed income detail steps.
      if (currentStepKey.startsWith("dependentDetails_")) {
        const depIndex = parseInt(currentStepKey.split("_")[1], 10) - 1;
        // Ensure there is an object for this dependent:
        if (!answers.dependentDetails || !answers.dependentDetails[depIndex]) {
          const newDep = { age: "", relation: "", relationOther: "" };
          let newDetails = answers.dependentDetails ? [...answers.dependentDetails] : [];
          newDetails[depIndex] = newDep;
          // It’s best to update state outside of render, but if needed you can do:
          setAnswers({ ...answers, dependentDetails: newDetails });
        }
        return (
          <div className="main-content">
              <div className="icon-container-intake">
                <DependIcon />
              </div>
            <div className="question-text-container">
              <p className="question-text">
                Enter details for dependent {depIndex + 1}:
              </p>
            </div>
            <div className = "vertical-stack-intake">
            <input 
              type="text"
              name={`dependentAge_${depIndex}`}
              placeholder="Age (years)"
              inputmode="numeric"
              value={answers.dependentDetails[depIndex]?.age || ""}
              onChange={(e) => {
                const newDetails = [...answers.dependentDetails];
                newDetails[depIndex].age = e.target.value;
                setAnswers({ ...answers, dependentDetails: newDetails });
              }}
            />
            <select
              name={`dependentRelation_${depIndex}`}
              value={answers.dependentDetails[depIndex]?.relation || ""}
              onChange={(e) => {
                const newDetails = [...answers.dependentDetails];
                newDetails[depIndex].relation = e.target.value;
                setAnswers({ ...answers, dependentDetails: newDetails });
              }}
            >
              <option value="">Select Relation</option>
              <option value="son">Son</option>
              <option value="daughter">Daughter</option>
              <option value="mother">Mother</option>
              <option value="father">Father</option>
              <option value="other">Other</option>
            </select>
            {answers.dependentDetails[depIndex]?.relation === "other" && (
              <input 
                type="text"
                name={`dependentRelationOther_${depIndex}`}
                placeholder="Please specify"
                value={answers.dependentDetails[depIndex]?.relationOther || ""}
                onChange={(e) => {
                  const newDetails = [...answers.dependentDetails];
                  newDetails[depIndex].relationOther = e.target.value;
                  setAnswers({ ...answers, dependentDetails: newDetails });
                }}
              />
            )}
          </div></div>
        );
      }
      if (currentStepKey.startsWith("fixedIncomeDetails_")) {
        const source = currentStepKey.replace("fixedIncomeDetails_", "");
        return (
          <div className="main-content">
            <div className="icon-container-intake">
                <MoneyIcon />
              </div>
            <div className="question-text-container">
              <p className="question-text">Enter your net monthly income for {source}:</p>
            </div>
            {source === "Other" ? (
              <div className="vertical-stack-intake">
                <input
                  type="text"
                  name="fixedIncomeOtherDesc"
                  placeholder="Describe income source"
                  value={answers.fixedIncomeOtherDesc || ""}
                  onChange={handleChange}
                /><div>$
                <input
                  type="text"
                  inputmode="numeric"
                  name="fixedIncomeOtherAmount"
                  placeholder="Net Monthly Income"
                  value={answers.fixedIncomeDetails["Other"] || ""}
                  onChange={(e) =>
                    setAnswers({
                      ...answers,
                      fixedIncomeDetails: { ...answers.fixedIncomeDetails, Other: e.target.value }
                    })
                  }
                />
              </div></div>
            ) : (<div className="vertical-stack-intake"><div>$
              <input
                type="text"
                name={`fixedIncome_${source}`}
                inputmode="numeric"
                placeholder="Net Monthly Income"
                value={answers.fixedIncomeDetails[source] || ""}
                onChange={(e) =>
                  setAnswers({
                    ...answers,
                    fixedIncomeDetails: { ...answers.fixedIncomeDetails, [source]: e.target.value }
                  })
                }
              /></div></div>
            )}
          </div>
        );
      }
      // Check for spouse fixed income detail steps.
      if (currentStepKey.startsWith("spouseFixedIncomeDetails_")) {
        const source = currentStepKey.replace("spouseFixedIncomeDetails_", "");
        return (
          <div className="main-content">
            <div className="icon-container-intake">
                <MoneyIcon />
              </div>
            <div className="question-text-container">
              <p className="question-text">Enter your spouse's net monthly income for {source}:</p>
            </div>
            {source === "Other" ? (
              <div className="vertical-stack-intake">
                <input
                  type="text"
                  name="spouseFixedIncomeOtherDesc"
                  placeholder="Describe income source"
                  value={answers.spouseFixedIncomeOtherDesc || ""}
                  onChange={handleChange}
                /><div>$
                <input
                  type="text"
                  name="spouseFixedIncomeOtherAmount"
                  inputmode="numeric"
                  placeholder="Net Monthly Income"
                  value={answers.spouseFixedIncomeDetails["Other"] || ""}
                  onChange={(e) =>
                    setAnswers({
                      ...answers,
                      spouseFixedIncomeDetails: { ...answers.spouseFixedIncomeDetails, Other: e.target.value }
                    })
                  }
                />
              </div></div>
            ) : (<div className = "vertical-stack-intake"><div>$
              <input
                type="text"
                name={`spouseFixedIncome_${source}`}
                inputmode="numeric"
                placeholder="Net Monthly Income"
                value={answers.spouseFixedIncomeDetails[source] || ""}
                onChange={(e) =>
                  setAnswers({
                    ...answers,
                    spouseFixedIncomeDetails: { ...answers.spouseFixedIncomeDetails, [source]: e.target.value }
                  })
                }
              /></div></div>
            )}
          </div>
        );
      }
  
      // Standard switch for remaining keys.
      switch (currentStepKey) {
            // ----- PART 6: Expense Information Steps -----
        case "paysRent":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <ReceiptIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">Do you pay rent?</p>
                </div>
                <div className="binary-options">
                <button className={`binary-button ${answers.paysRent==="yes"?"selected":""}`} onClick={() => setBinary("paysRent", "yes")}>Yes</button>
                <button className={`binary-button ${answers.paysRent==="no"?"selected":""}`} onClick={() => setBinary("paysRent", "no")}>No</button>
                </div>
            </div>
            );
        case "rentAmount":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <ReceiptIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">How much is your monthly rent?</p>
                </div><div className = "vertical-stack-intake">
                <input type="text" inputmode="numeric" name="rentAmount" placeholder="Rent Amount" value={answers.rentAmount} onChange={handleChange} />
            </div></div>
            );
        case "vehicleInsurance":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <ReceiptIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">What is your vehicle insurance cost per month?</p>
                </div><div className = "vertical-stack-intake">
                <input type="text" inputmode="numeric" name="vehicleInsurance" placeholder="Insurance Amount" value={answers.vehicleInsurance} onChange={handleChange} />
            </div></div>
            );
        case "childSupport":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <ReceiptIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">Do you pay child support?</p>
                </div>
                <div className="binary-options">
                <button className={`binary-button ${answers.childSupport==="yes"?"selected":""}`} onClick={() => setBinary("childSupport", "yes")}>Yes</button>
                <button className={`binary-button ${answers.childSupport==="no"?"selected":""}`} onClick={() => setBinary("childSupport", "no")}>No</button>
                </div>
            </div>
            );
        case "childSupportAmount":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <ReceiptIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">How much do you pay per month in child support?</p>
                </div><div className = "vertical-stack-intake">
                <input type="text" inputmode="numeric" name="childSupportAmount" placeholder="Child Support Amount" value={answers.childSupportAmount} onChange={handleChange} />
            </div></div>
            );
        case "childSupportDeducted":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <CalcIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">Is your child support deducted directly from your wages?</p>
                </div>
                <div className="binary-options">
                <button className={`binary-button ${answers.childSupportDeducted==="yes"?"selected":""}`} onClick={() => setBinary("childSupportDeducted", "yes")}>Yes</button>
                <button className={`binary-button ${answers.childSupportDeducted==="no"?"selected":""}`} onClick={() => setBinary("childSupportDeducted", "no")}>No</button>
                </div>
            </div>
            );
        case "childSupportArrearage":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <CoinIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">Do you have any child support arrearage?</p>
                </div>
                <div className="binary-options">
                <button className={`binary-button ${answers.childSupportArrearage==="yes"?"selected":""}`} onClick={() => setBinary("childSupportArrearage", "yes")}>Yes</button>
                <button className={`binary-button ${answers.childSupportArrearage==="no"?"selected":""}`} onClick={() => setBinary("childSupportArrearage", "no")}>No</button>
                </div>
            </div>
            );
        case "childSupportArrearageAmount":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <CoinIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">How much is your child support arrearage?</p>
                </div><div className = "vertical-stack-intake">
                <input type="text" inputmode="numeric" name="childSupportArrearageAmount" placeholder="Arrearage Amount" value={answers.childSupportArrearageAmount} onChange={handleChange} />
            </div></div>
            );
        case "alimony":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <ReceiptIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">Do you pay alimony?</p>
                </div>
                <div className="binary-options">
                <button className={`binary-button ${answers.alimony==="yes"?"selected":""}`} onClick={() => setBinary("alimony", "yes")}>Yes</button>
                <button className={`binary-button ${answers.alimony==="no"?"selected":""}`} onClick={() => setBinary("alimony", "no")}>No</button>
                </div>
            </div>
            );
        case "alimonyAmount":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <ReceiptIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">How much do you pay per month in alimony?</p>
                </div><div className = "vertical-stack-intake">
                <input type="text" inputmode="numeric" name="alimonyAmount" placeholder="Amount" value={answers.alimonyAmount} onChange={handleChange} />
            </div></div>
            );
        // Spouse expense information (if spouse is filing)
        case "spouseChildSupport":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <ReceiptIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">Does your spouse pay child support?</p>
                </div>
                <div className="binary-options">
                <button className={`binary-button ${answers.spouseChildSupport==="yes"?"selected":""}`} onClick={() => setBinary("spouseChildSupport", "yes")}>Yes</button>
                <button className={`binary-button ${answers.spouseChildSupport==="no"?"selected":""}`} onClick={() => setBinary("spouseChildSupport", "no")}>No</button>
                </div>
            </div>
            );
        case "spouseChildSupportAmount":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <ReceiptIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">How much does your spouse pay per month in child support?</p>
                </div><div className = "vertical-stack-intake">
                <input type="text" inputmode="numeric" name="spouseChildSupportAmount" placeholder="Amount" value={answers.spouseChildSupportAmount} onChange={handleChange} />
            </div></div>
            );
        case "spouseAlimonyAmount":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <ReceiptIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">How much does your spouse pay per month in alimony?</p>
                </div><div className = "vertical-stack-intake">
                <input type="text" inputmode="numeric" name="spouseAlimonyAmount" placeholder="Amount" value={answers.spouseAlimonyAmount} onChange={handleChange} />
            </div></div>
            );
        case "spouseChildSupportDeducted":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <CalcIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">Is your spouse's child support deducted from their wages?</p>
                </div>
                <div className="binary-options">
                <button className={`binary-button ${answers.spouseChildSupportDeducted==="yes"?"selected":""}`} onClick={() => setBinary("spouseChildSupportDeducted", "yes")}>Yes</button>
                <button className={`binary-button ${answers.spouseChildSupportDeducted==="no"?"selected":""}`} onClick={() => setBinary("spouseChildSupportDeducted", "no")}>No</button>
                </div>
            </div>
            );
        case "spouseChildSupportArrearage":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <CoinIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">Does your spouse have any child support arrearage?</p>
                </div>
                <div className="binary-options">
                <button className={`binary-button ${answers.spouseChildSupportArrearage==="yes"?"selected":""}`} onClick={() => setBinary("spouseChildSupportArrearage", "yes")}>Yes</button>
                <button className={`binary-button ${answers.spouseChildSupportArrearage==="no"?"selected":""}`} onClick={() => setBinary("spouseChildSupportArrearage", "no")}>No</button>
                </div>
            </div>
            );
        case "spouseChildSupportArrearageAmount":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <CoinIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">How much is your spouse's child support arrearage?</p>
                </div><div className = "vertical-stack-intake">
                <input type="text" inputmode="numeric" name="spouseChildSupportArrearageAmount" placeholder="Arrearage Amount" value={answers.spouseChildSupportArrearageAmount} onChange={handleChange} />
            </div></div>
            );
        case "spouseAlimony":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <ReceiptIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">Does your spouse pay alimony?</p>
                </div>
                <div className="binary-options">
                <button className={`binary-button ${answers.spouseAlimony==="yes"?"selected":""}`} onClick={() => setBinary("spouseAlimony", "yes")}>Yes</button>
                <button className={`binary-button ${answers.spouseAlimony==="no"?"selected":""}`} onClick={() => setBinary("spouseAlimony", "no")}>No</button>
                </div>
            </div>
            );

        // For additional real estate (Part 5)
        case "creditCardDebt":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <CardIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">Do you have any credit card debt?</p>
                </div>
                <div className="binary-options">
                  <button className={`binary-button ${answers.creditCardDebt==="yes" ? "selected" : ""}`}
                    onClick={() => setBinary("creditCardDebt", "yes")}>Yes</button>
                  <button className={`binary-button ${answers.creditCardDebt==="no" ? "selected" : ""}`}
                    onClick={() => setBinary("creditCardDebt", "no")}>No</button>
                </div>
              </div>
            );
          case "creditCardDebtDetails":
            if (answers.creditCardDebt !== "yes") return null;
            return (
                <>
                <UnsecuredDebtInformation 
                  debtType="creditCard"
                  debts={answers.creditCardDebtDetails}
                  setDebts={(newDebts) => setAnswers({ ...answers, creditCardDebtDetails: newDebts })}
                  labelPrefix="Your"
                /><p className="text-xs text-gray-500">
                You may approximate and add all creditors together on one debt record for simplicity if you wish
              </p>
                </>
              );
          
          // Repeat similar cases for personal loan debt:
          case "personalLoanDebt":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <CoinIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">Do you have any personal loan debt? (include furniture, affirm, pay-as-you-go debts)</p>
                </div>
                <div className="binary-options">
                  <button className={`binary-button ${answers.personalLoanDebt==="yes" ? "selected" : ""}`}
                    onClick={() => setBinary("personalLoanDebt", "yes")}>Yes</button>
                  <button className={`binary-button ${answers.personalLoanDebt==="no" ? "selected" : ""}`}
                    onClick={() => setBinary("personalLoanDebt", "no")}>No</button>
                </div>
              </div>
            );
          case "personalLoanDebtDetails":
            if (answers.personalLoanDebt !== "yes") return null;
            return (<>
                <UnsecuredDebtInformation 
                  debtType="personalLoan"
                  debts={answers.personalLoanDebtDetails}
                  setDebts={(newDebts) => setAnswers({ ...answers, personalLoanDebtDetails: newDebts })}
                  labelPrefix="Your"
                /><p className="text-xs text-gray-500">
                You may approximate and add all personal loans together on one debt record for simplicity if you wish
              </p>
                </>
              );
          
          // Similarly, add cases for medical debt:
          case "medicalDebt":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <MedicalIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">Do you have any medical debt?</p>
                </div>
                <div className="binary-options">
                  <button className={`binary-button ${answers.medicalDebt==="yes" ? "selected" : ""}`}
                    onClick={() => setBinary("medicalDebt", "yes")}>Yes</button>
                  <button className={`binary-button ${answers.medicalDebt==="no" ? "selected" : ""}`}
                    onClick={() => setBinary("medicalDebt", "no")}>No</button>
                </div>
              </div>
            );
          case "medicalDebtDetails":
            if (answers.medicalDebt !== "yes") return null;
            return (<>
                < UnsecuredDebtInformation 
                  debtType="medical"
                  debts={answers.medicalDebtDetails}
                  setDebts={(newDebts) => setAnswers({ ...answers, medicalDebtDetails: newDebts })}
                  labelPrefix="Your"
                /><p className="text-xs text-gray-500">
                You may approximate and add all medical together on one debt record for simplicity if you wish
              </p>
              </>);
          
          // Student loans:
          case "studentLoanDebt":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <StudentLoansIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">Do you have any student loans?</p>
                </div>
                <div className="binary-options">
                  <button className={`binary-button ${answers.studentLoanDebt==="yes" ? "selected" : ""}`}
                    onClick={() => setBinary("studentLoanDebt", "yes")}>Yes</button>
                  <button className={`binary-button ${answers.studentLoanDebt==="no" ? "selected" : ""}`}
                    onClick={() => setBinary("studentLoanDebt", "no")}>No</button>
                </div>
              </div>
            );
          case "studentLoanDebtDetails":
            if (answers.studentLoanDebt !== "yes") return null;
            return (<>
                <UnsecuredDebtInformation 
                  debtType="studentLoans"
                  debts={answers.studentLoanDebtDetails}
                  setDebts={(newDebts) => setAnswers({ ...answers, studentLoanDebtDetails: newDebts })}
                  labelPrefix="Your"
                /><p className="text-xs text-gray-500">
                You may approximate and add all student loans together on one debt record for simplicity if you wish
              </p>
                </>
              );
            //  Back Taxes
            case "backTaxes":
                return (
                <div className="main-content">
                    <div className="icon-container-intake">
                <BankIcon />
              </div>
                    <div className="question-text-container">
                    <p className="question-text">Do you owe any back taxes?</p>
                    </div>
                    <div className="binary-options">
                    <button
                        className={`binary-button ${answers.backTaxes === "yes" ? "selected" : ""}`}
                        onClick={() => setBinary("backTaxes", "yes")}
                    >
                        Yes
                    </button>
                    <button
                        className={`binary-button ${answers.backTaxes === "no" ? "selected" : ""}`}
                        onClick={() => setBinary("backTaxes", "no")}
                    >
                        No
                    </button>
                    </div>
                </div>
                );
            case "backTaxesDetails":
                if (answers.backTaxes !== "yes") return null;
                return (<>
                    <UnsecuredDebtInformation 
                      debtType="backTaxes"
                      debts={answers.backTaxDebtDetails}
                      setDebts={(newDebts) => setAnswers({ ...answers, backTaxDebtDetails: newDebts })}
                      labelPrefix="Your"
                    /><p className="text-xs text-gray-500">
                    You may approximate but add each tax year separately since it may be considered priority if it is more recent
                  </p>
                </>
                  );
            
            // Spouse Other Debt
            case "otherDebt":
                return (
                <div className="main-content">
                    <div className="icon-container-intake">
                <CoinIcon />
              </div>
                    <div className="question-text-container">
                    <p className="question-text">
                        Do you have any other debt or liabilities? (e.g., unpaid utilities, timeshare, rent-purchase)
                    </p>
                    </div>
                    <div className="binary-options">
                    <button
                        className={`binary-button ${answers.otherDebt === "yes" ? "selected" : ""}`}
                        onClick={() => setBinary("otherDebt", "yes")}
                    >
                        Yes
                    </button>
                    <button
                        className={`binary-button ${answers.otherDebt === "no" ? "selected" : ""}`}
                        onClick={() => setBinary("otherDebt", "no")}
                    >
                        No
                    </button>
                    </div>
                </div>
                );
            case "otherDebtDetails":
                if (answers.otherDebt !== "yes") return null;
                return (<>
                    <UnsecuredDebtInformation 
                      debtType="otherDebt"
                      debts={answers.otherDebtDetails}
                      setDebts={(newDebts) => setAnswers({ ...answers, otherDebtDetails: newDebts })}
                      labelPrefix="Your"
                    /><p className="text-xs text-gray-500">
                    You may approximate and add all other debts together on one debt record for simplicity if you wish
                  </p>
                </>
                  );
            // ----- Spouse Unsecured Debt Information (Part 5) -----
            // Spouse Credit Card Debt
            case "spouseCreditCardDebt":
                return (
                <div className="main-content">
                    <div className="icon-container-intake">
                <CardIcon />
              </div>
                    <div className="question-text-container">
                    <p className="question-text">Do you or your spouse have any credit card debt?</p>
                    </div>
                    <div className="binary-options">
                    <button
                        className={`binary-button ${answers.spouseCreditCardDebt === "yes" ? "selected" : ""}`}
                        onClick={() => setBinary("spouseCreditCardDebt", "yes")}
                    >
                        Yes
                    </button>
                    <button
                        className={`binary-button ${answers.spouseCreditCardDebt === "no" ? "selected" : ""}`}
                        onClick={() => setBinary("spouseCreditCardDebt", "no")}
                    >
                        No
                    </button>
                    </div>
                </div>
                );
            case "spouseCreditCardDebtDetails":
                if (answers.spouseCreditCardDebt !== "yes") return null;
                return (<>
                    <UnsecuredDebtInformation 
                      debtType="creditCard"
                      debts={answers.spouseCreditCardDebtDetails}
                      setDebts={(newDebts) => setAnswers({ ...answers, spouseCreditCardDebtDetails: newDebts })}
                      labelPrefix="Yours and your spouse's"
                    /><p className="text-xs text-gray-500">
                    You may approximate and add all credit card debt together on one debt record for simplicity if you wish. Include both yours and your spouse's credit cards.
                  </p>
                </>
                  );
            
            // Spouse Personal Loan Debt
            case "spousePersonalLoanDebt":
                return (
                <div className="main-content">
                    <div className="icon-container-intake">
                <CoinIcon />
              </div>
                    <div className="question-text-container">
                    <p className="question-text">
                        Do you or your spouse have any personal loan debt? (include furniture, affirm, pay-as-you-go debts)
                    </p>
                    </div>
                    <div className="binary-options">
                    <button
                        className={`binary-button ${answers.spousePersonalLoanDebt === "yes" ? "selected" : ""}`}
                        onClick={() => setBinary("spousePersonalLoanDebt", "yes")}
                    >
                        Yes
                    </button>
                    <button
                        className={`binary-button ${answers.spousePersonalLoanDebt === "no" ? "selected" : ""}`}
                        onClick={() => setBinary("spousePersonalLoanDebt", "no")}
                    >
                        No
                    </button>
                    </div>
                </div>
                );
            case "spousePersonalLoanDebtDetails":
                if (answers.spousePersonalLoanDebt !== "yes") return null;
                return (<>
                    <UnsecuredDebtInformation 
                      debtType="personalLoan"
                      debts={answers.spousePersonalLoanDebtDetails}
                      setDebts={(newDebts) => setAnswers({ ...answers, spousePersonalLoanDebtDetails: newDebts })}
                      labelPrefix="Yours and your spouse's"
                    /><p className="text-xs text-gray-500">
                    You may approximate and add all personal loan debt together on one debt record for simplicity if you wish. Include both yours and your spouse's personal loans.
                  </p>
                </>
                  );
            
            // Spouse Medical Debt
            case "spouseMedicalDebt":
                return (
                <div className="main-content">
                    <div className="icon-container-intake">
                <MedicalIcon />
              </div>
                    <div className="question-text-container">
                    <p className="question-text">Do you or your spouse have any medical debt?</p>
                    </div>
                    <div className="binary-options">
                    <button
                        className={`binary-button ${answers.spouseMedicalDebt === "yes" ? "selected" : ""}`}
                        onClick={() => setBinary("spouseMedicalDebt", "yes")}
                    >
                        Yes
                    </button>
                    <button
                        className={`binary-button ${answers.spouseMedicalDebt === "no" ? "selected" : ""}`}
                        onClick={() => setBinary("spouseMedicalDebt", "no")}
                    >
                        No
                    </button>
                    </div>
                </div>
                );
            case "spouseMedicalDebtDetails":
                if (answers.spouseMedicalDebt !== "yes") return null;
                return (<>
                    <UnsecuredDebtInformation 
                      debtType="medical"
                      debts={answers.spouseMedicalDebtDetails}
                      setDebts={(newDebts) => setAnswers({ ...answers, spouseMedicalDebtDetails: newDebts })}
                      labelPrefix="Yours and your spouse's"
                    /><p className="text-xs text-gray-500">
                    You may approximate and add all medical debt together on one debt record for simplicity if you wish. Include both yours and your spouse's medical.
                  </p>
                </>
                  );
            case "spousePriorPayType":
            return (
                <div className="main-content">
                    <div className="icon-container-intake">
                    <PaidIcon />
                    </div>
                <div className="question-text-container">
                    <p className="question-text">
                    How was your spouse paid in their prior employment?
                    </p>
                </div>
                <div className="binary-options">
                    <button
                    className={`binary-button ${answers.spousePriorPayType === "hourly" ? "selected" : ""}`}
                    onClick={() => setBinary("spousePriorPayType", "hourly")}
                    >
                    Hourly
                    </button>
                    <button
                    className={`binary-button ${answers.spousePriorPayType === "salary" ? "selected" : ""}`}
                    onClick={() => setBinary("spousePriorPayType", "salary")}
                    >
                    salary
                    </button>
                    <button
                    className={`binary-button ${answers.spousePriorPayType === "self-employed" ? "selected" : ""}`}
                    onClick={() => setBinary("spousePriorPayType", "self-employed")}
                    >
                    Self-Employed/1099
                    </button>
                </div>
                </div>
            );
    
            case "spousePriorHourlyDetails":
            return (
                <div className="main-content">
                    <div className="icon-container-intake">
                    <PaidIcon />
                    </div>
                <div className="question-text-container">
                    <p className="question-text">
                    What was your spouse's hourly rate and how many hours per week did they work?
                    </p>
                </div><div className="vertical-stack-intake"><div>$
                <input
                    type="text"
                    inputmode="numeric"
                    name="spousePriorHourlyRate"
                    placeholder="Hourly Rate"
                    value={answers.spousePriorHourlyRate}
                    onChange={handleChange}
                /></div>
                <input
                    type="text"
                    inputmode="numeric"
                    name="spousePriorHoursWorked"
                    placeholder="Hours Worked per Week"
                    value={answers.spousePriorHoursWorked}
                    onChange={handleChange}
                />
                </div></div>
            );
    
            case "spousePriorSalaryDetails":
            return (
                <div className="main-content">
                    <div className="icon-container-intake">
                    <PaidIcon />
                    </div>
                <div className="question-text-container">
                    <p className="question-text">
                    What was your spouse's yearly salary? (including bonuses).
                    </p>
                </div><div className="vertical-stack-intake"><div>$
                <input
                    type="text"
                    inputmode="numeric"
                    name="spousePriorYearlySalary"
                    placeholder="Yearly Salary"
                    value={answers.spousePriorYearlySalary}
                    onChange={handleChange}
                />
                </div></div></div>
            );
    
            case "spousePriorNetProfit":
            return (
                <div className="main-content">
                    <div className="icon-container-intake">
                    <PaidIcon />
                    </div>
                <div className="question-text-container">
                    <p className="question-text">
                    What was your spouse's net monthly profit?
                    </p>
                </div><div className="vertical-stack-intake"><div>$
                <input
                    type="text"
                    inputmode="numeric"
                    name="spousePriorNetProfit"
                    placeholder="Monthly Net Profit"
                    value={answers.spousePriorNetProfit}
                    onChange={handleChange}
                />
                </div></div></div>
            );
            case "priorPayType":
            return (
                <div className="main-content">
                    <div className="icon-container-intake">
                    <PaidIcon />
                    </div>
                <div className="question-text-container">
                    <p className="question-text">
                    How were you paid in your prior employment?
                    </p>
                </div>
                <div className="binary-options">
                    <button
                    className={`binary-button ${answers.priorPayType === "hourly" ? "selected" : ""}`}
                    onClick={() => setBinary("priorPayType", "hourly")}
                    >
                    Hourly
                    </button>
                    <button
                    className={`binary-button ${answers.priorPayType === "salary" ? "selected" : ""}`}
                    onClick={() => setBinary("priorPayType", "salary")}
                    >
                    salary
                    </button>
                    <button
                    className={`binary-button ${answers.priorPayType === "self-employed" ? "selected" : ""}`}
                    onClick={() => setBinary("priorPayType", "self-employed")}
                    >
                    Self-Employed/1099
                    </button>
                </div>
                </div>
            );
    
            case "priorHourlyDetails":
            return (
                <div className="main-content">
                    <div className="icon-container-intake">
                    <PaidIcon />
                    </div>
                <div className="question-text-container">
                    <p className="question-text">
                    What was your hourly rate and how many hours per week did you work?
                    </p>
                </div><div className="vertical-stack-intake"><div>$
                <input
                    type="text"
                    inputmode="numeric"
                    name="priorHourlyRate"
                    placeholder="Hourly Rate"
                    value={answers.priorHourlyRate}
                    onChange={handleChange}
                /></div>
                <input
                    type="text"
                    inputmode="numeric"
                    name="priorHoursWorked"
                    placeholder="Hours Worked per Week"
                    value={answers.priorHoursWorked}
                    onChange={handleChange}
                />
                </div></div>
            );
    
            case "priorSalaryDetails":
            return (
                <div className="main-content">
                    <div className="icon-container-intake">
                    <PaidIcon />
                    </div>
                <div className="question-text-container">
                    <p className="question-text">
                    What was your salary? (including bonuses).
                    </p>
                </div><div className="vertical-stack-intake"><div>$
                <input
                    type="text"
                    inputmode="numeric"
                    name="priorYearlySalary"
                    placeholder="Yearly Salary"
                    value={answers.priorYearlySalary}
                    onChange={handleChange}
                />
                </div></div></div>
            );
    
            case "priorNetProfit":
            return (
                <div className="main-content">
                    <div className="icon-container-intake">
                    <PaidIcon />
                    </div>
                <div className="question-text-container">
                    <p className="question-text">
                    What was your net monthly profit?
                    </p>
                </div>
                <input
                    type="text"
                    inputmode="numeric"
                    name="priorNetProfit"
                    placeholder="Monthly Net Profit"
                    value={answers.priorNetProfit}
                    onChange={handleChange}
                />
                </div>
            );
            // Spouse Student Loan Debt
            case "spouseStudentLoanDebt":
                return (
                <div className="main-content">
                    <div className="icon-container-intake">
                <StudentLoansIcon />
              </div>
                    <div className="question-text-container">
                    <p className="question-text">Do you or your spouse have any student loans?</p>
                    </div>
                    <div className="binary-options">
                    <button
                        className={`binary-button ${answers.spouseStudentLoanDebt === "yes" ? "selected" : ""}`}
                        onClick={() => setBinary("spouseStudentLoanDebt", "yes")}
                    >
                        Yes
                    </button>
                    <button
                        className={`binary-button ${answers.spouseStudentLoanDebt === "no" ? "selected" : ""}`}
                        onClick={() => setBinary("spouseStudentLoanDebt", "no")}
                    >
                        No
                    </button>
                    </div>
                </div>
                );
            case "spouseStudentLoanDebtDetails":
                if (answers.spouseStudentLoanDebt !== "yes") return null;
                return (<>
                    <UnsecuredDebtInformation 
                      debtType="studentLoans"
                      debts={answers.spouseStudentLoanDebtDetails}
                      setDebts={(newDebts) => setAnswers({ ...answers, spouseStudentLoanDebtDetails: newDebts })}
                      labelPrefix="Yours and your spouse's"
                    /><p className="text-xs text-gray-500">
                    You may approximate and add all student loan debt together on one debt record for simplicity if you wish. Include both yours and your spouse's student loans.
                  </p>
                    </>
                  );
            
            // Spouse Back Taxes
            case "spouseBackTaxes":
                return (
                <div className="main-content">
                    <div className="icon-container-intake">
                <BankIcon />
              </div>
                    <div className="question-text-container">
                    <p className="question-text">Do you or your spouse owe any back taxes?</p>
                    </div>
                    <div className="binary-options">
                    <button
                        className={`binary-button ${answers.spouseBackTaxes === "yes" ? "selected" : ""}`}
                        onClick={() => setBinary("spouseBackTaxes", "yes")}
                    >
                        Yes
                    </button>
                    <button
                        className={`binary-button ${answers.spouseBackTaxes === "no" ? "selected" : ""}`}
                        onClick={() => setBinary("spouseBackTaxes", "no")}
                    >
                        No
                    </button>
                    </div>
                </div>
                );
            case "spouseBackTaxesDetails":
                if (answers.spouseBackTaxes !== "yes") return null;
                return (<>
                    <UnsecuredDebtInformation 
                      debtType="backTaxes"
                      debts={answers.spouseBackTaxDebtDetails}
                      setDebts={(newDebts) => setAnswers({ ...answers, spouseBackTaxDebtDetails: newDebts })}
                      labelPrefix="Yours and your spouse's"
                    /><p className="text-xs text-gray-500">
                    You may approximate but add each tax year separately since it may be considered priority if it is more recent
                  </p>
                    </>
                  );
            
            // Spouse Other Debt
            case "spouseOtherDebt":
                return (
                <div className="main-content">
                    <div className="icon-container-intake">
                <CoinIcon />
              </div>
                    <div className="question-text-container">
                    <p className="question-text">
                        Do you or your spouse have any other debt or liabilities? (e.g., unpaid utilities, timeshare, rent-purchase)
                    </p>
                    </div>
                    <div className="binary-options">
                    <button
                        className={`binary-button ${answers.spouseOtherDebt === "yes" ? "selected" : ""}`}
                        onClick={() => setBinary("spouseOtherDebt", "yes")}
                    >
                        Yes
                    </button>
                    <button
                        className={`binary-button ${answers.spouseOtherDebt === "no" ? "selected" : ""}`}
                        onClick={() => setBinary("spouseOtherDebt", "no")}
                    >
                        No
                    </button>
                    </div>
                </div>
                );
            case "spouseOtherDebtDetails":
                if (answers.spouseOtherDebt !== "yes") return null;
                return (<>
                    <UnsecuredDebtInformation 
                      debtType="otherDebt"
                      debts={answers.spouseOtherDebtDetails}
                      setDebts={(newDebts) => setAnswers({ ...answers, spouseOtherDebtDetails: newDebts })}
                      labelPrefix="Yours and your spouse's"
                    /><p className="text-xs text-gray-500">
                    You may approximate and add all other debt together on one debt record for simplicity if you wish. Include both yours and your spouse's other debt.
                  </p>
                </>
                  );
        case "hasOtherRealEstate":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <HomeIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">
                    Do you own any other real estate? (Choose yes if your name is on anyone else's deed or you have inherited land.)
                </p>
                </div>
                <div className="binary-options">
                <button className={`binary-button ${answers.hasOtherRealEstate==="yes" ? "selected" : ""}`}
                    onClick={() => setBinary("hasOtherRealEstate", "yes")}>
                    Yes
                </button>
                <button className={`binary-button ${answers.hasOtherRealEstate==="no" ? "selected" : ""}`}
                    onClick={() => setBinary("hasOtherRealEstate", "no")}>
                    No
                </button>
                </div>
            </div>
            );
        case "otherRealEstateInformation":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <HomeIcon />
              </div>
                <RealEstateInformation
                properties={answers.otherRealEstateProperties}
                setProperties={(newProps) => setAnswers({ ...answers, otherRealEstateProperties: newProps })}
                labelPrefix="Your"
                />
            </div>
            );
        case "spouseHasOtherRealEstate":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <HomeIcon />
              </div>
                <div className="question-text-container">
                <p className="question-text">
                    Does your spouse own any other real estate?
                </p>
                </div>
                <div className="binary-options">
                <button className={`binary-button ${answers.spouseHasOtherRealEstate==="yes" ? "selected" : ""}`}
                    onClick={() => setBinary("spouseHasOtherRealEstate", "yes")}>
                    Yes
                </button>
                <button className={`binary-button ${answers.spouseHasOtherRealEstate==="no" ? "selected" : ""}`}
                    onClick={() => setBinary("spouseHasOtherRealEstate", "no")}>
                    No
                </button>
                </div>
            </div>
            );
        case "spouseOtherRealEstateInformation":
            return (
            <div className="main-content">
                <div className="icon-container-intake">
                <HomeIcon />
              </div>
                <RealEstateInformation
                properties={answers.spouseOtherRealEstateProperties}
                setProperties={(newProps) => setAnswers({ ...answers, spouseOtherRealEstateProperties: newProps })}
                labelPrefix="Spouse's"
                />
            </div>
            );
        case "ownsHome":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <AddressIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">
                    {answers.maritalStatus === "married"
                      ? "Do you (or your spouse) own your home?"
                      : "Do you own your home?"}
                  </p>
                </div>
                <div className="binary-options">
                  <button className={`binary-button ${answers.ownsHome==="yes" ? "selected" : ""}`}
                          onClick={() => setBinary("ownsHome", "yes")}>
                    Yes
                  </button>
                  <button className={`binary-button ${answers.ownsHome==="no" ? "selected" : ""}`}
                          onClick={() => setBinary("ownsHome", "no")}>
                    No
                  </button>
                </div>
              </div>
            );
          case "homeOwnershipType":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <AddressIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">
                    How do you own your home with your spouse?
                  </p>
                </div>
                <div className="binary-options">
                  <button className={`binary-button ${answers.homeOwnershipType==="I own" ? "selected" : ""}`}
                          onClick={() => setBinary("homeOwnershipType", "I own")}>
                    I own
                  </button>
                  <button className={`binary-button ${answers.homeOwnershipType==="My spouse owns" ? "selected" : ""}`}
                          onClick={() => setBinary("homeOwnershipType", "My spouse owns")}>
                    My spouse owns
                  </button>
                  <button className={`binary-button ${answers.homeOwnershipType==="We own together" ? "selected" : ""}`}
                          onClick={() => setBinary("homeOwnershipType", "We own together")}>
                    We own together
                  </button>
                </div>
              </div>
            );
          case "homeOwnershipDetail":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <AddressIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">
                    Do you own your home jointly with someone else?
                  </p>
                </div>
                <div className="binary-options">
                  <button className={`binary-button ${answers.homeOwnershipDetail==="yes" ? "selected" : ""}`}
                          onClick={() => setBinary("homeOwnershipDetail", "yes")}>
                    Yes
                  </button>
                  <button className={`binary-button ${answers.homeOwnershipDetail==="no" ? "selected" : ""}`}
                          onClick={() => setBinary("homeOwnershipDetail", "no")}>
                    No
                  </button>
                </div>
              </div>
            );
          case "homeValue":
            return (
                <div className="main-content">
                    <div className="icon-container-intake">
                <AddressIcon />
              </div>
                <div className="question-text-container">
                    <p className="question-text">
                    What is the value of your home? i.e., how much could it sell for? Consider information from sources like Zillow or your property tax card.
                    </p>
                </div><div className="vertical-stack-intake"><div>$&nbsp;&nbsp;
                <input
                    type="text"
                    inputmode="numeric"
                    name="homeValue"
                    placeholder="Home Value"
                    value={answers.homeValue || ""}
                    onChange={handleChange}
                /></div>
                </div></div>
            );
          case "hasMortgage":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <BankIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">Do you have a mortgage on your home?</p>
                </div>
                <div className="binary-options">
                  <button className={`binary-button ${answers.hasMortgage==="yes" ? "selected" : ""}`}
                          onClick={() => setBinary("hasMortgage", "yes")}>
                    Yes
                  </button>
                  <button className={`binary-button ${answers.hasMortgage==="no" ? "selected" : ""}`}
                          onClick={() => setBinary("hasMortgage", "no")}>
                    No
                  </button>
                </div>
              </div>
            );
          case "mortgageCreditor":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <BankIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">Who is your mortgage creditor?</p>
                </div><div className="vertical-stack-intake">
                <input type="text" name="mortgageCreditor" placeholder="Mortgage Creditor" value={answers.mortgageCreditor} onChange={handleChange} />
              </div></div>
            );
          case "mortgageBalancePayment":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <BankIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">What is your mortgage balance and monthly payment?</p>
                </div><div className="vertical-stack-intake"><div>$
                <input type="text" inputmode="numeric" name="mortgageBalance" placeholder="Mortgage Balance" value={answers.mortgageBalance} onChange={handleChange} /></div><div>$
                <input type="text" inputmode="numeric" name="mortgageMonthlyPayment" placeholder="Monthly Payment" value={answers.mortgageMonthlyPayment} onChange={handleChange} />
              </div></div></div>
            );
          case "mortgagePaymentStatus":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <CalendarIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">Are you current on your mortgage payments?</p>
                </div>
                <div className="binary-options">
                  <button className={`binary-button ${answers.mortgagePaymentStatus==="yes" ? "selected" : ""}`}
                          onClick={() => setBinary("mortgagePaymentStatus", "yes")}>
                    Yes
                  </button>
                  <button className={`binary-button ${answers.mortgagePaymentStatus==="no" ? "selected" : ""}`}
                          onClick={() => setBinary("mortgagePaymentStatus", "no")}>
                    No
                  </button>
                </div>
              </div>
            );
          case "mortgageMonthsBehind":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <CalendarIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">How many months are you behind?</p>
                </div><div className="vertical-stack-intake">
                <input type="text" inputmode="numeric" name="mortgageMonthsBehind" placeholder="Months Behind" value={answers.mortgageMonthsBehind} onChange={handleChange} />
              </div></div>
            );
        
            case "hasSecondMortgage":
                return (
                <div className="main-content">
                    <div className="icon-container-intake">
                <BankIcon />
              </div>
                    <div className="question-text-container">
                    <p className="question-text">Do you have a second mortgage on your home?</p>
                    </div>
                    <div className="binary-options">
                    <button className={`binary-button ${answers.hasSecondMortgage==="yes" ? "selected" : ""}`}
                            onClick={() => setBinary("hasSecondMortgage", "yes")}>
                        Yes
                    </button>
                    <button className={`binary-button ${answers.hasSecondMortgage==="no" ? "selected" : ""}`}
                            onClick={() => setBinary("hasSecondMortgage", "no")}>
                        No
                    </button>
                    </div>
                </div>
                );
            
            case "secondMortgageCreditor":
                return (
                <div className="main-content">
                    <div className="icon-container-intake">
                <BankIcon />
              </div>
                    <div className="question-text-container">
                    <p className="question-text">Who is your second mortgage creditor?</p>
                    </div><div className="vertical-stack-intake">
                    <input
                    type="text"
                    name="secondMortgageCreditor"
                    placeholder="Second Mortgage Creditor"
                    value={answers.secondMortgageCreditor}
                    onChange={handleChange}
                    />
                </div></div>
                );
            
            case "secondMortgageBalancePayment":
                return (
                <div className="main-content">
                    <div className="icon-container-intake">
                <BankIcon />
              </div>
                    <div className="question-text-container">
                    <p className="question-text">What is your second mortgage balance and monthly payment?</p>
                    </div><div className="vertical-stack-intake"><div>$
                    <input
                    type="text"
                    inputmode="numeric"
                    name="secondMortgageBalance"
                    placeholder="Balance"
                    value={answers.secondMortgageBalance}
                    onChange={handleChange}
                    /></div><div>$
                    <input
                    type="text"
                    inputmode="numeric"
                    name="secondMortgageMonthlyPayment"
                    placeholder="Monthly Payment"
                    value={answers.secondMortgageMonthlyPayment}
                    onChange={handleChange}
                    />
                </div></div></div>
                );
            
            case "secondMortgagePaymentStatus":
                return (
                <div className="main-content">
                    <div className="icon-container-intake">
                <CalendarIcon />
              </div>
                    <div className="question-text-container">
                    <p className="question-text">Are you current on your second mortgage payments?</p>
                    </div>
                    <div className="binary-options">
                    <button className={`binary-button ${answers.secondMortgagePaymentStatus==="yes" ? "selected" : ""}`}
                            onClick={() => setBinary("secondMortgagePaymentStatus", "yes")}>
                        Yes
                    </button>
                    <button className={`binary-button ${answers.secondMortgagePaymentStatus==="no" ? "selected" : ""}`}
                            onClick={() => setBinary("secondMortgagePaymentStatus", "no")}>
                        No
                    </button>
                    </div>
                </div>
                );
            
            case "secondMortgageMonthsBehind":
                return (
                <div className="main-content">
                    <div className="icon-container-intake">
                <CalendarIcon />
              </div>
                    <div className="question-text-container">
                    <p className="question-text">How many months are you behind on your second mortgage payments?</p>
                    </div><div className="vertical-stack-intake">
                    <input
                    type="text"
                    inputmode="numeric"
                    name="secondMortgageMonthsBehind"
                    placeholder="Months Behind"
                    value={answers.secondMortgageMonthsBehind}
                    onChange={handleChange}
                    />
                </div></div>
                );
        case "hasVehicle":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <CarIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">Are you on the title to any vehicles?</p>
                </div>
                <div className="binary-options">
                  <button
                    className={`binary-button ${answers.hasVehicle === "yes" ? "selected" : ""}`}
                    onClick={() => setBinary("hasVehicle", "yes")}
                  >
                    Yes
                  </button>
                  <button
                    className={`binary-button ${answers.hasVehicle === "no" ? "selected" : ""}`}
                    onClick={() => setBinary("hasVehicle", "no")}
                  >
                    No
                  </button>
                </div>
              </div>
            );
          case "vehicleInformation":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <CarIcon />
              </div>
                {/* Import and render your VehicleInformation component */}
                <VehicleInformation
                  vehicles={answers.vehicles}
                  setVehicles={(newVehicles) => setAnswers({ ...answers, vehicles: newVehicles })}
                  labelPrefix="Your"
                />
              </div>
            );
          case "spouseHasVehicle":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <CarIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">Is your spouse on the title to any vehicles you have not already listed?</p>
                </div>
                <div className="binary-options">
                  <button className={`binary-button ${answers.spouseHasVehicle==="yes" ? "selected" : ""}`}
                          onClick={() => setBinary("spouseHasVehicle", "yes")}>
                    Yes
                  </button>
                  <button className={`binary-button ${answers.spouseHasVehicle==="no" ? "selected" : ""}`}
                          onClick={() => setBinary("spouseHasVehicle", "no")}>
                    No
                  </button>
                </div>
              </div>
            );
          case "spouseVehicleInformation":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <CarIcon />
              </div>
                <VehicleInformation
                  vehicles={answers.spouseVehicles}
                  setVehicles={(newVehicles) => setAnswers({ ...answers, spouseVehicles: newVehicles })}
                  labelPrefix="Spouse's"
                />
              </div>
            );
        // ----- Part 1: Personal Information -----
        case "name":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <PersonIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">What is your name?</p>
              </div>
              <div className="name-fields">
                <input type="text" name="firstName" placeholder="First Name" value={answers.firstName} onChange={handleChange} />
                <input type="text" name="middleName" placeholder="Middle Name" value={answers.middleName} onChange={handleChange} />
                <input type="text" name="lastName" placeholder="Last Name" value={answers.lastName} onChange={handleChange} />
              </div>
            </div>
          );
        case "birthday":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <BirthdayIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">What is your birthday?</p>
              </div>
              <input type="date" name="dob" value={answers.dob} onChange={handleChange} className="date-input" />
              <p className="text-xs text-gray-500">
                Your age is used for determine healthcare expenses
              </p>
            </div>
          );
        case "bankruptcyHistory":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <BKIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">Have you filed a bankruptcy before?</p>
              </div>
              <div className="binary-options">
                <button className={`binary-button ${answers.bankruptcyFiled==="yes" ? "selected" : ""}`} onClick={() => setBinary("bankruptcyFiled", "yes")}>Yes</button>
                <button className={`binary-button ${answers.bankruptcyFiled==="no" ? "selected" : ""}`} onClick={() => setBinary("bankruptcyFiled", "no")}>No</button>
              </div>
            </div>
          );
        case "bankruptcyDetails":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <BKIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">What Chapter and how many years ago did you file?</p>
              </div>
              <div className="vertical-stack-intake">
                <select 
                  name="bankruptcyChapter" 
                  value={answers.bankruptcyChapter} 
                  onChange={handleChange}
                >
                  <option value="">Select Chapter...</option>
                  <option value="7">Chapter 7</option>
                  <option value="13">Chapter 13</option>
                </select>

                <select 
                  name="bankruptcyYearsAgo" 
                  value={answers.bankruptcyYearsAgo} 
                  onChange={handleChange}
                >
                  <option value="">Select Years Ago...</option>
                  {[...Array(9)].map((_, i) => (
                    <option key={i} value={i}>
                      {i === 0 ? "This year" : `${i} year${i > 1 ? "s" : ""} ago`}
                    </option>
                  ))}
                  <option value="9">9+ years ago</option>
                </select>
              </div>
            </div>
          );
        case "maritalStatus":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <MaritalIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">What is your marital status?</p>
              </div>
              <div className="vertical-stack-intake">
              <select name="maritalStatus" value={answers.maritalStatus} onChange={handleChange}>
                <option value="">Select...</option>
                <option value="single">Single</option>
                <option value="married">Married</option>
                <option value="separated">Separated</option>
                <option value="divorced">Divorced</option>
                <option value="widowed">Widowed</option>
              </select></div>
            </div>
          );
        case "yearsMarried":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <MaritalIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">How long have you been married?</p>
              </div><div className="vertical-stack-intake">
              <input inputmode="numeric" type="text" name="yearsMarried" placeholder="Years married" value={answers.yearsMarried} onChange={handleChange} />
            </div></div>
          );
        case "spouseFiling":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <SpouseIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">Is your spouse filing with you?</p>
              </div>
              <div className="binary-options">
                <button className={`binary-button ${answers.spouseFiling==="yes" ? "selected" : ""}`} onClick={() => setBinary("spouseFiling", "yes")}>Yes</button>
                <button className={`binary-button ${answers.spouseFiling==="no" ? "selected" : ""}`} onClick={() => setBinary("spouseFiling", "no")}>No</button>
              </div>
            </div>
          );
        case "spouseName":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <SpouseIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">What is your spouse's name?</p>
              </div>
              <div className="name-fields">
                <input type="text" name="spouseFirstName" placeholder="First Name" value={answers.spouseFirstName} onChange={handleChange} />
                <input type="text" name="spouseMiddleName" placeholder="Middle Name" value={answers.spouseMiddleName} onChange={handleChange} />
                <input type="text" name="spouseLastName" placeholder="Last Name" value={answers.spouseLastName} onChange={handleChange} />
              </div>
            </div>
          );
        case "spouseBirthday":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <SpouseIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">What is your spouse's birthday?</p>
              </div>
              <input type="date" name="spouseDOB" value={answers.spouseDOB} onChange={handleChange} className="date-input" />
            </div>
          );
        case "spouseBankruptcyHistory":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <SpouseIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">Has your spouse filed bankruptcy in the last 8 years?</p>
              </div>
              <div className="binary-options">
                <button className={`binary-button ${answers.spouseBankruptcyFiled==="yes" ? "selected" : ""}`} onClick={() => setBinary("spouseBankruptcyFiled", "yes")}>Yes</button>
                <button className={`binary-button ${answers.spouseBankruptcyFiled==="no" ? "selected" : ""}`} onClick={() => setBinary("spouseBankruptcyFiled", "no")}>No</button>
              </div>
            </div>
          );
        case "spouseBankruptcyDetails":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <SpouseIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">What Chapter and how many years ago did your spouse file?</p>
              </div>
              <div className="vertical-stack-intake">
                <select name="spouseBankruptcyChapter" value={answers.spouseBankruptcyChapter} onChange={handleChange}>
                  <option value="">Select Chapter...</option>
                  <option value="7">Chapter 7</option>
                  <option value="13">Chapter 13</option>
                </select>
                <select 
                  name="spouseBankruptcyYearsAgo" 
                  value={answers.spouseBankruptcyYearsAgo} 
                  onChange={handleChange}
                >
                  <option value="">Select Years Ago...</option>
                  {[...Array(9)].map((_, i) => (
                    <option key={i} value={i}>
                      {i === 0 ? "This year" : `${i} year${i > 1 ? "s" : ""} ago`}
                    </option>
                  ))}
                  <option value="9">9+ years ago</option>
                </select>
              </div>
            </div>
          );
        case "statusDuration":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <MaritalIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">
                  {answers.maritalStatus === "separated"
                    ? "How long have you been separated?"
                    : answers.maritalStatus === "divorced"
                    ? "How long have you been divorced?"
                    : "How long have you been widowed?"}
                </p>
              </div>
              <input type="text" name="statusDuration" placeholder="Duration" value={answers.statusDuration} onChange={handleChange} />
            </div>
          );
        case "dependents":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <DependIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">How many dependents live with you?</p>
              </div>
              <div className = "vertical-stack-intake">
              <select name="dependents" value={answers.dependents} onChange={handleChange}>
                <option value="">Select...</option>
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
              </select>
              </div>
            </div>
          );
        case "address":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <AddressIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">What is your Zip Code</p>
              </div><div className="vertical-stack-intake">
              <div className="realestate-grid-real">

                    <input
                    type="text"
                    inputmode="numeric"
                    name="zip"
                    placeholder="Zip"
                    value={answers.zip} onChange={handleChange}
                    /></div>
                            </div>
                            <p className="text-xs text-gray-500">
                Your zip code will determine the appropriate cost of living expenses and admin costs when determining your plan payment
              </p>
            </div>
            
          );
        case "contact":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <ContactIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">
                  {answers.maritalStatus === "married" && answers.spouseFiling==="yes"
                    ? "Enter your and your spouse's contact info (phone and email):"
                    : "Enter your contact info (phone and email):"}
                </p>
              </div>
              <div className="vertical-stack-intake">
                <input inputmode="numeric" type="text" name="phone" placeholder="Your Phone Number" value={answers.phone} onChange={handleChange} />
                <input type="email" name="email" placeholder="Your Email" value={answers.email} onChange={handleChange} />
                {answers.maritalStatus==="married" && answers.spouseFiling==="yes" && (
                  <>
                    <input inputmode="numeric" type="text" name="spousePhone" placeholder="Spouse Phone Number" value={answers.spousePhone} onChange={handleChange} />
                    <input type="email" name="spouseEmail" placeholder="Spouse Email" value={answers.spouseEmail} onChange={handleChange} />
                  </>
                )}
              </div>
            </div>
          );
        // ----- Part 2: Respondent Employment & Income -----
        case "employmentStatus":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <EmployedIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">Are you employed?</p>
              </div>
              <div className="binary-options">
                <button className={`binary-button ${answers.employmentStatus==="yes"?"selected":""}`} onClick={() => setBinary("employmentStatus", "yes")}>Yes</button>
                <button className={`binary-button ${answers.employmentStatus==="no"?"selected":""}`} onClick={() => setBinary("employmentStatus", "no")}>No</button>
              </div>
            </div>
          );
        case "jobInfo":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <EmployedIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">Where do you work, what is your job title, and how long have you been working there?</p>
              </div><div className="vertical-stack-intake">
              <input type="text" name="workPlace" placeholder="Workplace" value={answers.workPlace} onChange={handleChange} />
              <input type="text" name="jobTitle" placeholder="Job Title" value={answers.jobTitle} onChange={handleChange} />
              <div className="dropdown-jobs">
                <select name="jobDuration" value={answers.jobDuration} onChange={handleChange}>
                  <option value="">Select duration...</option>
                  <option value="<1 yr">Less than 1 yr</option>
                  <option value="1 yr">1 yr</option>
                  <option value="2 yrs">2 yrs</option>
                  <option value="3+ yrs">3+ yrs</option>
                </select>
              </div>
              {answers.jobDuration === "<1 yr" && (
                <>
                  <p>About when did you start?</p>
                  <input type="date" name="startDate" placeholder="Start Date" value={answers.startDate} onChange={handleChange} className="date-input" />
                </>
              )}
            </div></div>
          );
        case "payType":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <PaidIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">How are you paid?</p>
              </div>
              <div className="binary-options">
                <button className={`binary-button ${answers.payType==="hourly"?"selected":""}`} onClick={() => setBinary("payType", "hourly")}>Hourly</button>
                <button className={`binary-button ${answers.payType==="salary"?"selected":""}`} onClick={() => setBinary("payType", "salary")}>Salary</button>
                <button className={`binary-button ${answers.payType==="self-employed"?"selected":""}`} onClick={() => setBinary("payType", "self-employed")}>Self-Employed/1099</button>
              </div>
            </div>
          );
        case "hourlyDetails":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <PaidIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">What is your hourly rate and how many hours do you work per week? (Include overtime)</p>
              </div><div className="vertical-stack-intake"><div>$
              <input type="text" inputmode="numeric" name="hourlyRate" placeholder="Hourly Rate" value={answers.hourlyRate} onChange={handleChange} /></div>
              <input type="text" inputmode="numeric" name="hoursWorked" placeholder="Hours Worked" value={answers.hoursWorked} onChange={handleChange} />
            </div></div>
          );
        case "salaryDetails":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <PaidIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">What is your yearly salary? (Include bonuses)</p>
              </div>
              <div className="vertical-stack-intake">
                <div>$
              <input type="text" inputmode="numeric" name="yearlySalary" placeholder="Yearly Salary" value={answers.yearlySalary} onChange={handleChange} />
            </div></div></div>
          );
        case "netProfit":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <PaidIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">What is your average monthly net profit (revenue - expenses)?</p>
              </div><div className="vertical-stack-intake">
              <input type="text" inputmode="numeric" name="netProfit" placeholder="Net Profit" value={answers.netProfit} onChange={handleChange} />
            </div></div>
          );
        case "deductions":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <CalcIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">Do you have any of these paycheck deductions? (optional):</p>
              </div>
              <div className="binary-options">
                {["insurance", "401k", "401k loan"].map(deduction => (
                  <button
                    key={deduction}
                    className={`binary-button ${answers.deductions.includes(deduction) ? "selected" : ""}`}
                    onClick={() => toggleArrayValue("deductions", deduction)}
                  >
                    {deduction}
                  </button>
                ))}
              </div>
            </div>
          );
        case "secondJob":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <EmployedIcon/>
              </div>
              <div className="question-text-container">
                <p className="question-text">Do you have a second job or side-hustle?</p>
              </div>
              <div className="binary-options">
                <button className={`binary-button ${answers.secondJob==="yes"?"selected":""}`} onClick={() => setBinary("secondJob", "yes")}>Yes</button>
                <button className={`binary-button ${answers.secondJob==="no"?"selected":""}`} onClick={() => setBinary("secondJob", "no")}>No</button>
              </div>
            </div>
          );
        case "secondJobInfo":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <EmployedIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">For your second job: Where do you work and what is your job title?</p>
              </div><div className="vertical-stack-intake">
              <input type="text" name="secondWorkPlace" placeholder="Workplace" value={answers.secondWorkPlace} onChange={handleChange} />
              <input type="text" name="secondJobTitle" placeholder="Job Title" value={answers.secondJobTitle} onChange={handleChange} />
              <div className="dropdown-jobs">
                <select name="secondJobDuration" value={answers.secondJobDuration} onChange={handleChange}>
                  <option value="">Select duration...</option>
                  <option value="<1 yr">Less than 1 yr</option>
                  <option value="1 yr">1 yr</option>
                  <option value="2 yrs">2 yrs</option>
                  <option value="3+ yrs">3+ yrs</option>
                </select>
              </div>
              {answers.secondJobDuration === "<1 yr" && (
                <>
                  <p>About when did you start?</p>
                  <input type="date" name="secondStartDate" placeholder="Start Date" value={answers.secondStartDate} onChange={handleChange} className="date-input" />
                </>
              )}
            </div></div>
          );
        case "secondPayType":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <PaidIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">For your second job, how are you paid?</p>
              </div>
              <div className="binary-options">
                <button className={`binary-button ${answers.secondPayType==="hourly"?"selected":""}`} onClick={() => setBinary("secondPayType", "hourly")}>Hourly</button>
                <button className={`binary-button ${answers.secondPayType==="salary"?"selected":""}`} onClick={() => setBinary("secondPayType", "salary")}>Salary</button>
                <button className={`binary-button ${answers.secondPayType==="self-employed"?"selected":""}`} onClick={() => setBinary("secondPayType", "self-employed")}>Self-Employed/1099</button>
              </div>
            </div>
          );
        case "secondHourlyDetails":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <PaidIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">What is your second job's hourly rate and how many hours do you work per week? (Include overtime)</p>
              </div><div className="vertical-stack-intake"><div>$
              <input type="text" inputmode="numeric" name="secondHourlyRate" placeholder="Hourly Rate" value={answers.secondHourlyRate} onChange={handleChange} /></div>
              <input type="text" inputmode="numeric" name="secondHoursWorked" placeholder="Hours Worked" value={answers.secondHoursWorked} onChange={handleChange} />
            </div></div>
          );
        case "secondSalaryDetails":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <PaidIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">What is your second job's yearly salary? (Include bonuses)</p>
              </div><div className="vertical-stack-intake"><div>$
              <input type="text" inputmode="numeric" name="secondYearlySalary" placeholder="Yearly Salary" value={answers.secondYearlySalary} onChange={handleChange} />
            </div></div></div>
          );
        case "secondNetProfit":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <PaidIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">What is your second job's average monthly net profit (revenue - expenses)?</p>
              </div><div className="vertical-stack-intake"><div>$
              <input type="text" inputmode="numeric" name="secondNetProfit" placeholder="Net Profit" value={answers.secondNetProfit} onChange={handleChange} />
            </div></div></div>
          );
        case "priorEmployment":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <EmployedIcon/>
              </div>
              <div className="question-text-container">
                <p className="question-text">Have you had any prior employment in the last 6 months?</p>
              </div>
              <div className="binary-options">
                <button className={`binary-button ${answers.priorEmployment==="yes"?"selected":""}`} onClick={() => setBinary("priorEmployment", "yes")}>Yes</button>
                <button className={`binary-button ${answers.priorEmployment==="no"?"selected":""}`} onClick={() => setBinary("priorEmployment", "no")}>No</button>
              </div>
            </div>
          );
          case "priorJobInfo":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <EmployedIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">
                    For your prior employment: Where did you work, what was your job title, and how long did you work there?
                  </p>
                </div><div className="vertical-stack-intake">
                <input type="text" name="priorWorkPlace" placeholder="Workplace" value={answers.priorWorkPlace} onChange={handleChange} />
                <input type="text" name="priorJobTitle" placeholder="Job Title" value={answers.priorJobTitle} onChange={handleChange} />
                <div className="dropdown-jobs">
                  <select name="priorJobDuration" value={answers.priorJobDuration} onChange={handleChange}>
                    <option value="">Select duration...</option>
                    <option value="<1 yr">Less than 1 yr</option>
                    <option value="1 yr">1 yr</option>
                    <option value="2 yrs">2 yrs</option>
                    <option value="3+ yrs">3+ yrs</option>
                  </select>
                </div>
                {answers.priorJobDuration === "<1 yr" && (
                  <>
                    <p>About when did you start?</p>
                    <input type="date" name="priorStartDate" placeholder="Start Date" value={answers.priorStartDate} onChange={handleChange} className="date-input" />
                  </>
                )}
              </div></div>
            );
        case "priorLeavingDate":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <CalendarIcon/>
              </div>
              <div className="question-text-container">
                <p className="question-text">When did you leave your prior employment?</p>
              </div>
              <input type="date" name="priorLeavingDate" value={answers.priorLeavingDate} onChange={handleChange} className="date-input" />
            </div>
          );
        // Fixed income for respondent: first ask if they have any.
        case "hasFixedIncome":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <MoneyIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">Do you have any fixed income sources? (examples: government benefits, child support)</p>
              </div>
              <div className="binary-options">
                <button 
                  type="button"
                  className={`binary-button ${answers.hasFixedIncome === "yes" ? "selected" : ""}`} 
                  onClick={() => handleChange({ target: { name: "hasFixedIncome", value: "yes" } })}
                >
                  Yes
                </button>
                <button 
                  type="button"
                  className={`binary-button ${answers.hasFixedIncome === "no" ? "selected" : ""}`} 
                  onClick={() => handleChange({ target: { name: "hasFixedIncome", value: "no" } })}
                >
                  No
                </button>
              </div>
            </div>
          );
        case "fixedIncome":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <MoneyIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">Select your fixed income sources:</p>
              </div>
              <div className="grid-options">
                {["Social Security", "Veterans Benefits", "Private Pension", "Alimony", "Child Support", "Other", "None"].map(source => (
                    <button key={source} className={`binary-button ${answers.fixedIncomeSources.includes(source) ? "selected" : ""}`}
                    onClick={() => {
                        let sources = [...answers.fixedIncomeSources];
                        if (source === "None") {
                        sources = ["None"];
                        } else if (sources.includes("None")) {
                        sources = sources.filter(item => item !== "None");
                        if (!sources.includes(source)) sources.push(source);
                        } else {
                        if (sources.includes(source)) {
                            sources = sources.filter(item => item !== source);
                        } else {
                            sources.push(source);
                        }
                        }
                        setAnswers({ ...answers, fixedIncomeSources: sources });
                    }}>
                    {source}
                    </button>
                ))}
                </div>
            </div>
          );
        // For each fixed income source selected (other than "None"), create a dedicated detail step.
        // (These are detected by keys starting with "fixedIncomeDetails_")
        // Spouse fixed income detail steps are handled below.
        // ----- Spouse Employment & Income (Part 2) -----
        case "spouseEmploymentStatus":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <EmployedIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">Is your spouse employed?</p>
              </div>
              <div className="binary-options">
                <button className={`binary-button ${answers.spouseEmploymentStatus==="yes"?"selected":""}`} onClick={() => setBinary("spouseEmploymentStatus", "yes")}>Yes</button>
                <button className={`binary-button ${answers.spouseEmploymentStatus==="no"?"selected":""}`} onClick={() => setBinary("spouseEmploymentStatus", "no")}>No</button>
              </div>
            </div>
          );
        case "spouseJobInfo":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <EmployedIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">For your spouse: Where do they work and what is their job title?</p>
              </div><div className="vertical-stack-intake">
              <input type="text" name="spouseWorkPlace" placeholder="Workplace" value={answers.spouseWorkPlace} onChange={handleChange} />
              <input type="text" name="spouseJobTitle" placeholder="Job Title" value={answers.spouseJobTitle} onChange={handleChange} />
              <div className="dropdown-jobs">
                <select name="spouseJobDuration" value={answers.spouseJobDuration} onChange={handleChange}>
                  <option value="">Select duration...</option>
                  <option value="<1 yr">Less than 1 yr</option>
                  <option value="1 yr">1 yr</option>
                  <option value="2 yrs">2 yrs</option>
                  <option value="3+ yrs">3+ yrs</option>
                </select>
              </div>
              {answers.spouseJobDuration === "<1 yr" && (
                <>
                  <p>About when did your spouse start?</p>
                  <input type="date" name="spouseStartDate" placeholder="Start Date" value={answers.spouseStartDate} onChange={handleChange} className="date-input" />
                </>
              )}
            </div></div>
          );
        case "spousePayType":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <PaidIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">How is your spouse paid?</p>
              </div>
              <div className="binary-options">
                <button className={`binary-button ${answers.spousePayType==="hourly"?"selected":""}`} onClick={() => setBinary("spousePayType", "hourly")}>Hourly</button>
                <button className={`binary-button ${answers.spousePayType==="salary"?"selected":""}`} onClick={() => setBinary("spousePayType", "salary")}>salary</button>
                <button className={`binary-button ${answers.spousePayType==="self-employed"?"selected":""}`} onClick={() => setBinary("spousePayType", "self-employed")}>Self-Employed/1099</button>
              </div>
            </div>
          );
        case "spouseHourlyDetails":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <PaidIcon/>
              </div>
              <div className="question-text-container">
                <p className="question-text">What is your spouse's hourly rate and how many hours do they work per week? (Include overtime)</p>
              </div><div className="vertical-stack-intake"><div>$
              <input type="text" inputmode="numeric" name="spouseHourlyRate" placeholder="Hourly Rate" value={answers.spouseHourlyRate} onChange={handleChange} /></div>
              <input type="text" inputmode="numeric" name="spouseHoursWorked" placeholder="Hours Worked" value={answers.spouseHoursWorked} onChange={handleChange} />
            </div></div>
          );
        case "spouseSalaryDetails":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <PaidIcon/>
              </div>
              <div className="question-text-container">
                <p className="question-text">What is your spouse's yearly salary? (Include bonuses)</p>
              </div><div className="vertical-stack-intake"><div>$
              <input type="text" inputmode="numeric" name="spouseYearlySalary" placeholder="Yearly Salary" value={answers.spouseYearlySalary} onChange={handleChange} />
            </div></div></div>
          );
        case "spouseNetProfit":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <PaidIcon/>
              </div>
              <div className="question-text-container">
                <p className="question-text">What is your spouse's average monthly net profit (revenue - expenses)?</p>
              </div><div className="vertical-stack-intake"><div>$
              <input type="text" inputmode="numeric" name="spouseNetProfit" placeholder="Net Profit" value={answers.spouseNetProfit} onChange={handleChange} />
            </div></div></div>
          );
        case "spouseDeductions":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <CalcIcon/>
              </div>
              <div className="question-text-container">
                <p className="question-text">Does your spouse have any of these paycheck deductions? (optional):</p>
              </div>
              <div className="binary-options">
                {["insurance", "401k", "401k loan"].map(deduction => (
                  <button
                    key={deduction}
                    className={`binary-button ${answers.spouseDeductions.includes(deduction) ? "selected" : ""}`}
                    onClick={() => toggleArrayValue("spouseDeductions", deduction)}
                  >
                    {deduction}
                  </button>
                ))}
              </div>
            </div>
          );
        case "spouseSecondJob":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <EmployedIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">Does your spouse have a second job or side-hustle?</p>
              </div>
              <div className="binary-options">
                <button className={`binary-button ${answers.spouseSecondJob==="yes"?"selected":""}`} onClick={() => setBinary("spouseSecondJob", "yes")}>Yes</button>
                <button className={`binary-button ${answers.spouseSecondJob==="no"?"selected":""}`} onClick={() => setBinary("spouseSecondJob", "no")}>No</button>
              </div>
            </div>
          );
        case "spouseSecondJobInfo":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <EmployedIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">For your spouse's second job: Where do they work and what is their job title?</p>
              </div><div className="vertical-stack-intake">
              <input type="text" name="spouseSecondWorkPlace" placeholder="Workplace" value={answers.spouseSecondWorkPlace} onChange={handleChange} />
              <input type="text" name="spouseSecondJobTitle" placeholder="Job Title" value={answers.spouseSecondJobTitle} onChange={handleChange} />
              <div className="dropdown-jobs">
                <select name="spouseSecondJobDuration" value={answers.spouseSecondJobDuration} onChange={handleChange}>
                  <option value="">Select duration...</option>
                  <option value="<1 yr">Less than 1 yr</option>
                  <option value="1 yr">1 yr</option>
                  <option value="2 yrs">2 yrs</option>
                  <option value="3+ yrs">3+ yrs</option>
                </select>
              </div>
              {answers.spouseSecondJobDuration === "<1 yr" && (
                <>
                  <p>About when did your spouse start?</p>
                  <input type="date" name="spouseSecondStartDate" placeholder="Start Date" value={answers.spouseSecondStartDate} onChange={handleChange} className="date-input" />
                </>
              )}
            </div></div>
          );
        case "spouseSecondPayType":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <PaidIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">For your spouse's second job, how are they paid?</p>
              </div>
              <div className="binary-options">
                <button className={`binary-button ${answers.spouseSecondPayType==="hourly"?"selected":""}`} onClick={() => setBinary("spouseSecondPayType", "hourly")}>Hourly</button>
                <button className={`binary-button ${answers.spouseSecondPayType==="salary"?"selected":""}`} onClick={() => setBinary("spouseSecondPayType", "salary")}>Salary</button>
                <button className={`binary-button ${answers.spouseSecondPayType==="self-employed"?"selected":""}`} onClick={() => setBinary("spouseSecondPayType", "self-employed")}>Self-Employed/1099</button>
              </div>
            </div>
          );
        case "spouseSecondHourlyDetails":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <PaidIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">What is your spouse's second job hourly rate and how many hours do they work per week? (Include overtime)</p>
              </div><div className="vertical-stack-intake"><div>$
              <input type="text" inputmode="numeric" name="spouseSecondHourlyRate" placeholder="Hourly Rate" value={answers.spouseSecondHourlyRate} onChange={handleChange} /></div>
              <input type="text" inputmode="numeric" name="spouseSecondHoursWorked" placeholder="Hours Worked" value={answers.spouseSecondHoursWorked} onChange={handleChange} />
            </div></div>
          );
        case "spouseSecondSalaryDetails":
          return (
            <div className="main-content">
              <div className="icon-container-intake">
                <PaidIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">What is your spouse's second job yearly salary? (Include bonuses)</p>
              </div><div className="vertical-stack-intake"><div>$
              <input type="text" inputmode="numeric" name="spouseSecondYearlySalary" placeholder="Yearly Salary" value={answers.spouseSecondYearlySalary} onChange={handleChange} />
            </div></div></div>
          );
        case "spouseSecondNetProfit":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <PaidIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">What is your spouse's second job average monthly net profit (revenue - expenses)?</p>
              </div><div className="vertical-stack-intake"><div>$
              <input type="text" inputmode="numeric" name="spouseSecondNetProfit" placeholder="Net Profit" value={answers.spouseSecondNetProfit} onChange={handleChange} />
            </div></div></div>
          );
          case "spousePriorEmployment":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <EmployedIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">Has your spouse had any prior employment in the last 6 months?</p>
                </div>
                <div className="binary-options">
                  <button className={`binary-button ${answers.spousePriorEmployment==="yes"?"selected":""}`} onClick={() => setBinary("spousePriorEmployment", "yes")}>
                    Yes
                  </button>
                  <button className={`binary-button ${answers.spousePriorEmployment==="no"?"selected":""}`} onClick={() => setBinary("spousePriorEmployment", "no")}>
                    No
                  </button>
                </div>
              </div>
            );
          case "spousePriorJobInfo":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <EmployedIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">For your spouse's prior employment: Where did they work, what was their job title, and how long did they work there?</p>
                </div><div className="vertical-stack-intake">
                <input type="text" name="spousePriorWorkPlace" placeholder="Workplace" value={answers.spousePriorWorkPlace} onChange={handleChange} />
                <input type="text" name="spousePriorJobTitle" placeholder="Job Title" value={answers.spousePriorJobTitle} onChange={handleChange} />
                <div className="dropdown-jobs">
                  <select name="spousePriorJobDuration" value={answers.spousePriorJobDuration} onChange={handleChange}>
                    <option value="">Select duration...</option>
                    <option value="<1 yr">Less than 1 yr</option>
                    <option value="1 yr">1 yr</option>
                    <option value="2 yrs">2 yrs</option>
                    <option value="3+ yrs">3+ yrs</option>
                  </select>
                </div>
                {answers.spousePriorJobDuration === "<1 yr" && (
                  <>
                    <p>About when did your spouse start their prior job?</p>
                    <input type="date" name="spousePriorStartDate" placeholder="Start Date" value={answers.spousePriorStartDate} onChange={handleChange} className="date-input" />
                  </>
                )}
              </div></div>
            );
          case "spousePriorLeavingDate":
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <CalendarIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">When did your spouse leave their prior employment?</p>
                </div>
                <input type="date" name="spousePriorLeavingDate" value={answers.spousePriorLeavingDate} onChange={handleChange} className="date-input" />
              </div>
            );
        // Spouse Fixed Income Section
        case "spouseHasFixedIncome":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <MoneyIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">Does your spouse have any fixed income sources? (Examples: government benefits, child support)</p>
              </div>
              <div className="binary-options">
                <button className={`binary-button ${answers.spouseHasFixedIncome==="yes"?"selected":""}`} onClick={() => setBinary("spouseHasFixedIncome", "yes")} onChange={handleChange}>Yes</button>
                <button className={`binary-button ${answers.spouseHasFixedIncome==="no"?"selected":""}`} onClick={() => setBinary("spouseHasFixedIncome", "no")} onChange={handleChange}>No</button>
              </div>
            </div>
          );
        case "spouseFixedIncome":
          return (
            <div className="main-content">
                <div className="icon-container-intake">
                <MoneyIcon />
              </div>
              <div className="question-text-container">
                <p className="question-text">Select your spouse's fixed income sources:</p>
              </div>
              <div className="grid-options">
                {["Social Security", "Veterans Benefits", "Private Pension", "Alimony", "Child Support", "Other", "None"].map(source => (
                    <button key={source} className={`binary-button ${answers.spouseFixedIncomeSources.includes(source) ? "selected" : ""}`}
                    onClick={() => {
                        let sources = [...answers.spouseFixedIncomeSources];
                        if (source === "None") {
                        sources = ["None"];
                        } else if (sources.includes("None")) {
                        sources = sources.filter(item => item !== "None");
                        if (!sources.includes(source)) sources.push(source);
                        } else {
                        if (sources.includes(source)) {
                            sources = sources.filter(item => item !== source);
                        } else {
                            sources.push(source);
                        }
                        }
                        setAnswers({ ...answers, spouseFixedIncomeSources: sources });
                    }}>
                    {source}
                    </button>
                ))}
                </div>
            </div>
          );
        // Spouse Fixed Income Details:
        default:
          if (currentStepKey.startsWith("spouseFixedIncomeDetails_")) {
            const source = currentStepKey.replace("spouseFixedIncomeDetails_", "");
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <MoneyIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">Enter your spouse's net monthly income for {source}:</p>
                </div>
                {source === "Other" ? (
                  <>
                    <input
                      type="text"
                      name="spouseFixedIncomeOtherDesc"
                      placeholder="Describe income source"
                      value={answers.spouseFixedIncomeOtherDesc || ""}
                      onChange={handleChange}
                    />
                    <input
                      type="text"
                      inputmode="numeric"
                      name="spouseFixedIncomeOtherAmount"
                      placeholder="Net Monthly Income"
                      value={answers.spouseFixedIncomeDetails["Other"] || ""}
                      onChange={(e) =>
                        setAnswers({
                          ...answers,
                          spouseFixedIncomeDetails: { ...answers.spouseFixedIncomeDetails, Other: e.target.value }
                        })
                      }
                    />
                  </>
                ) : (
                  <input
                    type="text"
                    inputmode="numeric"
                    name={`spouseFixedIncome_${source}`}
                    placeholder="Net Monthly Income"
                    value={answers.spouseFixedIncomeDetails[source] || ""}
                    onChange={(e) =>
                      setAnswers({
                        ...answers,
                        spouseFixedIncomeDetails: { ...answers.spouseFixedIncomeDetails, [source]: e.target.value }
                      })
                    }
                  />
                )}
              </div>
            );
          }
          // Respondent fixed income details:
          if (currentStepKey.startsWith("fixedIncomeDetails_")) {
            const source = currentStepKey.replace("fixedIncomeDetails_", "");
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <MoneyIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">Enter your net monthly income for {source}:</p>
                </div>
                {source === "Other" ? (
                  <div className="vertical-stack-intake">
                    <input
                      type="text"
                      name="fixedIncomeOtherDesc"
                      placeholder="Describe income source"
                      value={answers.fixedIncomeOtherDesc || ""}
                      onChange={handleChange}
                    /><div>$
                    <input
                      type="text"
                      inputmode="numeric"
                      name="fixedIncomeOtherAmount"
                      placeholder="Net Monthly Income"
                      value={answers.fixedIncomeDetails["Other"] || ""}
                      onChange={(e) =>
                        setAnswers({
                          ...answers,
                          fixedIncomeDetails: { ...answers.fixedIncomeDetails, Other: e.target.value }
                        })
                      }
                    /></div></div>
                ) : (<div className="vertical-stack-intake"><div>$
                  <input
                    type="text"
                    inputmode="numeric"
                    name={`fixedIncome_${source}`}
                    placeholder="Net Monthly Income"
                    value={answers.fixedIncomeDetails[source] || ""}
                    onChange={(e) =>
                      setAnswers({
                        ...answers,
                        fixedIncomeDetails: { ...answers.fixedIncomeDetails, [source]: e.target.value }
                      })
                    }
                  /></div></div>
                )}
              </div>
            );
          }
          if (currentStepKey === "spouseHasFixedIncome") {
            return (
              <div className="main-content">
                <div className="icon-container-intake">
                <MoneyIcon />
              </div>
                <div className="question-text-container">
                  <p className="question-text">Does your spouse have any fixed income sources? (examples: government benefits, child support)</p>
                </div>
                <div className="binary-options">
                  <button className={`binary-button ${answers.spouseHasFixedIncome==="yes"?"selected":""}`} onClick={() => setBinary("spouseHasFixedIncome", "yes")} onChange={handleChange}>Yes</button>
                  <button className={`binary-button ${answers.spouseHasFixedIncome==="no"?"selected":""}`} onClick={() => setBinary("spouseHasFixedIncome", "no")} onChange={handleChange}>No</button>
                </div>
              </div>
            );
          }
          return null;
      }
    };
  
    const renderNavButtons = () => {
      const part1Length = getPart1Steps(answers).length;
      const isPart1Final = currentStep === part1Length;
      const part2Length = getPart2Steps(answers).length;
      const part3Length = getPart3Steps(answers).length;
      const part4Length = getPart4Steps(answers).length;
      const part5Length = getPart5Steps(answers).length;
      const part6Length = getPart6Steps(answers).length;
      const part2Final = currentStep === (part1Length + part2Length);
      
      return (
        <div className="nav-buttons">
          <button className="action-button left" onClick={previousStep} disabled={currentStep === 1}>
            Back
          </button>
          {currentStep === totalSteps ? (
            <button className="action-button right" onClick={handleSubmit}>Submit</button>
          ) : (
        <button className="action-button right" onClick={nextStepValidated}>
        {currentStep === totalSteps
        ? "Submit"
        : currentStep === part1Length
        ? "Part 2"
        : currentStep === part1Length + part2Length
        ? "Part 3"
        : currentStep === part3Length +part1Length + part2Length
        ? "Part 4"
        : currentStep === part4Length + part3Length + part2Length + part1Length
        ? "Part 5"
        : currentStep === part5Length + part4Length + part3Length + part2Length + part1Length
        ? "Part 6"
        : "Next"}
        </button>
          )}
        </div>
      );
    };
  
    return (      <div ref={containerRef}>
      {/* ... the rest of your form/steps/modal markup ... */}
    
      <div className="step-questionnaire-container">
        <img
            src="/images/logo.png"
            alt="Cisowskilaw logo"
            className="h-12 w-auto mb-2"
          />
        <h1 className="text-2xl md:text-4xl font-extrabold uppercase bg-clip-text text-transparent bg-gradient-to-r from-slate-500 via-blue-500 to-slate-500 mb-2 text-center tracking-tight relative">
          Cisowski Law Chapter 13 Plan Calculator
        </h1>
        <div className="mx-auto w-24 h-1 bg-gradient-to-b from-blue-500 to-slate-500 rounded-full mb-6"></div>
        <div className="question-box">
          <div className="part-indicator">
            {`Part ${currentPart} of ${totalParts}`}
          </div>
          <div className="step-indicator">
            {`Step ${partStep} of ${partTotal}`}
          </div>
          <h2 className="sub-header">
            {currentStep <= part1Length
                ? "Part 1: Personal Information"
                : currentStep <= part1Length + part2Length
                ? "Part 2: Income Information"
                : currentStep <= part1Length + part2Length + part3Length
                ? "Part 3: Vehicle Information"
                : currentStep <= part1Length + part2Length + part3Length + part4Length
                ? "Part 4: Real Estate Information"
                : currentStep <= part1Length + part2Length + part3Length + part4Length + part5Length
                ? "Part 5: Unsecured Debt Information"
                : "Part 6: Expense Information"}
            </h2>
          <div key={currentStep} className="swoop-animation">
            {renderMainContent()}
            <LoadingModal
        isOpen={loading}
        onComplete={onLoaderComplete}
      />
            {recResult && (
              <Chapter13PlanModal
                isOpen={showRec}
                onClose={() => setShowRec(false)}
                recommendationResult={recResult}
                answers={answers}
                onAnswersChange={setAnswers}
                /* if you need fees or computedValues you can pass them here too */
              />
            )}
          </div>
          {renderNavButtons()}
        </div>
      </div></div>
    );
  }
  
  export default Chapter13PlanCalculator;